//-----Types.File-----
export interface ProblemDetails  {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}
export function deserializeProblemDetails(json: string): ProblemDetails {
  const data = JSON.parse(json) as ProblemDetails;
  initProblemDetails(data);
  return data;
}
export function initProblemDetails(_data: ProblemDetails) {
    return _data;
}
export function serializeProblemDetails(_data: ProblemDetails | undefined) {
  if (_data) {
    _data = prepareSerializeProblemDetails(_data as ProblemDetails);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeProblemDetails(_data: ProblemDetails): ProblemDetails {
  const data: Record<string, any> = { ..._data };
  return data as ProblemDetails;
}
export interface HttpValidationProblemDetails extends ProblemDetails  {
  errors?: { [key: string]: string[]; };
  [key: string]: any;
}
export function deserializeHttpValidationProblemDetails(json: string): HttpValidationProblemDetails {
  const data = JSON.parse(json) as HttpValidationProblemDetails;
  initHttpValidationProblemDetails(data);
  return data;
}
export function initHttpValidationProblemDetails(_data: HttpValidationProblemDetails) {
  initProblemDetails(_data);
    return _data;
}
export function serializeHttpValidationProblemDetails(_data: HttpValidationProblemDetails | undefined) {
  if (_data) {
    _data = prepareSerializeHttpValidationProblemDetails(_data as HttpValidationProblemDetails);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeHttpValidationProblemDetails(_data: HttpValidationProblemDetails): HttpValidationProblemDetails {
  const data = prepareSerializeProblemDetails(_data as HttpValidationProblemDetails) as Record<string, any>;
  return data as HttpValidationProblemDetails;
}
/** A ProblemDetails for validation errors. */
export interface ValidationProblemDetails extends HttpValidationProblemDetails  {
  /** Gets or sets the validation errors associated with this instance of ValidationProblemDetails. */
  errors?: { [key: string]: string[]; };
  [key: string]: any;
}
export function deserializeValidationProblemDetails(json: string): ValidationProblemDetails {
  const data = JSON.parse(json) as ValidationProblemDetails;
  initValidationProblemDetails(data);
  return data;
}
export function initValidationProblemDetails(_data: ValidationProblemDetails) {
  initHttpValidationProblemDetails(_data);
    return _data;
}
export function serializeValidationProblemDetails(_data: ValidationProblemDetails | undefined) {
  if (_data) {
    _data = prepareSerializeValidationProblemDetails(_data as ValidationProblemDetails);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeValidationProblemDetails(_data: ValidationProblemDetails): ValidationProblemDetails {
  const data = prepareSerializeHttpValidationProblemDetails(_data as ValidationProblemDetails) as Record<string, any>;
  return data as ValidationProblemDetails;
}
export interface HL7SettingsDto  {
  onlyProcessMessagesForExistingPatients: boolean;
  subtenantId: number;
  ackProcessing: HL7AckProcessing;
  encoding: string;
  appName: string;
  facility: string;
}
export function deserializeHL7SettingsDto(json: string): HL7SettingsDto {
  const data = JSON.parse(json) as HL7SettingsDto;
  initHL7SettingsDto(data);
  return data;
}
export function initHL7SettingsDto(_data: HL7SettingsDto) {
  if (_data) {
    _data.ackProcessing = _data["ackProcessing"];
  }
  return _data;
}
export function serializeHL7SettingsDto(_data: HL7SettingsDto | undefined) {
  if (_data) {
    _data = prepareSerializeHL7SettingsDto(_data as HL7SettingsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeHL7SettingsDto(_data: HL7SettingsDto): HL7SettingsDto {
  const data: Record<string, any> = { ..._data };
  return data as HL7SettingsDto;
}
/** 0 = Automatic 1 = Always 2 = Never 3 = ErrorOnly 4 = SuccessOnly */
export enum HL7AckProcessing {
    Automatic = 0,
    Always = 1,
    Never = 2,
    ErrorOnly = 3,
    SuccessOnly = 4,
}
export interface HL7SettingsPatchDto  {
  onlyProcessMessagesForExistingPatients?: boolean;
  subtenantId?: number;
  ackProcessing?: HL7AckProcessing;
  encoding?: string;
  appName?: string;
  facility?: string;
}
export function deserializeHL7SettingsPatchDto(json: string): HL7SettingsPatchDto {
  const data = JSON.parse(json) as HL7SettingsPatchDto;
  initHL7SettingsPatchDto(data);
  return data;
}
export function initHL7SettingsPatchDto(_data: HL7SettingsPatchDto) {
  if (_data) {
    _data.ackProcessing = _data["ackProcessing"];
  }
  return _data;
}
export function serializeHL7SettingsPatchDto(_data: HL7SettingsPatchDto | undefined) {
  if (_data) {
    _data = prepareSerializeHL7SettingsPatchDto(_data as HL7SettingsPatchDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeHL7SettingsPatchDto(_data: HL7SettingsPatchDto): HL7SettingsPatchDto {
  const data: Record<string, any> = { ..._data };
  return data as HL7SettingsPatchDto;
}
export interface TemplateListDto  {
  id: number;
  title: string;
  isDefault: boolean;
  isActive: boolean;
  type: DocumentTemplateType;
  dataBlockTypeId: number | null;
}
export function deserializeTemplateListDto(json: string): TemplateListDto {
  const data = JSON.parse(json) as TemplateListDto;
  initTemplateListDto(data);
  return data;
}
export function initTemplateListDto(_data: TemplateListDto) {
  if (_data) {
    _data.type = _data["type"];
  }
  return _data;
}
export function serializeTemplateListDto(_data: TemplateListDto | undefined) {
  if (_data) {
    _data = prepareSerializeTemplateListDto(_data as TemplateListDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeTemplateListDto(_data: TemplateListDto): TemplateListDto {
  const data: Record<string, any> = { ..._data };
  return data as TemplateListDto;
}
/** 0 = Document 1 = HL7OutgoingMessage 2 = GDTOutgoingMessage 3 = DocumentHeader 4 = DocumentFooter */
export enum DocumentTemplateType {
    Document = 0,
    HL7OutgoingMessage = 1,
    GDTOutgoingMessage = 2,
    DocumentHeader = 3,
    DocumentFooter = 4,
}
export interface TemplateDto  {
  id: number;
  title: string;
  content: string;
  isDefault: boolean;
  isActive: boolean;
  type: DocumentTemplateType;
  dataBlockTypeId: number | null;
}
export function deserializeTemplateDto(json: string): TemplateDto {
  const data = JSON.parse(json) as TemplateDto;
  initTemplateDto(data);
  return data;
}
export function initTemplateDto(_data: TemplateDto) {
  if (_data) {
    _data.type = _data["type"];
  }
  return _data;
}
export function serializeTemplateDto(_data: TemplateDto | undefined) {
  if (_data) {
    _data = prepareSerializeTemplateDto(_data as TemplateDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeTemplateDto(_data: TemplateDto): TemplateDto {
  const data: Record<string, any> = { ..._data };
  return data as TemplateDto;
}
export interface PatchTemplateDto  {
  title?: string | null;
  documentContent?: string | null;
  isActive?: boolean | null;
}
export function deserializePatchTemplateDto(json: string): PatchTemplateDto {
  const data = JSON.parse(json) as PatchTemplateDto;
  initPatchTemplateDto(data);
  return data;
}
export function initPatchTemplateDto(_data: PatchTemplateDto) {
    return _data;
}
export function serializePatchTemplateDto(_data: PatchTemplateDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchTemplateDto(_data as PatchTemplateDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchTemplateDto(_data: PatchTemplateDto): PatchTemplateDto {
  const data: Record<string, any> = { ..._data };
  return data as PatchTemplateDto;
}
export interface CreateTemplateDto  {
  title: string;
  content: string;
  type: DocumentTemplateType;
}
export function deserializeCreateTemplateDto(json: string): CreateTemplateDto {
  const data = JSON.parse(json) as CreateTemplateDto;
  initCreateTemplateDto(data);
  return data;
}
export function initCreateTemplateDto(_data: CreateTemplateDto) {
  if (_data) {
    _data.type = _data["type"];
  }
  return _data;
}
export function serializeCreateTemplateDto(_data: CreateTemplateDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateTemplateDto(_data as CreateTemplateDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateTemplateDto(_data: CreateTemplateDto): CreateTemplateDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateTemplateDto;
}
export interface HL7TemplateRuleDto  {
  id: number;
  subtenantId: number;
  messageGroup: HL7MessageGroup;
  dataBlockTypeId: number | null;
  hL7DocumentType: HL7DocumentType | null;
  hL7QueryType: HL7QueryType | null;
  documentTemplateId: number;
  isAutoSending: boolean;
  serverAddress: string | null;
  serverPort: number | null;
  isActive: boolean;
  isDeleted: boolean;
  isDefault: boolean;
}
export function deserializeHL7TemplateRuleDto(json: string): HL7TemplateRuleDto {
  const data = JSON.parse(json) as HL7TemplateRuleDto;
  initHL7TemplateRuleDto(data);
  return data;
}
export function initHL7TemplateRuleDto(_data: HL7TemplateRuleDto) {
  if (_data) {
    _data.messageGroup = _data["messageGroup"];
    _data.hL7DocumentType = _data["hL7DocumentType"];
    _data.hL7QueryType = _data["hL7QueryType"];
  }
  return _data;
}
export function serializeHL7TemplateRuleDto(_data: HL7TemplateRuleDto | undefined) {
  if (_data) {
    _data = prepareSerializeHL7TemplateRuleDto(_data as HL7TemplateRuleDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeHL7TemplateRuleDto(_data: HL7TemplateRuleDto): HL7TemplateRuleDto {
  const data: Record<string, any> = { ..._data };
  return data as HL7TemplateRuleDto;
}
/** 1 = DataBlock 2 = Document 3 = Query */
export enum HL7MessageGroup {
    DataBlock = 1,
    Document = 2,
    Query = 3,
}
/** 1 = MDM_T01 2 = MDM_T02 3 = MDM_T09 4 = MDM_T10 5 = MDM_T11 */
export enum HL7DocumentType {
    MDM_T01 = 1,
    MDM_T02 = 2,
    MDM_T09 = 3,
    MDM_T10 = 4,
    MDM_T11 = 5,
}
/** 1 = PatientInformationQuery */
export enum HL7QueryType {
    PatientInformationQuery = 1,
}
export interface PatchHL7TemplateRuleDto  {
  messageGroup?: HL7MessageGroup | null;
  dataBlockTypeId?: number | null;
  hL7DocumentType?: HL7DocumentType | null;
  hL7QueryType?: HL7QueryType | null;
  documentTemplateId?: number | null;
  isAutoSending?: boolean | null;
  serverAddress?: string | null;
  serverPort?: number | null;
  isActive?: boolean | null;
}
export function deserializePatchHL7TemplateRuleDto(json: string): PatchHL7TemplateRuleDto {
  const data = JSON.parse(json) as PatchHL7TemplateRuleDto;
  initPatchHL7TemplateRuleDto(data);
  return data;
}
export function initPatchHL7TemplateRuleDto(_data: PatchHL7TemplateRuleDto) {
  if (_data) {
    _data.messageGroup = _data["messageGroup"];
    _data.hL7DocumentType = _data["hL7DocumentType"];
    _data.hL7QueryType = _data["hL7QueryType"];
  }
  return _data;
}
export function serializePatchHL7TemplateRuleDto(_data: PatchHL7TemplateRuleDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchHL7TemplateRuleDto(_data as PatchHL7TemplateRuleDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchHL7TemplateRuleDto(_data: PatchHL7TemplateRuleDto): PatchHL7TemplateRuleDto {
  const data: Record<string, any> = { ..._data };
  return data as PatchHL7TemplateRuleDto;
}
export interface CreateHL7TemplateRuleDto  {
  subtenantId: number;
  messageGroup: HL7MessageGroup;
  dataBlockTypeId: number | null;
  hL7DocumentType: HL7DocumentType | null;
  hL7QueryType: HL7QueryType | null;
  documentTemplateId: number;
  isAutoSending: boolean;
  serverAddress: string | null;
  serverPort: number | null;
  isActive: boolean;
}
export function deserializeCreateHL7TemplateRuleDto(json: string): CreateHL7TemplateRuleDto {
  const data = JSON.parse(json) as CreateHL7TemplateRuleDto;
  initCreateHL7TemplateRuleDto(data);
  return data;
}
export function initCreateHL7TemplateRuleDto(_data: CreateHL7TemplateRuleDto) {
  if (_data) {
    _data.messageGroup = _data["messageGroup"];
    _data.hL7DocumentType = _data["hL7DocumentType"];
    _data.hL7QueryType = _data["hL7QueryType"];
  }
  return _data;
}
export function serializeCreateHL7TemplateRuleDto(_data: CreateHL7TemplateRuleDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateHL7TemplateRuleDto(_data as CreateHL7TemplateRuleDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateHL7TemplateRuleDto(_data: CreateHL7TemplateRuleDto): CreateHL7TemplateRuleDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateHL7TemplateRuleDto;
}
export interface HL7OutgoingSettingsDto  {
  outgoingTransporterEnabled: boolean;
  enabled: boolean;
  serverAddress: string;
  /** Delays to retry failing sending attempts (in seconds)  */
  retryDelays: string;
  serverPort: number;
  encoding: number;
  outgoingMessageStorageFolder: string;
  filesDirectory: string;
}
export function deserializeHL7OutgoingSettingsDto(json: string): HL7OutgoingSettingsDto {
  const data = JSON.parse(json) as HL7OutgoingSettingsDto;
  initHL7OutgoingSettingsDto(data);
  return data;
}
export function initHL7OutgoingSettingsDto(_data: HL7OutgoingSettingsDto) {
    return _data;
}
export function serializeHL7OutgoingSettingsDto(_data: HL7OutgoingSettingsDto | undefined) {
  if (_data) {
    _data = prepareSerializeHL7OutgoingSettingsDto(_data as HL7OutgoingSettingsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeHL7OutgoingSettingsDto(_data: HL7OutgoingSettingsDto): HL7OutgoingSettingsDto {
  const data: Record<string, any> = { ..._data };
  return data as HL7OutgoingSettingsDto;
}
export interface HL7OutgoingSettingsPatchDto  {
  outgoingTransporterEnabled?: boolean;
  enabled?: boolean;
  serverAddress?: string;
  serverPort?: number;
  encoding?: number;
  /** Delays to retry failing sending attempts (in seconds)  */
  retryDelays?: string;
  filesDirectory?: string;
}
export function deserializeHL7OutgoingSettingsPatchDto(json: string): HL7OutgoingSettingsPatchDto {
  const data = JSON.parse(json) as HL7OutgoingSettingsPatchDto;
  initHL7OutgoingSettingsPatchDto(data);
  return data;
}
export function initHL7OutgoingSettingsPatchDto(_data: HL7OutgoingSettingsPatchDto) {
    return _data;
}
export function serializeHL7OutgoingSettingsPatchDto(_data: HL7OutgoingSettingsPatchDto | undefined) {
  if (_data) {
    _data = prepareSerializeHL7OutgoingSettingsPatchDto(_data as HL7OutgoingSettingsPatchDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeHL7OutgoingSettingsPatchDto(_data: HL7OutgoingSettingsPatchDto): HL7OutgoingSettingsPatchDto {
  const data: Record<string, any> = { ..._data };
  return data as HL7OutgoingSettingsPatchDto;
}
export interface SendHL7PatientRequestDto  {
  patientNumber: string;
  subtenantId: number;
}
export function deserializeSendHL7PatientRequestDto(json: string): SendHL7PatientRequestDto {
  const data = JSON.parse(json) as SendHL7PatientRequestDto;
  initSendHL7PatientRequestDto(data);
  return data;
}
export function initSendHL7PatientRequestDto(_data: SendHL7PatientRequestDto) {
    return _data;
}
export function serializeSendHL7PatientRequestDto(_data: SendHL7PatientRequestDto | undefined) {
  if (_data) {
    _data = prepareSerializeSendHL7PatientRequestDto(_data as SendHL7PatientRequestDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSendHL7PatientRequestDto(_data: SendHL7PatientRequestDto): SendHL7PatientRequestDto {
  const data: Record<string, any> = { ..._data };
  return data as SendHL7PatientRequestDto;
}
export interface SendHL7MessageDto  {
  templateIds?: number[] | null;
}
export function deserializeSendHL7MessageDto(json: string): SendHL7MessageDto {
  const data = JSON.parse(json) as SendHL7MessageDto;
  initSendHL7MessageDto(data);
  return data;
}
export function initSendHL7MessageDto(_data: SendHL7MessageDto) {
  if (_data) {
    _data.templateIds = _data["templateIds"];
  }
  return _data;
}
export function serializeSendHL7MessageDto(_data: SendHL7MessageDto | undefined) {
  if (_data) {
    _data = prepareSerializeSendHL7MessageDto(_data as SendHL7MessageDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSendHL7MessageDto(_data: SendHL7MessageDto): SendHL7MessageDto {
  const data: Record<string, any> = { ..._data };
  return data as SendHL7MessageDto;
}
export interface PageableListDtoOfHL7MessageDto  {
  totalCount: number;
  data: HL7MessageDto[];
}
export function deserializePageableListDtoOfHL7MessageDto(json: string): PageableListDtoOfHL7MessageDto {
  const data = JSON.parse(json) as PageableListDtoOfHL7MessageDto;
  initPageableListDtoOfHL7MessageDto(data);
  return data;
}
export function initPageableListDtoOfHL7MessageDto(_data: PageableListDtoOfHL7MessageDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initHL7MessageDto(item)
      );
    }
  }
  return _data;
}
export function serializePageableListDtoOfHL7MessageDto(_data: PageableListDtoOfHL7MessageDto | undefined) {
  if (_data) {
    _data = prepareSerializePageableListDtoOfHL7MessageDto(_data as PageableListDtoOfHL7MessageDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePageableListDtoOfHL7MessageDto(_data: PageableListDtoOfHL7MessageDto): PageableListDtoOfHL7MessageDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeHL7MessageDto(item)
    );
  }
  return data as PageableListDtoOfHL7MessageDto;
}
export interface HL7MessageDto  {
  id: number;
  content: string;
  messageDirection: HL7MessageDirection;
  acknowledged: boolean;
  type: HL7MessageType;
  dateTime: Date;
  /** If true it means there it was fit by a filter with Accept action */
  isAccepted: boolean;
  /** Only valid for Outgoing messages */
  isSent: boolean;
  error?: string | null;
  patient: PatientReferenceDto | null;
  status: GDTMessageStatus;
  outgoingObjectId?: number | null;
  outgoingFileId?: string | null;
}
export function deserializeHL7MessageDto(json: string): HL7MessageDto {
  const data = JSON.parse(json) as HL7MessageDto;
  initHL7MessageDto(data);
  return data;
}
export function initHL7MessageDto(_data: HL7MessageDto) {
  if (_data) {
    _data.messageDirection = _data["messageDirection"];
    _data.type = _data["type"];
    _data.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>null;
    _data.patient = _data["patient"] && initPatientReferenceDto(_data["patient"]);
    _data.status = _data["status"];
  }
  return _data;
}
export function serializeHL7MessageDto(_data: HL7MessageDto | undefined) {
  if (_data) {
    _data = prepareSerializeHL7MessageDto(_data as HL7MessageDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeHL7MessageDto(_data: HL7MessageDto): HL7MessageDto {
  const data: Record<string, any> = { ..._data };
  data["dateTime"] = _data.dateTime && _data.dateTime.toISOString();
  data["patient"] = _data.patient && prepareSerializePatientReferenceDto(_data.patient);
  return data as HL7MessageDto;
}
/** 0 = Incoming 1 = Outgoing */
export enum HL7MessageDirection {
    Incoming = 0,
    Outgoing = 1,
}
/** 0 = ADR_A19 1 = ADT_A01 2 = ADT_A02 3 = ADT_A03 4 = ADT_A04 5 = ADT_A05 6 = ADT_A06 7 = ADT_A07 8 = ADT_A08 9 = ADT_A09 10 = ADT_A10 11 = ADT_A11 12 = ADT_A12 13 = ADT_A13 14 = ADT_A14 15 = ADT_A15 16 = ADT_A16 17 = ADT_A17 18 = ADT_A18 19 = ADT_A20 20 = ADT_A21 21 = ADT_A22 22 = ADT_A23 23 = ADT_A24 24 = ADT_A25 25 = ADT_A26 26 = ADT_A27 27 = ADT_A28 28 = ADT_A29 29 = ADT_A30 30 = ADT_A31 31 = ADT_A32 32 = ADT_A33 33 = ADT_A34 34 = ADT_A35 35 = ADT_A36 36 = ADT_A37 37 = ADT_A38 38 = ADT_A39 39 = ADT_A40 40 = ADT_A41 41 = ADT_A42 42 = ADT_A43 43 = ADT_A44 44 = ADT_A45 45 = ADT_A46 46 = ADT_A47 47 = ADT_A48 48 = ADT_A49 49 = ADT_A50 50 = ADT_A51 51 = ADT_A52 52 = ADT_A53 53 = ADT_A54 54 = ADT_A55 55 = ADT_A60 56 = ADT_A61 57 = ADT_A62 58 = BAR_P01 59 = BAR_P02 60 = BAR_P05 61 = BAR_P06 62 = BAR_P10 63 = BAR_P12 64 = BPS_O29 65 = BRP_O30 66 = BRT_O32 67 = BTS_O31 68 = CRM_C01 69 = CRM_C02 70 = CRM_C03 71 = CRM_C04 72 = CRM_C05 73 = CRM_C06 74 = CRM_C07 75 = CRM_C08 76 = CSU_C09 77 = CSU_C10 78 = CSU_C11 79 = CSU_C12 80 = DFT_P03 81 = DFT_P11 82 = DOC_T12 83 = EAC_U07 84 = EAN_U09 85 = EAR_U08 86 = EHC_E01 87 = ESR_U02 88 = ESU_U01 89 = INR_U06 90 = INU_U05 91 = LSR_U13 92 = LSU_U12 93 = MDM_T01 94 = MDM_T02 95 = MDM_T03 96 = MDM_T04 97 = MDM_T05 98 = MDM_T06 99 = MDM_T07 100 = MDM_T08 101 = MDM_T09 102 = MDM_T10 103 = MDM_T11 104 = MFK_M01 105 = MFN_M01 106 = MFN_M02 107 = MFN_M03 108 = MFN_M04 109 = MFN_M05 110 = MFN_M06 111 = MFN_M07 112 = MFN_M08 113 = MFN_M09 114 = MFN_M10 115 = MFN_M11 116 = MFN_M12 117 = MFN_M13 118 = MFN_M14 119 = MFN_M15 120 = NMD_N02 121 = NMQ_N01 122 = NMR_N01 123 = OMB_O27 124 = OMD_O03 125 = OMG_O19 126 = OMI_O23 127 = OML_O21 128 = OML_O33 129 = OML_O35 130 = OMN_O07 131 = OMP_O09 132 = OMS_O05 133 = ORB_O28 134 = ORD_O04 135 = ORF_R04 136 = ORG_O20 137 = ORI_O24 138 = ORL_O22 139 = ORL_O34 140 = ORL_O36 141 = ORM_O01 142 = ORN_O08 143 = ORP_O10 144 = ORR_O02 145 = ORS_O06 146 = ORU_R01 147 = ORU_R30 148 = ORU_R31 149 = ORU_R32 150 = ORU_R40 151 = OSQ_Q06 152 = OSR_Q06 153 = OUL_R21 154 = OUL_R22 155 = OUL_R23 156 = OUL_R24 157 = PEX_P07 158 = PEX_P08 159 = PGL_PC6 160 = PGL_PC7 161 = PGL_PC8 162 = PIN_I07 163 = PMU_B01 164 = PMU_B02 165 = PMU_B03 166 = PMU_B04 167 = PMU_B05 168 = PMU_B06 169 = PMU_B07 170 = PMU_B08 171 = PPG_PCG 172 = PPG_PCH 173 = PPG_PCJ 174 = PPP_PCB 175 = PPP_PCC 176 = PPP_PCD 177 = PPR_PC1 178 = PPR_PC2 179 = PPR_PC3 180 = PPT_PCL 181 = PPV_PCA 182 = PRR_PC5 183 = PTR_PCF 184 = QBP_Q11 185 = QBP_Q13 186 = QBP_Q15 187 = QBP_Q21 188 = QBP_Q22 189 = QBP_Q23 190 = QBP_Q24 191 = QBP_Q25 192 = QBP_Q31 193 = QBP_Z73 194 = QBP_Z75 195 = QBP_Z77 196 = QBP_Z79 197 = QBP_Z81 198 = QBP_Z85 199 = QBP_Z87 200 = QBP_Z89 201 = QBP_Z91 202 = QBP_Z93 203 = QBP_Z95 204 = QBP_Z97 205 = QBP_Z99 206 = QBP_ZV1 207 = QCN_J01 208 = QRY_A19 209 = QRY_PC4 210 = QRY_PC9 211 = QRY_PCE 212 = QRY_PCK 213 = QRY_Q26 214 = QRY_Q27 215 = QRY_Q28 216 = QRY_Q29 217 = QRY_Q30 218 = QRY_R02 219 = QRY_T12 220 = QSB_Q16 221 = QSB_Z83 222 = QSX_J02 223 = QVR_Q17 224 = RAR_RAR 225 = RAS_O17 226 = RCL_I06 227 = RDE_O11 228 = RDE_O25 229 = RDR_RDR 230 = RDS_O13 231 = RDY_K15 232 = RDY_Z80 233 = RDY_Z98 234 = REF_I12 235 = REF_I13 236 = REF_I14 237 = REF_I15 238 = REF_I16 239 = REF_I17 240 = REF_I18 241 = RER_RER 242 = RGR_RGR 243 = RGV_O15 244 = ROR_ROR 245 = RPA_I08 246 = RPI_I01 247 = RPI_I04 248 = RPL_I02 249 = RPR_I03 250 = RQA_I08 251 = RQA_I09 252 = RQA_I10 253 = RQA_I11 254 = RQC_I05 255 = RQC_I06 256 = RQI_I01 257 = RQI_I02 258 = RQI_I03 259 = RQP_I04 260 = RRA_O18 261 = RRD_O14 262 = RRE_O12 263 = RRE_O26 264 = RRG_O16 265 = RRI_I12 266 = RRI_I13 267 = RRI_I14 268 = RRI_I15 269 = RRI_I16 270 = RRI_I17 271 = RRI_I18 272 = RSP_K11 273 = RSP_K21 274 = RSP_K22 275 = RSP_K23 276 = RSP_K24 277 = RSP_K25 278 = RSP_K31 279 = RSP_Z82 280 = RSP_Z84 281 = RSP_Z86 282 = RSP_Z88 283 = RSP_Z90 284 = RSV_ZV2 285 = RTB_K13 286 = RTB_Z74 287 = RTB_Z76 288 = RTB_Z78 289 = RTB_Z92 290 = RTB_Z94 291 = RTB_Z96 292 = SIU_S12 293 = SIU_S13 294 = SIU_S14 295 = SIU_S15 296 = SIU_S16 297 = SIU_S17 298 = SIU_S18 299 = SIU_S19 300 = SIU_S20 301 = SIU_S21 302 = SIU_S22 303 = SIU_S23 304 = SIU_S24 305 = SIU_S26 306 = SQM_S25 307 = SQR_S25 308 = SRM_S01 309 = SRM_S02 310 = SRM_S03 311 = SRM_S04 312 = SRM_S05 313 = SRM_S06 314 = SRM_S07 315 = SRM_S08 316 = SRM_S09 317 = SRM_S10 318 = SRM_S11 319 = SRR_S01 320 = SSR_U04 321 = SSU_U03 322 = SUR_P09 323 = TCR_U11 324 = TCU_U10 325 = VXQ_V01 326 = VXR_V03 327 = VXU_V04 328 = VXX_V02 -1 = Unknown */
export enum HL7MessageType {
    ADR_A19 = 0,
    ADT_A01 = 1,
    ADT_A02 = 2,
    ADT_A03 = 3,
    ADT_A04 = 4,
    ADT_A05 = 5,
    ADT_A06 = 6,
    ADT_A07 = 7,
    ADT_A08 = 8,
    ADT_A09 = 9,
    ADT_A10 = 10,
    ADT_A11 = 11,
    ADT_A12 = 12,
    ADT_A13 = 13,
    ADT_A14 = 14,
    ADT_A15 = 15,
    ADT_A16 = 16,
    ADT_A17 = 17,
    ADT_A18 = 18,
    ADT_A20 = 19,
    ADT_A21 = 20,
    ADT_A22 = 21,
    ADT_A23 = 22,
    ADT_A24 = 23,
    ADT_A25 = 24,
    ADT_A26 = 25,
    ADT_A27 = 26,
    ADT_A28 = 27,
    ADT_A29 = 28,
    ADT_A30 = 29,
    ADT_A31 = 30,
    ADT_A32 = 31,
    ADT_A33 = 32,
    ADT_A34 = 33,
    ADT_A35 = 34,
    ADT_A36 = 35,
    ADT_A37 = 36,
    ADT_A38 = 37,
    ADT_A39 = 38,
    ADT_A40 = 39,
    ADT_A41 = 40,
    ADT_A42 = 41,
    ADT_A43 = 42,
    ADT_A44 = 43,
    ADT_A45 = 44,
    ADT_A46 = 45,
    ADT_A47 = 46,
    ADT_A48 = 47,
    ADT_A49 = 48,
    ADT_A50 = 49,
    ADT_A51 = 50,
    ADT_A52 = 51,
    ADT_A53 = 52,
    ADT_A54 = 53,
    ADT_A55 = 54,
    ADT_A60 = 55,
    ADT_A61 = 56,
    ADT_A62 = 57,
    BAR_P01 = 58,
    BAR_P02 = 59,
    BAR_P05 = 60,
    BAR_P06 = 61,
    BAR_P10 = 62,
    BAR_P12 = 63,
    BPS_O29 = 64,
    BRP_O30 = 65,
    BRT_O32 = 66,
    BTS_O31 = 67,
    CRM_C01 = 68,
    CRM_C02 = 69,
    CRM_C03 = 70,
    CRM_C04 = 71,
    CRM_C05 = 72,
    CRM_C06 = 73,
    CRM_C07 = 74,
    CRM_C08 = 75,
    CSU_C09 = 76,
    CSU_C10 = 77,
    CSU_C11 = 78,
    CSU_C12 = 79,
    DFT_P03 = 80,
    DFT_P11 = 81,
    DOC_T12 = 82,
    EAC_U07 = 83,
    EAN_U09 = 84,
    EAR_U08 = 85,
    EHC_E01 = 86,
    ESR_U02 = 87,
    ESU_U01 = 88,
    INR_U06 = 89,
    INU_U05 = 90,
    LSR_U13 = 91,
    LSU_U12 = 92,
    MDM_T01 = 93,
    MDM_T02 = 94,
    MDM_T03 = 95,
    MDM_T04 = 96,
    MDM_T05 = 97,
    MDM_T06 = 98,
    MDM_T07 = 99,
    MDM_T08 = 100,
    MDM_T09 = 101,
    MDM_T10 = 102,
    MDM_T11 = 103,
    MFK_M01 = 104,
    MFN_M01 = 105,
    MFN_M02 = 106,
    MFN_M03 = 107,
    MFN_M04 = 108,
    MFN_M05 = 109,
    MFN_M06 = 110,
    MFN_M07 = 111,
    MFN_M08 = 112,
    MFN_M09 = 113,
    MFN_M10 = 114,
    MFN_M11 = 115,
    MFN_M12 = 116,
    MFN_M13 = 117,
    MFN_M14 = 118,
    MFN_M15 = 119,
    NMD_N02 = 120,
    NMQ_N01 = 121,
    NMR_N01 = 122,
    OMB_O27 = 123,
    OMD_O03 = 124,
    OMG_O19 = 125,
    OMI_O23 = 126,
    OML_O21 = 127,
    OML_O33 = 128,
    OML_O35 = 129,
    OMN_O07 = 130,
    OMP_O09 = 131,
    OMS_O05 = 132,
    ORB_O28 = 133,
    ORD_O04 = 134,
    ORF_R04 = 135,
    ORG_O20 = 136,
    ORI_O24 = 137,
    ORL_O22 = 138,
    ORL_O34 = 139,
    ORL_O36 = 140,
    ORM_O01 = 141,
    ORN_O08 = 142,
    ORP_O10 = 143,
    ORR_O02 = 144,
    ORS_O06 = 145,
    ORU_R01 = 146,
    ORU_R30 = 147,
    ORU_R31 = 148,
    ORU_R32 = 149,
    ORU_R40 = 150,
    OSQ_Q06 = 151,
    OSR_Q06 = 152,
    OUL_R21 = 153,
    OUL_R22 = 154,
    OUL_R23 = 155,
    OUL_R24 = 156,
    PEX_P07 = 157,
    PEX_P08 = 158,
    PGL_PC6 = 159,
    PGL_PC7 = 160,
    PGL_PC8 = 161,
    PIN_I07 = 162,
    PMU_B01 = 163,
    PMU_B02 = 164,
    PMU_B03 = 165,
    PMU_B04 = 166,
    PMU_B05 = 167,
    PMU_B06 = 168,
    PMU_B07 = 169,
    PMU_B08 = 170,
    PPG_PCG = 171,
    PPG_PCH = 172,
    PPG_PCJ = 173,
    PPP_PCB = 174,
    PPP_PCC = 175,
    PPP_PCD = 176,
    PPR_PC1 = 177,
    PPR_PC2 = 178,
    PPR_PC3 = 179,
    PPT_PCL = 180,
    PPV_PCA = 181,
    PRR_PC5 = 182,
    PTR_PCF = 183,
    QBP_Q11 = 184,
    QBP_Q13 = 185,
    QBP_Q15 = 186,
    QBP_Q21 = 187,
    QBP_Q22 = 188,
    QBP_Q23 = 189,
    QBP_Q24 = 190,
    QBP_Q25 = 191,
    QBP_Q31 = 192,
    QBP_Z73 = 193,
    QBP_Z75 = 194,
    QBP_Z77 = 195,
    QBP_Z79 = 196,
    QBP_Z81 = 197,
    QBP_Z85 = 198,
    QBP_Z87 = 199,
    QBP_Z89 = 200,
    QBP_Z91 = 201,
    QBP_Z93 = 202,
    QBP_Z95 = 203,
    QBP_Z97 = 204,
    QBP_Z99 = 205,
    QBP_ZV1 = 206,
    QCN_J01 = 207,
    QRY_A19 = 208,
    QRY_PC4 = 209,
    QRY_PC9 = 210,
    QRY_PCE = 211,
    QRY_PCK = 212,
    QRY_Q26 = 213,
    QRY_Q27 = 214,
    QRY_Q28 = 215,
    QRY_Q29 = 216,
    QRY_Q30 = 217,
    QRY_R02 = 218,
    QRY_T12 = 219,
    QSB_Q16 = 220,
    QSB_Z83 = 221,
    QSX_J02 = 222,
    QVR_Q17 = 223,
    RAR_RAR = 224,
    RAS_O17 = 225,
    RCL_I06 = 226,
    RDE_O11 = 227,
    RDE_O25 = 228,
    RDR_RDR = 229,
    RDS_O13 = 230,
    RDY_K15 = 231,
    RDY_Z80 = 232,
    RDY_Z98 = 233,
    REF_I12 = 234,
    REF_I13 = 235,
    REF_I14 = 236,
    REF_I15 = 237,
    REF_I16 = 238,
    REF_I17 = 239,
    REF_I18 = 240,
    RER_RER = 241,
    RGR_RGR = 242,
    RGV_O15 = 243,
    ROR_ROR = 244,
    RPA_I08 = 245,
    RPI_I01 = 246,
    RPI_I04 = 247,
    RPL_I02 = 248,
    RPR_I03 = 249,
    RQA_I08 = 250,
    RQA_I09 = 251,
    RQA_I10 = 252,
    RQA_I11 = 253,
    RQC_I05 = 254,
    RQC_I06 = 255,
    RQI_I01 = 256,
    RQI_I02 = 257,
    RQI_I03 = 258,
    RQP_I04 = 259,
    RRA_O18 = 260,
    RRD_O14 = 261,
    RRE_O12 = 262,
    RRE_O26 = 263,
    RRG_O16 = 264,
    RRI_I12 = 265,
    RRI_I13 = 266,
    RRI_I14 = 267,
    RRI_I15 = 268,
    RRI_I16 = 269,
    RRI_I17 = 270,
    RRI_I18 = 271,
    RSP_K11 = 272,
    RSP_K21 = 273,
    RSP_K22 = 274,
    RSP_K23 = 275,
    RSP_K24 = 276,
    RSP_K25 = 277,
    RSP_K31 = 278,
    RSP_Z82 = 279,
    RSP_Z84 = 280,
    RSP_Z86 = 281,
    RSP_Z88 = 282,
    RSP_Z90 = 283,
    RSV_ZV2 = 284,
    RTB_K13 = 285,
    RTB_Z74 = 286,
    RTB_Z76 = 287,
    RTB_Z78 = 288,
    RTB_Z92 = 289,
    RTB_Z94 = 290,
    RTB_Z96 = 291,
    SIU_S12 = 292,
    SIU_S13 = 293,
    SIU_S14 = 294,
    SIU_S15 = 295,
    SIU_S16 = 296,
    SIU_S17 = 297,
    SIU_S18 = 298,
    SIU_S19 = 299,
    SIU_S20 = 300,
    SIU_S21 = 301,
    SIU_S22 = 302,
    SIU_S23 = 303,
    SIU_S24 = 304,
    SIU_S26 = 305,
    SQM_S25 = 306,
    SQR_S25 = 307,
    SRM_S01 = 308,
    SRM_S02 = 309,
    SRM_S03 = 310,
    SRM_S04 = 311,
    SRM_S05 = 312,
    SRM_S06 = 313,
    SRM_S07 = 314,
    SRM_S08 = 315,
    SRM_S09 = 316,
    SRM_S10 = 317,
    SRM_S11 = 318,
    SRR_S01 = 319,
    SSR_U04 = 320,
    SSU_U03 = 321,
    SUR_P09 = 322,
    TCR_U11 = 323,
    TCU_U10 = 324,
    VXQ_V01 = 325,
    VXR_V03 = 326,
    VXU_V04 = 327,
    VXX_V02 = 328,
    Unknown = -1,
}
/** DTO to be used in other DTOs that reference a patient */
export interface PatientReferenceDto  {
  /** The patient id. */
  id: number;
  /** First name of a patient. */
  firstName: string;
  /** Last name of a patient. */
  lastName: string;
  /** Sex of the patient. */
  sex: SexType;
  /** Date of birth of the patient. */
  dateOfBirth: Date;
}
export function deserializePatientReferenceDto(json: string): PatientReferenceDto {
  const data = JSON.parse(json) as PatientReferenceDto;
  initPatientReferenceDto(data);
  return data;
}
export function initPatientReferenceDto(_data: PatientReferenceDto) {
  if (_data) {
    _data.sex = _data["sex"];
    _data.dateOfBirth = _data["dateOfBirth"] ? parseDateOnly(_data["dateOfBirth"].toString()) : <any>null;
  }
  return _data;
}
export function serializePatientReferenceDto(_data: PatientReferenceDto | undefined) {
  if (_data) {
    _data = prepareSerializePatientReferenceDto(_data as PatientReferenceDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatientReferenceDto(_data: PatientReferenceDto): PatientReferenceDto {
  const data: Record<string, any> = { ..._data };
  data["dateOfBirth"] = _data.dateOfBirth && formatDate(_data.dateOfBirth);
  return data as PatientReferenceDto;
}
/** 0 = Undefined 1 = Male 2 = Female 3 = Diverse */
export enum SexType {
    Undefined = 0,
    Male = 1,
    Female = 2,
    Diverse = 3,
}
/** 1 = Initial 2 = Stored 3 = Processed 4 = Received 5 = Applied 6 = Refused 7 = Error */
export enum GDTMessageStatus {
    Initial = 1,
    Stored = 2,
    Processed = 3,
    Received = 4,
    Applied = 5,
    Refused = 6,
    Error = 7,
}
/** 0 = Asc 1 = Desc */
export enum SortDirection {
    Asc = 0,
    Desc = 1,
}
export interface SortingDto  {
  sortField: string | null;
  sortDirection: SortDirection;
}
export function deserializeSortingDto(json: string): SortingDto {
  const data = JSON.parse(json) as SortingDto;
  initSortingDto(data);
  return data;
}
export function initSortingDto(_data: SortingDto) {
  if (_data) {
    _data.sortDirection = _data["sortDirection"];
  }
  return _data;
}
export function serializeSortingDto(_data: SortingDto | undefined) {
  if (_data) {
    _data = prepareSerializeSortingDto(_data as SortingDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSortingDto(_data: SortingDto): SortingDto {
  const data: Record<string, any> = { ..._data };
  return data as SortingDto;
}
export interface MappingFieldDto  {
  tableName: string;
  fieldName: string;
  dataType: DataType;
  possibleValues?: { [key: string]: any; };
}
export function deserializeMappingFieldDto(json: string): MappingFieldDto {
  const data = JSON.parse(json) as MappingFieldDto;
  initMappingFieldDto(data);
  return data;
}
export function initMappingFieldDto(_data: MappingFieldDto) {
  if (_data) {
    _data.dataType = _data["dataType"];
  }
  return _data;
}
export function serializeMappingFieldDto(_data: MappingFieldDto | undefined) {
  if (_data) {
    _data = prepareSerializeMappingFieldDto(_data as MappingFieldDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeMappingFieldDto(_data: MappingFieldDto): MappingFieldDto {
  const data: Record<string, any> = { ..._data };
  return data as MappingFieldDto;
}
/** 0 = Undefined 1 = Number 2 = Text 3 = Boolean 4 = DateTime 5 = DateOnly 6 = TimeOnly 7 = Dictionary 8 = Table 9 = MultilineText */
export enum DataType {
    Undefined = 0,
    Number = 1,
    Text = 2,
    Boolean = 3,
    DateTime = 4,
    DateOnly = 5,
    TimeOnly = 6,
    Dictionary = 7,
    Table = 8,
    MultilineText = 9,
}
export interface HL7MappingListDto  {
  id: number;
  name: string;
  isDefault: boolean;
  isDeleted: boolean;
}
export function deserializeHL7MappingListDto(json: string): HL7MappingListDto {
  const data = JSON.parse(json) as HL7MappingListDto;
  initHL7MappingListDto(data);
  return data;
}
export function initHL7MappingListDto(_data: HL7MappingListDto) {
    return _data;
}
export function serializeHL7MappingListDto(_data: HL7MappingListDto | undefined) {
  if (_data) {
    _data = prepareSerializeHL7MappingListDto(_data as HL7MappingListDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeHL7MappingListDto(_data: HL7MappingListDto): HL7MappingListDto {
  const data: Record<string, any> = { ..._data };
  return data as HL7MappingListDto;
}
export interface HL7MappingDto  {
  id: number;
  name: string;
  rules: HL7TargetDefinition[];
}
export function deserializeHL7MappingDto(json: string): HL7MappingDto {
  const data = JSON.parse(json) as HL7MappingDto;
  initHL7MappingDto(data);
  return data;
}
export function initHL7MappingDto(_data: HL7MappingDto) {
  if (_data) {
    if (Array.isArray(_data["rules"])) {
      _data.rules = _data["rules"].map(item => 
        initHL7TargetDefinition(item)
      );
    }
  }
  return _data;
}
export function serializeHL7MappingDto(_data: HL7MappingDto | undefined) {
  if (_data) {
    _data = prepareSerializeHL7MappingDto(_data as HL7MappingDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeHL7MappingDto(_data: HL7MappingDto): HL7MappingDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.rules)) {
    data["rules"] = _data.rules.map(item => 
        prepareSerializeHL7TargetDefinition(item)
    );
  }
  return data as HL7MappingDto;
}
export interface HL7TargetDefinition  {
  table: string;
  dictionaryField: string | null;
  fieldName: string;
  expression: string;
  enabled: boolean;
  isMandatory: boolean;
  ignoreErrors: boolean;
  overwriteIfEmpty: boolean;
  defaultValue: string | null;
  isDefault: boolean;
  defaulExpression?: string | null;
  isDeleted: boolean;
  hasOverwriteSettings: boolean;
}
export function deserializeHL7TargetDefinition(json: string): HL7TargetDefinition {
  const data = JSON.parse(json) as HL7TargetDefinition;
  initHL7TargetDefinition(data);
  return data;
}
export function initHL7TargetDefinition(_data: HL7TargetDefinition) {
    return _data;
}
export function serializeHL7TargetDefinition(_data: HL7TargetDefinition | undefined) {
  if (_data) {
    _data = prepareSerializeHL7TargetDefinition(_data as HL7TargetDefinition);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeHL7TargetDefinition(_data: HL7TargetDefinition): HL7TargetDefinition {
  const data: Record<string, any> = { ..._data };
  return data as HL7TargetDefinition;
}
export interface PatchHL7MappingDto  {
  name?: string | null;
  rules?: HL7TargetDefinition[] | null;
}
export function deserializePatchHL7MappingDto(json: string): PatchHL7MappingDto {
  const data = JSON.parse(json) as PatchHL7MappingDto;
  initPatchHL7MappingDto(data);
  return data;
}
export function initPatchHL7MappingDto(_data: PatchHL7MappingDto) {
  if (_data) {
    if (Array.isArray(_data["rules"])) {
      _data.rules = _data["rules"].map(item => 
        initHL7TargetDefinition(item)
      );
    }
  }
  return _data;
}
export function serializePatchHL7MappingDto(_data: PatchHL7MappingDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchHL7MappingDto(_data as PatchHL7MappingDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchHL7MappingDto(_data: PatchHL7MappingDto): PatchHL7MappingDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.rules)) {
    data["rules"] = _data.rules.map(item => 
        prepareSerializeHL7TargetDefinition(item)
    );
  }
  return data as PatchHL7MappingDto;
}
export interface CreateHL7MappingDto  {
  name: string;
  rules?: HL7TargetDefinition[];
}
export function deserializeCreateHL7MappingDto(json: string): CreateHL7MappingDto {
  const data = JSON.parse(json) as CreateHL7MappingDto;
  initCreateHL7MappingDto(data);
  return data;
}
export function initCreateHL7MappingDto(_data: CreateHL7MappingDto) {
  if (_data) {
    if (Array.isArray(_data["rules"])) {
      _data.rules = _data["rules"].map(item => 
        initHL7TargetDefinition(item)
      );
    }
  }
  return _data;
}
export function serializeCreateHL7MappingDto(_data: CreateHL7MappingDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateHL7MappingDto(_data as CreateHL7MappingDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateHL7MappingDto(_data: CreateHL7MappingDto): CreateHL7MappingDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.rules)) {
    data["rules"] = _data.rules.map(item => 
        prepareSerializeHL7TargetDefinition(item)
    );
  }
  return data as CreateHL7MappingDto;
}
export interface HL7MessageTypeMappingDto  {
  id: number;
  messageType: HL7MessageType;
  mappingId: number;
  enabled: boolean;
  visitCreatingEnabled: boolean;
  isDefault: boolean;
}
export function deserializeHL7MessageTypeMappingDto(json: string): HL7MessageTypeMappingDto {
  const data = JSON.parse(json) as HL7MessageTypeMappingDto;
  initHL7MessageTypeMappingDto(data);
  return data;
}
export function initHL7MessageTypeMappingDto(_data: HL7MessageTypeMappingDto) {
  if (_data) {
    _data.messageType = _data["messageType"];
  }
  return _data;
}
export function serializeHL7MessageTypeMappingDto(_data: HL7MessageTypeMappingDto | undefined) {
  if (_data) {
    _data = prepareSerializeHL7MessageTypeMappingDto(_data as HL7MessageTypeMappingDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeHL7MessageTypeMappingDto(_data: HL7MessageTypeMappingDto): HL7MessageTypeMappingDto {
  const data: Record<string, any> = { ..._data };
  return data as HL7MessageTypeMappingDto;
}
export interface PatchHL7MessageTypeMappingDto  {
  messageType?: HL7MessageType;
  mappingId?: number;
  enabled?: boolean;
  visitCreatingEnabled?: boolean;
}
export function deserializePatchHL7MessageTypeMappingDto(json: string): PatchHL7MessageTypeMappingDto {
  const data = JSON.parse(json) as PatchHL7MessageTypeMappingDto;
  initPatchHL7MessageTypeMappingDto(data);
  return data;
}
export function initPatchHL7MessageTypeMappingDto(_data: PatchHL7MessageTypeMappingDto) {
  if (_data) {
    _data.messageType = _data["messageType"];
  }
  return _data;
}
export function serializePatchHL7MessageTypeMappingDto(_data: PatchHL7MessageTypeMappingDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchHL7MessageTypeMappingDto(_data as PatchHL7MessageTypeMappingDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchHL7MessageTypeMappingDto(_data: PatchHL7MessageTypeMappingDto): PatchHL7MessageTypeMappingDto {
  const data: Record<string, any> = { ..._data };
  return data as PatchHL7MessageTypeMappingDto;
}
export interface CreateHL7MessageTypeMappingDto  {
  messageType: HL7MessageType;
  mappingId: number;
  enabled: boolean;
  visitCreatingEnabled: boolean;
}
export function deserializeCreateHL7MessageTypeMappingDto(json: string): CreateHL7MessageTypeMappingDto {
  const data = JSON.parse(json) as CreateHL7MessageTypeMappingDto;
  initCreateHL7MessageTypeMappingDto(data);
  return data;
}
export function initCreateHL7MessageTypeMappingDto(_data: CreateHL7MessageTypeMappingDto) {
  if (_data) {
    _data.messageType = _data["messageType"];
  }
  return _data;
}
export function serializeCreateHL7MessageTypeMappingDto(_data: CreateHL7MessageTypeMappingDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateHL7MessageTypeMappingDto(_data as CreateHL7MessageTypeMappingDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateHL7MessageTypeMappingDto(_data: CreateHL7MessageTypeMappingDto): CreateHL7MessageTypeMappingDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateHL7MessageTypeMappingDto;
}
export interface HL7IncomingSettingsDto  {
  port: number;
  enabled: boolean;
  incomingTransporterEnabled: boolean;
  defaultVisitTypeId: number;
  overwriteTime: boolean;
  overwriteTimeOption: OverwriteTimeOption;
  visitStartTimeInSecondsSinceMidnight: number;
  visitLengthInSeconds: number;
  visitSearchBackwardDaysCount: number;
  visitSearchForwardDaysCount: number;
  caseSearchBackwardDaysCount: number;
  caseSearchForwardDaysCount: number;
  additionalVisits?: AdditionalVisitDto[];
}
export function deserializeHL7IncomingSettingsDto(json: string): HL7IncomingSettingsDto {
  const data = JSON.parse(json) as HL7IncomingSettingsDto;
  initHL7IncomingSettingsDto(data);
  return data;
}
export function initHL7IncomingSettingsDto(_data: HL7IncomingSettingsDto) {
  if (_data) {
    _data.overwriteTimeOption = _data["overwriteTimeOption"];
    if (Array.isArray(_data["additionalVisits"])) {
      _data.additionalVisits = _data["additionalVisits"].map(item => 
        initAdditionalVisitDto(item)
      );
    }
  }
  return _data;
}
export function serializeHL7IncomingSettingsDto(_data: HL7IncomingSettingsDto | undefined) {
  if (_data) {
    _data = prepareSerializeHL7IncomingSettingsDto(_data as HL7IncomingSettingsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeHL7IncomingSettingsDto(_data: HL7IncomingSettingsDto): HL7IncomingSettingsDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.additionalVisits)) {
    data["additionalVisits"] = _data.additionalVisits.map(item => 
        prepareSerializeAdditionalVisitDto(item)
    );
  }
  return data as HL7IncomingSettingsDto;
}
/** 0 = OverwriteEndIfEmpty 1 = OverwriteAlways */
export enum OverwriteTimeOption {
    OverwriteEndIfEmpty = 0,
    OverwriteAlways = 1,
}
export interface AdditionalVisitDto  {
  type: string;
  visitTypeId: number;
  visitStartTimeInSecondsSinceMidnight: number;
  visitLengthInSeconds: number;
}
export function deserializeAdditionalVisitDto(json: string): AdditionalVisitDto {
  const data = JSON.parse(json) as AdditionalVisitDto;
  initAdditionalVisitDto(data);
  return data;
}
export function initAdditionalVisitDto(_data: AdditionalVisitDto) {
    return _data;
}
export function serializeAdditionalVisitDto(_data: AdditionalVisitDto | undefined) {
  if (_data) {
    _data = prepareSerializeAdditionalVisitDto(_data as AdditionalVisitDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAdditionalVisitDto(_data: AdditionalVisitDto): AdditionalVisitDto {
  const data: Record<string, any> = { ..._data };
  return data as AdditionalVisitDto;
}
export interface HL7IncomingSettingsPatchDto  {
  incomingTransporterEnabled?: boolean;
  defaultVisitTypeId?: number;
  overwriteTime?: boolean;
  overwriteTimeOption?: OverwriteTimeOption;
  visitStartTimeInSecondsSinceMidnight?: number | null;
  visitLengthInSeconds?: number;
  visitSearchBackwardDaysCount?: number;
  visitSearchForwardDaysCount?: number;
  caseSearchBackwardDaysCount?: number;
  caseSearchForwardDaysCount?: number;
  additionalVisits?: AdditionalVisitDto[];
}
export function deserializeHL7IncomingSettingsPatchDto(json: string): HL7IncomingSettingsPatchDto {
  const data = JSON.parse(json) as HL7IncomingSettingsPatchDto;
  initHL7IncomingSettingsPatchDto(data);
  return data;
}
export function initHL7IncomingSettingsPatchDto(_data: HL7IncomingSettingsPatchDto) {
  if (_data) {
    _data.overwriteTimeOption = _data["overwriteTimeOption"];
    if (Array.isArray(_data["additionalVisits"])) {
      _data.additionalVisits = _data["additionalVisits"].map(item => 
        initAdditionalVisitDto(item)
      );
    }
  }
  return _data;
}
export function serializeHL7IncomingSettingsPatchDto(_data: HL7IncomingSettingsPatchDto | undefined) {
  if (_data) {
    _data = prepareSerializeHL7IncomingSettingsPatchDto(_data as HL7IncomingSettingsPatchDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeHL7IncomingSettingsPatchDto(_data: HL7IncomingSettingsPatchDto): HL7IncomingSettingsPatchDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.additionalVisits)) {
    data["additionalVisits"] = _data.additionalVisits.map(item => 
        prepareSerializeAdditionalVisitDto(item)
    );
  }
  return data as HL7IncomingSettingsPatchDto;
}
export interface HL7FilterDto  {
  id: number;
  messageType: HL7MessageType | null;
  position: number;
  enabled: boolean;
  /** JSON-serialized filter */
  filterExpression: string;
  action: HL7FilterAction;
  isDefault: boolean;
}
export function deserializeHL7FilterDto(json: string): HL7FilterDto {
  const data = JSON.parse(json) as HL7FilterDto;
  initHL7FilterDto(data);
  return data;
}
export function initHL7FilterDto(_data: HL7FilterDto) {
  if (_data) {
    _data.messageType = _data["messageType"];
    _data.action = _data["action"];
  }
  return _data;
}
export function serializeHL7FilterDto(_data: HL7FilterDto | undefined) {
  if (_data) {
    _data = prepareSerializeHL7FilterDto(_data as HL7FilterDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeHL7FilterDto(_data: HL7FilterDto): HL7FilterDto {
  const data: Record<string, any> = { ..._data };
  return data as HL7FilterDto;
}
/** 0 = Accept 1 = Reject */
export enum HL7FilterAction {
    Accept = 0,
    Reject = 1,
}
export interface UpdateHL7FilterDto  {
  messageType?: HL7MessageType;
  position?: number;
  enabled?: boolean;
  /** JSON-serialized filter */
  filterExpression?: string | null;
  action?: HL7FilterAction;
}
export function deserializeUpdateHL7FilterDto(json: string): UpdateHL7FilterDto {
  const data = JSON.parse(json) as UpdateHL7FilterDto;
  initUpdateHL7FilterDto(data);
  return data;
}
export function initUpdateHL7FilterDto(_data: UpdateHL7FilterDto) {
  if (_data) {
    _data.messageType = _data["messageType"];
    _data.action = _data["action"];
  }
  return _data;
}
export function serializeUpdateHL7FilterDto(_data: UpdateHL7FilterDto | undefined) {
  if (_data) {
    _data = prepareSerializeUpdateHL7FilterDto(_data as UpdateHL7FilterDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUpdateHL7FilterDto(_data: UpdateHL7FilterDto): UpdateHL7FilterDto {
  const data: Record<string, any> = { ..._data };
  return data as UpdateHL7FilterDto;
}
export interface CreateHL7FilterDto  {
  messageType: HL7MessageType;
  enabled: boolean;
  /** JSON-serialized filter */
  filterExpression?: string | null;
  action: HL7FilterAction;
}
export function deserializeCreateHL7FilterDto(json: string): CreateHL7FilterDto {
  const data = JSON.parse(json) as CreateHL7FilterDto;
  initCreateHL7FilterDto(data);
  return data;
}
export function initCreateHL7FilterDto(_data: CreateHL7FilterDto) {
  if (_data) {
    _data.messageType = _data["messageType"];
    _data.action = _data["action"];
  }
  return _data;
}
export function serializeCreateHL7FilterDto(_data: CreateHL7FilterDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateHL7FilterDto(_data as CreateHL7FilterDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateHL7FilterDto(_data: CreateHL7FilterDto): CreateHL7FilterDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateHL7FilterDto;
}
export interface GDTSettingsDto  {
  enabled: boolean;
  onlyProcessMessagesForExistingPatients: boolean;
  subtenantId: number;
  encoding: string;
  appName: string;
  defaultVisitTypeId: number;
  visitLengthInSeconds: number;
  caseSearchBackwardDaysCount: number;
  caseSearchForwardDaysCount: number;
}
export function deserializeGDTSettingsDto(json: string): GDTSettingsDto {
  const data = JSON.parse(json) as GDTSettingsDto;
  initGDTSettingsDto(data);
  return data;
}
export function initGDTSettingsDto(_data: GDTSettingsDto) {
    return _data;
}
export function serializeGDTSettingsDto(_data: GDTSettingsDto | undefined) {
  if (_data) {
    _data = prepareSerializeGDTSettingsDto(_data as GDTSettingsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeGDTSettingsDto(_data: GDTSettingsDto): GDTSettingsDto {
  const data: Record<string, any> = { ..._data };
  return data as GDTSettingsDto;
}
export interface GDTSettingsPatchDto  {
  enabled?: boolean;
  onlyProcessMessagesForExistingPatients?: boolean;
  subtenantId?: number;
  encoding?: string;
  appName?: string;
  defaultVisitTypeId?: number | null;
  visitLengthInSeconds?: number | null;
  caseSearchBackwardDaysCount?: number | null;
  caseSearchForwardDaysCount?: number | null;
}
export function deserializeGDTSettingsPatchDto(json: string): GDTSettingsPatchDto {
  const data = JSON.parse(json) as GDTSettingsPatchDto;
  initGDTSettingsPatchDto(data);
  return data;
}
export function initGDTSettingsPatchDto(_data: GDTSettingsPatchDto) {
    return _data;
}
export function serializeGDTSettingsPatchDto(_data: GDTSettingsPatchDto | undefined) {
  if (_data) {
    _data = prepareSerializeGDTSettingsPatchDto(_data as GDTSettingsPatchDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeGDTSettingsPatchDto(_data: GDTSettingsPatchDto): GDTSettingsPatchDto {
  const data: Record<string, any> = { ..._data };
  return data as GDTSettingsPatchDto;
}
export interface GDTTemplateRuleDto  {
  id: number;
  subtenantId: number;
  messageGroup: GDTMessageGroup;
  dataBlockTypeId: number | null;
  documentTemplateId: number;
  isAutoSending: boolean;
  isActive: boolean;
  isDeleted: boolean;
  isDefault: boolean;
}
export function deserializeGDTTemplateRuleDto(json: string): GDTTemplateRuleDto {
  const data = JSON.parse(json) as GDTTemplateRuleDto;
  initGDTTemplateRuleDto(data);
  return data;
}
export function initGDTTemplateRuleDto(_data: GDTTemplateRuleDto) {
  if (_data) {
    _data.messageGroup = _data["messageGroup"];
  }
  return _data;
}
export function serializeGDTTemplateRuleDto(_data: GDTTemplateRuleDto | undefined) {
  if (_data) {
    _data = prepareSerializeGDTTemplateRuleDto(_data as GDTTemplateRuleDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeGDTTemplateRuleDto(_data: GDTTemplateRuleDto): GDTTemplateRuleDto {
  const data: Record<string, any> = { ..._data };
  return data as GDTTemplateRuleDto;
}
/** 1 = DataBlock 2 = Document */
export enum GDTMessageGroup {
    DataBlock = 1,
    Document = 2,
}
export interface PatchGDTTemplateRuleDto  {
  messageGroup?: GDTMessageGroup | null;
  dataBlockTypeId?: number | null;
  documentTemplateId?: number | null;
  isAutoSending?: boolean | null;
  isActive?: boolean | null;
}
export function deserializePatchGDTTemplateRuleDto(json: string): PatchGDTTemplateRuleDto {
  const data = JSON.parse(json) as PatchGDTTemplateRuleDto;
  initPatchGDTTemplateRuleDto(data);
  return data;
}
export function initPatchGDTTemplateRuleDto(_data: PatchGDTTemplateRuleDto) {
  if (_data) {
    _data.messageGroup = _data["messageGroup"];
  }
  return _data;
}
export function serializePatchGDTTemplateRuleDto(_data: PatchGDTTemplateRuleDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchGDTTemplateRuleDto(_data as PatchGDTTemplateRuleDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchGDTTemplateRuleDto(_data: PatchGDTTemplateRuleDto): PatchGDTTemplateRuleDto {
  const data: Record<string, any> = { ..._data };
  return data as PatchGDTTemplateRuleDto;
}
export interface CreateGDTTemplateRuleDto  {
  subtenantId: number;
  messageGroup: GDTMessageGroup;
  dataBlockTypeId: number | null;
  documentTemplateId: number;
  isAutoSending: boolean;
  isActive: boolean;
}
export function deserializeCreateGDTTemplateRuleDto(json: string): CreateGDTTemplateRuleDto {
  const data = JSON.parse(json) as CreateGDTTemplateRuleDto;
  initCreateGDTTemplateRuleDto(data);
  return data;
}
export function initCreateGDTTemplateRuleDto(_data: CreateGDTTemplateRuleDto) {
  if (_data) {
    _data.messageGroup = _data["messageGroup"];
  }
  return _data;
}
export function serializeCreateGDTTemplateRuleDto(_data: CreateGDTTemplateRuleDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateGDTTemplateRuleDto(_data as CreateGDTTemplateRuleDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateGDTTemplateRuleDto(_data: CreateGDTTemplateRuleDto): CreateGDTTemplateRuleDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateGDTTemplateRuleDto;
}
export interface SendGDTMessageDto  {
  templateIds?: number[] | null;
}
export function deserializeSendGDTMessageDto(json: string): SendGDTMessageDto {
  const data = JSON.parse(json) as SendGDTMessageDto;
  initSendGDTMessageDto(data);
  return data;
}
export function initSendGDTMessageDto(_data: SendGDTMessageDto) {
  if (_data) {
    _data.templateIds = _data["templateIds"];
  }
  return _data;
}
export function serializeSendGDTMessageDto(_data: SendGDTMessageDto | undefined) {
  if (_data) {
    _data = prepareSerializeSendGDTMessageDto(_data as SendGDTMessageDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSendGDTMessageDto(_data: SendGDTMessageDto): SendGDTMessageDto {
  const data: Record<string, any> = { ..._data };
  return data as SendGDTMessageDto;
}
export interface PageableListDtoOfGDTMessageDto  {
  totalCount: number;
  data: GDTMessageDto[];
}
export function deserializePageableListDtoOfGDTMessageDto(json: string): PageableListDtoOfGDTMessageDto {
  const data = JSON.parse(json) as PageableListDtoOfGDTMessageDto;
  initPageableListDtoOfGDTMessageDto(data);
  return data;
}
export function initPageableListDtoOfGDTMessageDto(_data: PageableListDtoOfGDTMessageDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initGDTMessageDto(item)
      );
    }
  }
  return _data;
}
export function serializePageableListDtoOfGDTMessageDto(_data: PageableListDtoOfGDTMessageDto | undefined) {
  if (_data) {
    _data = prepareSerializePageableListDtoOfGDTMessageDto(_data as PageableListDtoOfGDTMessageDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePageableListDtoOfGDTMessageDto(_data: PageableListDtoOfGDTMessageDto): PageableListDtoOfGDTMessageDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeGDTMessageDto(item)
    );
  }
  return data as PageableListDtoOfGDTMessageDto;
}
export interface GDTMessageDto  {
  id: number;
  content: string;
  direction: GDTMessageDirection;
  dateTime: Date;
  error: string;
  status: GDTMessageStatus;
  patient: PatientReferenceDto | null;
  outgoingFileId?: string | null;
  outgoingObjectId?: number | null;
}
export function deserializeGDTMessageDto(json: string): GDTMessageDto {
  const data = JSON.parse(json) as GDTMessageDto;
  initGDTMessageDto(data);
  return data;
}
export function initGDTMessageDto(_data: GDTMessageDto) {
  if (_data) {
    _data.direction = _data["direction"];
    _data.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>null;
    _data.status = _data["status"];
    _data.patient = _data["patient"] && initPatientReferenceDto(_data["patient"]);
  }
  return _data;
}
export function serializeGDTMessageDto(_data: GDTMessageDto | undefined) {
  if (_data) {
    _data = prepareSerializeGDTMessageDto(_data as GDTMessageDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeGDTMessageDto(_data: GDTMessageDto): GDTMessageDto {
  const data: Record<string, any> = { ..._data };
  data["dateTime"] = _data.dateTime && _data.dateTime.toISOString();
  data["patient"] = _data.patient && prepareSerializePatientReferenceDto(_data.patient);
  return data as GDTMessageDto;
}
/** 0 = Incoming 1 = Outgoing */
export enum GDTMessageDirection {
    Incoming = 0,
    Outgoing = 1,
}
export interface UpdateGDTMessageDto  {
  error: string;
}
export function deserializeUpdateGDTMessageDto(json: string): UpdateGDTMessageDto {
  const data = JSON.parse(json) as UpdateGDTMessageDto;
  initUpdateGDTMessageDto(data);
  return data;
}
export function initUpdateGDTMessageDto(_data: UpdateGDTMessageDto) {
    return _data;
}
export function serializeUpdateGDTMessageDto(_data: UpdateGDTMessageDto | undefined) {
  if (_data) {
    _data = prepareSerializeUpdateGDTMessageDto(_data as UpdateGDTMessageDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUpdateGDTMessageDto(_data: UpdateGDTMessageDto): UpdateGDTMessageDto {
  const data: Record<string, any> = { ..._data };
  return data as UpdateGDTMessageDto;
}
export interface GDTMappingListDto  {
  id: number;
  name: string;
}
export function deserializeGDTMappingListDto(json: string): GDTMappingListDto {
  const data = JSON.parse(json) as GDTMappingListDto;
  initGDTMappingListDto(data);
  return data;
}
export function initGDTMappingListDto(_data: GDTMappingListDto) {
    return _data;
}
export function serializeGDTMappingListDto(_data: GDTMappingListDto | undefined) {
  if (_data) {
    _data = prepareSerializeGDTMappingListDto(_data as GDTMappingListDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeGDTMappingListDto(_data: GDTMappingListDto): GDTMappingListDto {
  const data: Record<string, any> = { ..._data };
  return data as GDTMappingListDto;
}
export interface GDTMappingDto  {
  id: number;
  name: string;
  rules: GDTMappingRule[];
}
export function deserializeGDTMappingDto(json: string): GDTMappingDto {
  const data = JSON.parse(json) as GDTMappingDto;
  initGDTMappingDto(data);
  return data;
}
export function initGDTMappingDto(_data: GDTMappingDto) {
  if (_data) {
    if (Array.isArray(_data["rules"])) {
      _data.rules = _data["rules"].map(item => 
        initGDTMappingRule(item)
      );
    }
  }
  return _data;
}
export function serializeGDTMappingDto(_data: GDTMappingDto | undefined) {
  if (_data) {
    _data = prepareSerializeGDTMappingDto(_data as GDTMappingDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeGDTMappingDto(_data: GDTMappingDto): GDTMappingDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.rules)) {
    data["rules"] = _data.rules.map(item => 
        prepareSerializeGDTMappingRule(item)
    );
  }
  return data as GDTMappingDto;
}
export interface GDTMappingRule  {
  table: string;
  fieldName: string;
  dictionaryField: string | null;
  gdtCode: string;
  enabled: boolean;
  default: boolean;
}
export function deserializeGDTMappingRule(json: string): GDTMappingRule {
  const data = JSON.parse(json) as GDTMappingRule;
  initGDTMappingRule(data);
  return data;
}
export function initGDTMappingRule(_data: GDTMappingRule) {
    return _data;
}
export function serializeGDTMappingRule(_data: GDTMappingRule | undefined) {
  if (_data) {
    _data = prepareSerializeGDTMappingRule(_data as GDTMappingRule);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeGDTMappingRule(_data: GDTMappingRule): GDTMappingRule {
  const data: Record<string, any> = { ..._data };
  return data as GDTMappingRule;
}
export interface PatchGDTMappingDto  {
  name?: string | null;
  rules?: GDTMappingRule[] | null;
}
export function deserializePatchGDTMappingDto(json: string): PatchGDTMappingDto {
  const data = JSON.parse(json) as PatchGDTMappingDto;
  initPatchGDTMappingDto(data);
  return data;
}
export function initPatchGDTMappingDto(_data: PatchGDTMappingDto) {
  if (_data) {
    if (Array.isArray(_data["rules"])) {
      _data.rules = _data["rules"].map(item => 
        initGDTMappingRule(item)
      );
    }
  }
  return _data;
}
export function serializePatchGDTMappingDto(_data: PatchGDTMappingDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchGDTMappingDto(_data as PatchGDTMappingDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchGDTMappingDto(_data: PatchGDTMappingDto): PatchGDTMappingDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.rules)) {
    data["rules"] = _data.rules.map(item => 
        prepareSerializeGDTMappingRule(item)
    );
  }
  return data as PatchGDTMappingDto;
}
export interface CreateGDTMappingDto  {
  name: string;
  rules?: GDTMappingRule[];
}
export function deserializeCreateGDTMappingDto(json: string): CreateGDTMappingDto {
  const data = JSON.parse(json) as CreateGDTMappingDto;
  initCreateGDTMappingDto(data);
  return data;
}
export function initCreateGDTMappingDto(_data: CreateGDTMappingDto) {
  if (_data) {
    if (Array.isArray(_data["rules"])) {
      _data.rules = _data["rules"].map(item => 
        initGDTMappingRule(item)
      );
    }
  }
  return _data;
}
export function serializeCreateGDTMappingDto(_data: CreateGDTMappingDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateGDTMappingDto(_data as CreateGDTMappingDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateGDTMappingDto(_data: CreateGDTMappingDto): CreateGDTMappingDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.rules)) {
    data["rules"] = _data.rules.map(item => 
        prepareSerializeGDTMappingRule(item)
    );
  }
  return data as CreateGDTMappingDto;
}
export interface UserDto  {
  /** The patient id. */
  id: string;
  /** User login. */
  username: string;
  /** First name of a user. */
  firstName: string;
  /** Last name of a user. */
  lastName: string;
  /** Email of a user. */
  email: string;
  /** Roles */
  roles: number[];
  subtenants: number[];
  isLocked: boolean;
  mustUpdatePassword: boolean;
}
export function deserializeUserDto(json: string): UserDto {
  const data = JSON.parse(json) as UserDto;
  initUserDto(data);
  return data;
}
export function initUserDto(_data: UserDto) {
  if (_data) {
    _data.roles = _data["roles"];
    _data.subtenants = _data["subtenants"];
  }
  return _data;
}
export function serializeUserDto(_data: UserDto | undefined) {
  if (_data) {
    _data = prepareSerializeUserDto(_data as UserDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUserDto(_data: UserDto): UserDto {
  const data: Record<string, any> = { ..._data };
  return data as UserDto;
}
export interface ChangePasswordDto  {
  oldPassword: string;
  newPassword: string;
}
export function deserializeChangePasswordDto(json: string): ChangePasswordDto {
  const data = JSON.parse(json) as ChangePasswordDto;
  initChangePasswordDto(data);
  return data;
}
export function initChangePasswordDto(_data: ChangePasswordDto) {
    return _data;
}
export function serializeChangePasswordDto(_data: ChangePasswordDto | undefined) {
  if (_data) {
    _data = prepareSerializeChangePasswordDto(_data as ChangePasswordDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeChangePasswordDto(_data: ChangePasswordDto): ChangePasswordDto {
  const data: Record<string, any> = { ..._data };
  return data as ChangePasswordDto;
}
export interface CreatePasswordDto  {
  password: string;
}
export function deserializeCreatePasswordDto(json: string): CreatePasswordDto {
  const data = JSON.parse(json) as CreatePasswordDto;
  initCreatePasswordDto(data);
  return data;
}
export function initCreatePasswordDto(_data: CreatePasswordDto) {
    return _data;
}
export function serializeCreatePasswordDto(_data: CreatePasswordDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreatePasswordDto(_data as CreatePasswordDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreatePasswordDto(_data: CreatePasswordDto): CreatePasswordDto {
  const data: Record<string, any> = { ..._data };
  return data as CreatePasswordDto;
}
export interface ResetPasswordDto  {
  username: string;
  token: string;
  newPassword: string;
}
export function deserializeResetPasswordDto(json: string): ResetPasswordDto {
  const data = JSON.parse(json) as ResetPasswordDto;
  initResetPasswordDto(data);
  return data;
}
export function initResetPasswordDto(_data: ResetPasswordDto) {
    return _data;
}
export function serializeResetPasswordDto(_data: ResetPasswordDto | undefined) {
  if (_data) {
    _data = prepareSerializeResetPasswordDto(_data as ResetPasswordDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeResetPasswordDto(_data: ResetPasswordDto): ResetPasswordDto {
  const data: Record<string, any> = { ..._data };
  return data as ResetPasswordDto;
}
export interface UpdateUserDto  {
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  roles?: number[] | null;
  subtenants?: number[] | null;
  mustUpdatePassword: boolean | null;
}
export function deserializeUpdateUserDto(json: string): UpdateUserDto {
  const data = JSON.parse(json) as UpdateUserDto;
  initUpdateUserDto(data);
  return data;
}
export function initUpdateUserDto(_data: UpdateUserDto) {
  if (_data) {
    _data.roles = _data["roles"];
    _data.subtenants = _data["subtenants"];
  }
  return _data;
}
export function serializeUpdateUserDto(_data: UpdateUserDto | undefined) {
  if (_data) {
    _data = prepareSerializeUpdateUserDto(_data as UpdateUserDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUpdateUserDto(_data: UpdateUserDto): UpdateUserDto {
  const data: Record<string, any> = { ..._data };
  return data as UpdateUserDto;
}
/** Dto to create a user by admin of some existing Tenant */
export interface CreateUserByAdminDto  {
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  roles: number[];
  /** Subtenants to add the user to */
  subtenants: number[];
  mustUpdatePassword: boolean;
}
export function deserializeCreateUserByAdminDto(json: string): CreateUserByAdminDto {
  const data = JSON.parse(json) as CreateUserByAdminDto;
  initCreateUserByAdminDto(data);
  return data;
}
export function initCreateUserByAdminDto(_data: CreateUserByAdminDto) {
  if (_data) {
    _data.roles = _data["roles"];
    _data.subtenants = _data["subtenants"];
  }
  return _data;
}
export function serializeCreateUserByAdminDto(_data: CreateUserByAdminDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateUserByAdminDto(_data as CreateUserByAdminDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateUserByAdminDto(_data: CreateUserByAdminDto): CreateUserByAdminDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateUserByAdminDto;
}
export interface CurrentUserDto  {
  permissions?: string[];
  id: string;
  name: string;
  nickname: string;
  subtenants?: number[];
}
export function deserializeCurrentUserDto(json: string): CurrentUserDto {
  const data = JSON.parse(json) as CurrentUserDto;
  initCurrentUserDto(data);
  return data;
}
export function initCurrentUserDto(_data: CurrentUserDto) {
  if (_data) {
    _data.permissions = _data["permissions"];
    _data.subtenants = _data["subtenants"];
  }
  return _data;
}
export function serializeCurrentUserDto(_data: CurrentUserDto | undefined) {
  if (_data) {
    _data = prepareSerializeCurrentUserDto(_data as CurrentUserDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCurrentUserDto(_data: CurrentUserDto): CurrentUserDto {
  const data: Record<string, any> = { ..._data };
  return data as CurrentUserDto;
}
export interface PasswordValidationSettingsDto  {
  /** Gets or sets the minimum length a password must be. Defaults to 6. */
  requiredLength: number;
  /** Gets or sets a flag indicating if passwords must contain a non-alphanumeric character. Defaults to true. */
  requireNonAlphanumeric: boolean;
  /** Gets or sets a flag indicating if passwords must contain a lower case ASCII character. Defaults to true. */
  requireLowercase: boolean;
  /** Gets or sets a flag indicating if passwords must contain a upper case ASCII character. Defaults to true. */
  requireUppercase: boolean;
  /** Gets or sets a flag indicating if passwords must contain a digit. Defaults to true. */
  requireDigit: boolean;
}
export function deserializePasswordValidationSettingsDto(json: string): PasswordValidationSettingsDto {
  const data = JSON.parse(json) as PasswordValidationSettingsDto;
  initPasswordValidationSettingsDto(data);
  return data;
}
export function initPasswordValidationSettingsDto(_data: PasswordValidationSettingsDto) {
    return _data;
}
export function serializePasswordValidationSettingsDto(_data: PasswordValidationSettingsDto | undefined) {
  if (_data) {
    _data = prepareSerializePasswordValidationSettingsDto(_data as PasswordValidationSettingsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePasswordValidationSettingsDto(_data: PasswordValidationSettingsDto): PasswordValidationSettingsDto {
  const data: Record<string, any> = { ..._data };
  return data as PasswordValidationSettingsDto;
}
export interface PasswordValidationSettingsPatchDto  {
  /** Gets or sets the minimum length a password must be. Defaults to 8. */
  requiredLength?: number;
  /** Gets or sets a flag indicating if passwords must contain a non-alphanumeric character. Defaults to true. */
  requireNonAlphanumeric?: boolean;
  /** Gets or sets a flag indicating if passwords must contain a upper case ASCII character. Defaults to true. */
  requireUppercase?: boolean;
  /** Gets or sets a flag indicating if passwords must contain a digit. Defaults to true. */
  requireDigit?: boolean;
  /** Gets or sets a flag indicating if passwords must contain a lower case ASCII character. Defaults to true. */
  requireLowercase?: boolean;
}
export function deserializePasswordValidationSettingsPatchDto(json: string): PasswordValidationSettingsPatchDto {
  const data = JSON.parse(json) as PasswordValidationSettingsPatchDto;
  initPasswordValidationSettingsPatchDto(data);
  return data;
}
export function initPasswordValidationSettingsPatchDto(_data: PasswordValidationSettingsPatchDto) {
    return _data;
}
export function serializePasswordValidationSettingsPatchDto(_data: PasswordValidationSettingsPatchDto | undefined) {
  if (_data) {
    _data = prepareSerializePasswordValidationSettingsPatchDto(_data as PasswordValidationSettingsPatchDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePasswordValidationSettingsPatchDto(_data: PasswordValidationSettingsPatchDto): PasswordValidationSettingsPatchDto {
  const data: Record<string, any> = { ..._data };
  return data as PasswordValidationSettingsPatchDto;
}
export interface CreateUIConfigurationDto  {
  name: string;
  uiConfig: string;
  isShared: boolean;
  dataBlockTypes?: number[] | null;
}
export function deserializeCreateUIConfigurationDto(json: string): CreateUIConfigurationDto {
  const data = JSON.parse(json) as CreateUIConfigurationDto;
  initCreateUIConfigurationDto(data);
  return data;
}
export function initCreateUIConfigurationDto(_data: CreateUIConfigurationDto) {
  if (_data) {
    _data.dataBlockTypes = _data["dataBlockTypes"];
  }
  return _data;
}
export function serializeCreateUIConfigurationDto(_data: CreateUIConfigurationDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateUIConfigurationDto(_data as CreateUIConfigurationDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateUIConfigurationDto(_data: CreateUIConfigurationDto): CreateUIConfigurationDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateUIConfigurationDto;
}
export interface EditUIConfigurationDto  {
  name: string;
  uiConfig: string;
  isShared: boolean;
  dataBlockTypes?: number[] | null;
}
export function deserializeEditUIConfigurationDto(json: string): EditUIConfigurationDto {
  const data = JSON.parse(json) as EditUIConfigurationDto;
  initEditUIConfigurationDto(data);
  return data;
}
export function initEditUIConfigurationDto(_data: EditUIConfigurationDto) {
  if (_data) {
    _data.dataBlockTypes = _data["dataBlockTypes"];
  }
  return _data;
}
export function serializeEditUIConfigurationDto(_data: EditUIConfigurationDto | undefined) {
  if (_data) {
    _data = prepareSerializeEditUIConfigurationDto(_data as EditUIConfigurationDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeEditUIConfigurationDto(_data: EditUIConfigurationDto): EditUIConfigurationDto {
  const data: Record<string, any> = { ..._data };
  return data as EditUIConfigurationDto;
}
export interface UIConfigurationListDto  {
  id: number;
  name: string;
  isShared: boolean;
  isDefault: boolean;
}
export function deserializeUIConfigurationListDto(json: string): UIConfigurationListDto {
  const data = JSON.parse(json) as UIConfigurationListDto;
  initUIConfigurationListDto(data);
  return data;
}
export function initUIConfigurationListDto(_data: UIConfigurationListDto) {
    return _data;
}
export function serializeUIConfigurationListDto(_data: UIConfigurationListDto | undefined) {
  if (_data) {
    _data = prepareSerializeUIConfigurationListDto(_data as UIConfigurationListDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUIConfigurationListDto(_data: UIConfigurationListDto): UIConfigurationListDto {
  const data: Record<string, any> = { ..._data };
  return data as UIConfigurationListDto;
}
export interface UIConfigurationDto  {
  id: number;
  name: string;
  uiConfig: string;
  isShared: boolean;
  isDefault: boolean;
  /** IsChanged is:
- false if UI is the same as it was seeded (user didn't change anything);
- true if UI configuration was changed by the user after it was created.
Used mostly for Default configurations (to check if it was changed by the user or not) */
  isUpdated: boolean | null;
}
export function deserializeUIConfigurationDto(json: string): UIConfigurationDto {
  const data = JSON.parse(json) as UIConfigurationDto;
  initUIConfigurationDto(data);
  return data;
}
export function initUIConfigurationDto(_data: UIConfigurationDto) {
    return _data;
}
export function serializeUIConfigurationDto(_data: UIConfigurationDto | undefined) {
  if (_data) {
    _data = prepareSerializeUIConfigurationDto(_data as UIConfigurationDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUIConfigurationDto(_data: UIConfigurationDto): UIConfigurationDto {
  const data: Record<string, any> = { ..._data };
  return data as UIConfigurationDto;
}
export interface TransportMessageDto  {
  id: number;
  protocol: TransportProtocol;
  content: string;
  status: TransportMessageStatus | null;
  error: string | null;
  dateTime: Date;
  outgoingFileId: string | null;
  subtenantCode: string | null;
}
export function deserializeTransportMessageDto(json: string): TransportMessageDto {
  const data = JSON.parse(json) as TransportMessageDto;
  initTransportMessageDto(data);
  return data;
}
export function initTransportMessageDto(_data: TransportMessageDto) {
  if (_data) {
    _data.protocol = _data["protocol"];
    _data.status = _data["status"];
    _data.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>null;
  }
  return _data;
}
export function serializeTransportMessageDto(_data: TransportMessageDto | undefined) {
  if (_data) {
    _data = prepareSerializeTransportMessageDto(_data as TransportMessageDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeTransportMessageDto(_data: TransportMessageDto): TransportMessageDto {
  const data: Record<string, any> = { ..._data };
  data["dateTime"] = _data.dateTime && _data.dateTime.toISOString();
  return data as TransportMessageDto;
}
/** 0 = GDT 1 = HL7 */
export enum TransportProtocol {
    GDT = 0,
    HL7 = 1,
}
/** 0 = New 1 = InWork 2 = Processed 3 = Error */
export enum TransportMessageStatus {
    New = 0,
    InWork = 1,
    Processed = 2,
    Error = 3,
}
/** 0 = Incoming 1 = Outgoing */
export enum TransportMessageDirection {
    Incoming = 0,
    Outgoing = 1,
}
export interface TransportClientDto  {
  name: string;
  lastActivityDateTime: Date;
}
export function deserializeTransportClientDto(json: string): TransportClientDto {
  const data = JSON.parse(json) as TransportClientDto;
  initTransportClientDto(data);
  return data;
}
export function initTransportClientDto(_data: TransportClientDto) {
  if (_data) {
    _data.lastActivityDateTime = _data["lastActivityDateTime"] ? new Date(_data["lastActivityDateTime"].toString()) : <any>null;
  }
  return _data;
}
export function serializeTransportClientDto(_data: TransportClientDto | undefined) {
  if (_data) {
    _data = prepareSerializeTransportClientDto(_data as TransportClientDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeTransportClientDto(_data: TransportClientDto): TransportClientDto {
  const data: Record<string, any> = { ..._data };
  data["lastActivityDateTime"] = _data.lastActivityDateTime && _data.lastActivityDateTime.toISOString();
  return data as TransportClientDto;
}
export interface TenantDto  {
  id: number;
  name: string;
  description: string;
  domain: string;
  subtenants: number[];
}
export function deserializeTenantDto(json: string): TenantDto {
  const data = JSON.parse(json) as TenantDto;
  initTenantDto(data);
  return data;
}
export function initTenantDto(_data: TenantDto) {
  if (_data) {
    _data.subtenants = _data["subtenants"];
  }
  return _data;
}
export function serializeTenantDto(_data: TenantDto | undefined) {
  if (_data) {
    _data = prepareSerializeTenantDto(_data as TenantDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeTenantDto(_data: TenantDto): TenantDto {
  const data: Record<string, any> = { ..._data };
  return data as TenantDto;
}
export interface CreateTenantInternalDto  {
  name: string;
  domain: string;
  adminUsername: string;
  adminEmail: string;
  adminFirstName: string;
  adminLastName: string;
  adminPassword: string;
  adminMustUpdatePassword: boolean;
}
export function deserializeCreateTenantInternalDto(json: string): CreateTenantInternalDto {
  const data = JSON.parse(json) as CreateTenantInternalDto;
  initCreateTenantInternalDto(data);
  return data;
}
export function initCreateTenantInternalDto(_data: CreateTenantInternalDto) {
    return _data;
}
export function serializeCreateTenantInternalDto(_data: CreateTenantInternalDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateTenantInternalDto(_data as CreateTenantInternalDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateTenantInternalDto(_data: CreateTenantInternalDto): CreateTenantInternalDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateTenantInternalDto;
}
export interface CreateTenantDto extends CreateTenantInternalDto  {
  accessPassphrase: string | null;
}
export function deserializeCreateTenantDto(json: string): CreateTenantDto {
  const data = JSON.parse(json) as CreateTenantDto;
  initCreateTenantDto(data);
  return data;
}
export function initCreateTenantDto(_data: CreateTenantDto) {
  initCreateTenantInternalDto(_data);
    return _data;
}
export function serializeCreateTenantDto(_data: CreateTenantDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateTenantDto(_data as CreateTenantDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateTenantDto(_data: CreateTenantDto): CreateTenantDto {
  const data = prepareSerializeCreateTenantInternalDto(_data as CreateTenantDto) as Record<string, any>;
  return data as CreateTenantDto;
}
export interface SubtenantDto  {
  id: number;
  name: string;
  code: string;
  /** Subtenant's working day start in seconds since midnight */
  workingTimeStartInSeconds: number;
  /** Subtenant's working day end in seconds since midnight */
  workingTimeEndInSeconds: number;
}
export function deserializeSubtenantDto(json: string): SubtenantDto {
  const data = JSON.parse(json) as SubtenantDto;
  initSubtenantDto(data);
  return data;
}
export function initSubtenantDto(_data: SubtenantDto) {
    return _data;
}
export function serializeSubtenantDto(_data: SubtenantDto | undefined) {
  if (_data) {
    _data = prepareSerializeSubtenantDto(_data as SubtenantDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSubtenantDto(_data: SubtenantDto): SubtenantDto {
  const data: Record<string, any> = { ..._data };
  return data as SubtenantDto;
}
export interface CreateSubtenantDto  {
  name: string;
  code: string;
  workingTimeStartInSeconds?: number | null;
  workingTimeEndInSeconds?: number | null;
}
export function deserializeCreateSubtenantDto(json: string): CreateSubtenantDto {
  const data = JSON.parse(json) as CreateSubtenantDto;
  initCreateSubtenantDto(data);
  return data;
}
export function initCreateSubtenantDto(_data: CreateSubtenantDto) {
    return _data;
}
export function serializeCreateSubtenantDto(_data: CreateSubtenantDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateSubtenantDto(_data as CreateSubtenantDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateSubtenantDto(_data: CreateSubtenantDto): CreateSubtenantDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateSubtenantDto;
}
export interface PageableListDtoOfSubtenantDto  {
  totalCount: number;
  data: SubtenantDto[];
}
export function deserializePageableListDtoOfSubtenantDto(json: string): PageableListDtoOfSubtenantDto {
  const data = JSON.parse(json) as PageableListDtoOfSubtenantDto;
  initPageableListDtoOfSubtenantDto(data);
  return data;
}
export function initPageableListDtoOfSubtenantDto(_data: PageableListDtoOfSubtenantDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initSubtenantDto(item)
      );
    }
  }
  return _data;
}
export function serializePageableListDtoOfSubtenantDto(_data: PageableListDtoOfSubtenantDto | undefined) {
  if (_data) {
    _data = prepareSerializePageableListDtoOfSubtenantDto(_data as PageableListDtoOfSubtenantDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePageableListDtoOfSubtenantDto(_data: PageableListDtoOfSubtenantDto): PageableListDtoOfSubtenantDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeSubtenantDto(item)
    );
  }
  return data as PageableListDtoOfSubtenantDto;
}
export interface PatchSubtenantDto  {
  name?: string | null;
  code?: string | null;
  workingTimeStartInSeconds?: number | null;
  workingTimeEndInSeconds?: number | null;
}
export function deserializePatchSubtenantDto(json: string): PatchSubtenantDto {
  const data = JSON.parse(json) as PatchSubtenantDto;
  initPatchSubtenantDto(data);
  return data;
}
export function initPatchSubtenantDto(_data: PatchSubtenantDto) {
    return _data;
}
export function serializePatchSubtenantDto(_data: PatchSubtenantDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchSubtenantDto(_data as PatchSubtenantDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchSubtenantDto(_data: PatchSubtenantDto): PatchSubtenantDto {
  const data: Record<string, any> = { ..._data };
  return data as PatchSubtenantDto;
}
export interface TenantSettingsDto  {
  allowTenantCreation: boolean;
}
export function deserializeTenantSettingsDto(json: string): TenantSettingsDto {
  const data = JSON.parse(json) as TenantSettingsDto;
  initTenantSettingsDto(data);
  return data;
}
export function initTenantSettingsDto(_data: TenantSettingsDto) {
    return _data;
}
export function serializeTenantSettingsDto(_data: TenantSettingsDto | undefined) {
  if (_data) {
    _data = prepareSerializeTenantSettingsDto(_data as TenantSettingsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeTenantSettingsDto(_data: TenantSettingsDto): TenantSettingsDto {
  const data: Record<string, any> = { ..._data };
  return data as TenantSettingsDto;
}
export interface SecuritySettingsDto  {
  idleLogoutTimeoutMinutes: number | null;
  adminLogoutTimeoutMinutes: number | null;
}
export function deserializeSecuritySettingsDto(json: string): SecuritySettingsDto {
  const data = JSON.parse(json) as SecuritySettingsDto;
  initSecuritySettingsDto(data);
  return data;
}
export function initSecuritySettingsDto(_data: SecuritySettingsDto) {
    return _data;
}
export function serializeSecuritySettingsDto(_data: SecuritySettingsDto | undefined) {
  if (_data) {
    _data = prepareSerializeSecuritySettingsDto(_data as SecuritySettingsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSecuritySettingsDto(_data: SecuritySettingsDto): SecuritySettingsDto {
  const data: Record<string, any> = { ..._data };
  return data as SecuritySettingsDto;
}
export interface SecuritySettingsPatchDto  {
  idleLogoutTimeoutMinutes?: number | null;
  adminLogoutTimeoutMinutes?: number | null;
}
export function deserializeSecuritySettingsPatchDto(json: string): SecuritySettingsPatchDto {
  const data = JSON.parse(json) as SecuritySettingsPatchDto;
  initSecuritySettingsPatchDto(data);
  return data;
}
export function initSecuritySettingsPatchDto(_data: SecuritySettingsPatchDto) {
    return _data;
}
export function serializeSecuritySettingsPatchDto(_data: SecuritySettingsPatchDto | undefined) {
  if (_data) {
    _data = prepareSerializeSecuritySettingsPatchDto(_data as SecuritySettingsPatchDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSecuritySettingsPatchDto(_data: SecuritySettingsPatchDto): SecuritySettingsPatchDto {
  const data: Record<string, any> = { ..._data };
  return data as SecuritySettingsPatchDto;
}
export interface MeasurementImportSettingsDto  {
  createVisitAutomatically: boolean;
  defaultVisitTypeId: number;
  visitStartTimeInSecondsSinceMidnight: number;
  visitLengthInSeconds: number;
  visitSearchBackwardDaysCount: number;
  visitSearchForwardDaysCount: number;
  caseSearchBackwardDaysCount: number;
  saveOldFilesWhenMeasurementReplaced: boolean;
}
export function deserializeMeasurementImportSettingsDto(json: string): MeasurementImportSettingsDto {
  const data = JSON.parse(json) as MeasurementImportSettingsDto;
  initMeasurementImportSettingsDto(data);
  return data;
}
export function initMeasurementImportSettingsDto(_data: MeasurementImportSettingsDto) {
    return _data;
}
export function serializeMeasurementImportSettingsDto(_data: MeasurementImportSettingsDto | undefined) {
  if (_data) {
    _data = prepareSerializeMeasurementImportSettingsDto(_data as MeasurementImportSettingsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeMeasurementImportSettingsDto(_data: MeasurementImportSettingsDto): MeasurementImportSettingsDto {
  const data: Record<string, any> = { ..._data };
  return data as MeasurementImportSettingsDto;
}
export interface MeasurementImportSettingsPatchDto  {
  createVisitAutomatically?: boolean;
  defaultVisitTypeId?: number;
  visitStartTimeInSecondsSinceMidnight?: number;
  visitLengthInSeconds?: number;
  visitSearchBackwardDaysCount?: number;
  visitSearchForwardDaysCount?: number;
  caseSearchBackwardDaysCount?: number;
  saveOldFilesWhenMeasurementReplaced?: boolean;
}
export function deserializeMeasurementImportSettingsPatchDto(json: string): MeasurementImportSettingsPatchDto {
  const data = JSON.parse(json) as MeasurementImportSettingsPatchDto;
  initMeasurementImportSettingsPatchDto(data);
  return data;
}
export function initMeasurementImportSettingsPatchDto(_data: MeasurementImportSettingsPatchDto) {
    return _data;
}
export function serializeMeasurementImportSettingsPatchDto(_data: MeasurementImportSettingsPatchDto | undefined) {
  if (_data) {
    _data = prepareSerializeMeasurementImportSettingsPatchDto(_data as MeasurementImportSettingsPatchDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeMeasurementImportSettingsPatchDto(_data: MeasurementImportSettingsPatchDto): MeasurementImportSettingsPatchDto {
  const data: Record<string, any> = { ..._data };
  return data as MeasurementImportSettingsPatchDto;
}
export interface GeneralSettingsDto  {
  isPatientCreatingShortedFormEnabled: boolean;
  isVisitCreatingShortedFormEnabled: boolean;
  serverLocale: string;
}
export function deserializeGeneralSettingsDto(json: string): GeneralSettingsDto {
  const data = JSON.parse(json) as GeneralSettingsDto;
  initGeneralSettingsDto(data);
  return data;
}
export function initGeneralSettingsDto(_data: GeneralSettingsDto) {
    return _data;
}
export function serializeGeneralSettingsDto(_data: GeneralSettingsDto | undefined) {
  if (_data) {
    _data = prepareSerializeGeneralSettingsDto(_data as GeneralSettingsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeGeneralSettingsDto(_data: GeneralSettingsDto): GeneralSettingsDto {
  const data: Record<string, any> = { ..._data };
  return data as GeneralSettingsDto;
}
export interface GeneralSettingsPatchDto  {
  isPatientCreatingShortedFormEnabled?: boolean;
  isVisitCreatingShortedFormEnabled?: boolean;
  serverLocale?: string;
}
export function deserializeGeneralSettingsPatchDto(json: string): GeneralSettingsPatchDto {
  const data = JSON.parse(json) as GeneralSettingsPatchDto;
  initGeneralSettingsPatchDto(data);
  return data;
}
export function initGeneralSettingsPatchDto(_data: GeneralSettingsPatchDto) {
    return _data;
}
export function serializeGeneralSettingsPatchDto(_data: GeneralSettingsPatchDto | undefined) {
  if (_data) {
    _data = prepareSerializeGeneralSettingsPatchDto(_data as GeneralSettingsPatchDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeGeneralSettingsPatchDto(_data: GeneralSettingsPatchDto): GeneralSettingsPatchDto {
  const data: Record<string, any> = { ..._data };
  return data as GeneralSettingsPatchDto;
}
export interface CalendarSettingsDto  {
  firstDayOfWeek: DayOfWeek;
  defaultCalendarView: number;
  timeZoneIanaId: string;
}
export function deserializeCalendarSettingsDto(json: string): CalendarSettingsDto {
  const data = JSON.parse(json) as CalendarSettingsDto;
  initCalendarSettingsDto(data);
  return data;
}
export function initCalendarSettingsDto(_data: CalendarSettingsDto) {
  if (_data) {
    _data.firstDayOfWeek = _data["firstDayOfWeek"];
  }
  return _data;
}
export function serializeCalendarSettingsDto(_data: CalendarSettingsDto | undefined) {
  if (_data) {
    _data = prepareSerializeCalendarSettingsDto(_data as CalendarSettingsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCalendarSettingsDto(_data: CalendarSettingsDto): CalendarSettingsDto {
  const data: Record<string, any> = { ..._data };
  return data as CalendarSettingsDto;
}
/** 0 = Sunday 1 = Monday 2 = Tuesday 3 = Wednesday 4 = Thursday 5 = Friday 6 = Saturday */
export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}
export interface CalendarSettingsPatchDto  {
  firstDayOfWeek?: DayOfWeek;
  defaultCalendarView?: number;
  timeZoneIanaId?: string;
}
export function deserializeCalendarSettingsPatchDto(json: string): CalendarSettingsPatchDto {
  const data = JSON.parse(json) as CalendarSettingsPatchDto;
  initCalendarSettingsPatchDto(data);
  return data;
}
export function initCalendarSettingsPatchDto(_data: CalendarSettingsPatchDto) {
  if (_data) {
    _data.firstDayOfWeek = _data["firstDayOfWeek"];
  }
  return _data;
}
export function serializeCalendarSettingsPatchDto(_data: CalendarSettingsPatchDto | undefined) {
  if (_data) {
    _data = prepareSerializeCalendarSettingsPatchDto(_data as CalendarSettingsPatchDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCalendarSettingsPatchDto(_data: CalendarSettingsPatchDto): CalendarSettingsPatchDto {
  const data: Record<string, any> = { ..._data };
  return data as CalendarSettingsPatchDto;
}
export interface PageableListDtoOfReportListDto  {
  totalCount: number;
  data: ReportListDto[];
}
export function deserializePageableListDtoOfReportListDto(json: string): PageableListDtoOfReportListDto {
  const data = JSON.parse(json) as PageableListDtoOfReportListDto;
  initPageableListDtoOfReportListDto(data);
  return data;
}
export function initPageableListDtoOfReportListDto(_data: PageableListDtoOfReportListDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initReportListDto(item)
      );
    }
  }
  return _data;
}
export function serializePageableListDtoOfReportListDto(_data: PageableListDtoOfReportListDto | undefined) {
  if (_data) {
    _data = prepareSerializePageableListDtoOfReportListDto(_data as PageableListDtoOfReportListDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePageableListDtoOfReportListDto(_data: PageableListDtoOfReportListDto): PageableListDtoOfReportListDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeReportListDto(item)
    );
  }
  return data as PageableListDtoOfReportListDto;
}
export interface ReportListDto  {
  fileName: string;
}
export function deserializeReportListDto(json: string): ReportListDto {
  const data = JSON.parse(json) as ReportListDto;
  initReportListDto(data);
  return data;
}
export function initReportListDto(_data: ReportListDto) {
    return _data;
}
export function serializeReportListDto(_data: ReportListDto | undefined) {
  if (_data) {
    _data = prepareSerializeReportListDto(_data as ReportListDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeReportListDto(_data: ReportListDto): ReportListDto {
  const data: Record<string, any> = { ..._data };
  return data as ReportListDto;
}
export interface RoleDto  {
  id: number;
  name: string;
  permissions?: string[];
  isEditable: boolean;
  isDefault: boolean;
}
export function deserializeRoleDto(json: string): RoleDto {
  const data = JSON.parse(json) as RoleDto;
  initRoleDto(data);
  return data;
}
export function initRoleDto(_data: RoleDto) {
  if (_data) {
    _data.permissions = _data["permissions"];
  }
  return _data;
}
export function serializeRoleDto(_data: RoleDto | undefined) {
  if (_data) {
    _data = prepareSerializeRoleDto(_data as RoleDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeRoleDto(_data: RoleDto): RoleDto {
  const data: Record<string, any> = { ..._data };
  return data as RoleDto;
}
export interface UpdateRoleDto  {
  name: string;
  permissions?: string[];
}
export function deserializeUpdateRoleDto(json: string): UpdateRoleDto {
  const data = JSON.parse(json) as UpdateRoleDto;
  initUpdateRoleDto(data);
  return data;
}
export function initUpdateRoleDto(_data: UpdateRoleDto) {
  if (_data) {
    _data.permissions = _data["permissions"];
  }
  return _data;
}
export function serializeUpdateRoleDto(_data: UpdateRoleDto | undefined) {
  if (_data) {
    _data = prepareSerializeUpdateRoleDto(_data as UpdateRoleDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUpdateRoleDto(_data: UpdateRoleDto): UpdateRoleDto {
  const data: Record<string, any> = { ..._data };
  return data as UpdateRoleDto;
}
export interface CreateRoleDto  {
  name: string;
  permissions?: string[];
}
export function deserializeCreateRoleDto(json: string): CreateRoleDto {
  const data = JSON.parse(json) as CreateRoleDto;
  initCreateRoleDto(data);
  return data;
}
export function initCreateRoleDto(_data: CreateRoleDto) {
  if (_data) {
    _data.permissions = _data["permissions"];
  }
  return _data;
}
export function serializeCreateRoleDto(_data: CreateRoleDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateRoleDto(_data as CreateRoleDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateRoleDto(_data: CreateRoleDto): CreateRoleDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateRoleDto;
}
export interface ResourceDto  {
  id: number;
  name: string;
  isDeleted: boolean;
  type: ResourceType;
  doctorId?: number | null;
}
export function deserializeResourceDto(json: string): ResourceDto {
  const data = JSON.parse(json) as ResourceDto;
  initResourceDto(data);
  return data;
}
export function initResourceDto(_data: ResourceDto) {
  if (_data) {
    _data.type = _data["type"];
  }
  return _data;
}
export function serializeResourceDto(_data: ResourceDto | undefined) {
  if (_data) {
    _data = prepareSerializeResourceDto(_data as ResourceDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeResourceDto(_data: ResourceDto): ResourceDto {
  const data: Record<string, any> = { ..._data };
  return data as ResourceDto;
}
/** 0 = Places 1 = SpecialConditions 2 = Doctors */
export enum ResourceType {
    Places = 0,
    SpecialConditions = 1,
    Doctors = 2,
}
export interface PageableListDtoOfResourceDto  {
  totalCount: number;
  data: ResourceDto[];
}
export function deserializePageableListDtoOfResourceDto(json: string): PageableListDtoOfResourceDto {
  const data = JSON.parse(json) as PageableListDtoOfResourceDto;
  initPageableListDtoOfResourceDto(data);
  return data;
}
export function initPageableListDtoOfResourceDto(_data: PageableListDtoOfResourceDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initResourceDto(item)
      );
    }
  }
  return _data;
}
export function serializePageableListDtoOfResourceDto(_data: PageableListDtoOfResourceDto | undefined) {
  if (_data) {
    _data = prepareSerializePageableListDtoOfResourceDto(_data as PageableListDtoOfResourceDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePageableListDtoOfResourceDto(_data: PageableListDtoOfResourceDto): PageableListDtoOfResourceDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeResourceDto(item)
    );
  }
  return data as PageableListDtoOfResourceDto;
}
export interface UpdateResourceDto  {
  name: string;
}
export function deserializeUpdateResourceDto(json: string): UpdateResourceDto {
  const data = JSON.parse(json) as UpdateResourceDto;
  initUpdateResourceDto(data);
  return data;
}
export function initUpdateResourceDto(_data: UpdateResourceDto) {
    return _data;
}
export function serializeUpdateResourceDto(_data: UpdateResourceDto | undefined) {
  if (_data) {
    _data = prepareSerializeUpdateResourceDto(_data as UpdateResourceDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUpdateResourceDto(_data: UpdateResourceDto): UpdateResourceDto {
  const data: Record<string, any> = { ..._data };
  return data as UpdateResourceDto;
}
export interface CreateResourceDto  {
  name: string;
  type: ResourceType;
  doctorId?: number | null;
}
export function deserializeCreateResourceDto(json: string): CreateResourceDto {
  const data = JSON.parse(json) as CreateResourceDto;
  initCreateResourceDto(data);
  return data;
}
export function initCreateResourceDto(_data: CreateResourceDto) {
  if (_data) {
    _data.type = _data["type"];
  }
  return _data;
}
export function serializeCreateResourceDto(_data: CreateResourceDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateResourceDto(_data as CreateResourceDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateResourceDto(_data: CreateResourceDto): CreateResourceDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateResourceDto;
}
export interface PatientDto  {
  /** The patient id. */
  id: number;
  /** First name of a patient. */
  firstName: string;
  /** Last name of a patient. */
  lastName: string;
  /** Sex of the patient. */
  sex: SexType;
  /** Date of birth of the patient. */
  dateOfBirth: Date;
  tags: number[];
  number: string;
  numberSource: NumberSource;
  address: string | null;
  postcode: string | null;
  location: string | null;
  homePhone: string | null;
  workPhone: string | null;
  mobilePhone: string | null;
  fax: string | null;
  email: string | null;
  emailsAllowed: boolean;
  healthInsuranceCompanyId: number | null;
  isPrivateInsurance: boolean;
  isSelfPayer: boolean;
  insuranceNumber: string | null;
  doctorId: number | null;
  comments: string | null;
  isDeceased: boolean;
  isDeleted: boolean;
  deletionReason: string | null;
  /** Id of the Subtenant that Patient belongs to. */
  subtenantId: number;
  dateOfDeath: Date | null;
  values: any;
  anonymous: boolean;
  priorityContactType: ContactType;
  priorityContact: string;
  importId: string | null;
  importErrors?: { [key: string]: string; } | null;
  lastChangeDateTime: Date;
}
export function deserializePatientDto(json: string): PatientDto {
  const data = JSON.parse(json) as PatientDto;
  initPatientDto(data);
  return data;
}
export function initPatientDto(_data: PatientDto) {
  if (_data) {
    _data.sex = _data["sex"];
    _data.dateOfBirth = _data["dateOfBirth"] ? parseDateOnly(_data["dateOfBirth"].toString()) : <any>null;
    _data.tags = _data["tags"];
    _data.numberSource = _data["numberSource"];
    _data.dateOfDeath = _data["dateOfDeath"] ? parseDateOnly(_data["dateOfDeath"].toString()) : <any>null;
    _data.values = _data["values"];
    _data.priorityContactType = _data["priorityContactType"];
    _data.lastChangeDateTime = _data["lastChangeDateTime"] ? new Date(_data["lastChangeDateTime"].toString()) : <any>null;
  }
  return _data;
}
export function serializePatientDto(_data: PatientDto | undefined) {
  if (_data) {
    _data = prepareSerializePatientDto(_data as PatientDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatientDto(_data: PatientDto): PatientDto {
  const data: Record<string, any> = { ..._data };
  data["dateOfBirth"] = _data.dateOfBirth && formatDate(_data.dateOfBirth);
  data["dateOfDeath"] = _data.dateOfDeath && formatDate(_data.dateOfDeath);
  data["lastChangeDateTime"] = _data.lastChangeDateTime && _data.lastChangeDateTime.toISOString();
  return data as PatientDto;
}
/** 0 = Autogenerated 1 = External */
export enum NumberSource {
    Autogenerated = 0,
    External = 1,
}
/** 0 = Undefined 1 = MobilePhone 2 = HomePhone 3 = WorkPhone 4 = Email 5 = Fax */
export enum ContactType {
    Undefined = 0,
    MobilePhone = 1,
    HomePhone = 2,
    WorkPhone = 3,
    Email = 4,
    Fax = 5,
}
export interface PageableListDtoOfPatientListDto  {
  totalCount: number;
  data: PatientListDto[];
}
export function deserializePageableListDtoOfPatientListDto(json: string): PageableListDtoOfPatientListDto {
  const data = JSON.parse(json) as PageableListDtoOfPatientListDto;
  initPageableListDtoOfPatientListDto(data);
  return data;
}
export function initPageableListDtoOfPatientListDto(_data: PageableListDtoOfPatientListDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initPatientListDto(item)
      );
    }
  }
  return _data;
}
export function serializePageableListDtoOfPatientListDto(_data: PageableListDtoOfPatientListDto | undefined) {
  if (_data) {
    _data = prepareSerializePageableListDtoOfPatientListDto(_data as PageableListDtoOfPatientListDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePageableListDtoOfPatientListDto(_data: PageableListDtoOfPatientListDto): PageableListDtoOfPatientListDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializePatientListDto(item)
    );
  }
  return data as PageableListDtoOfPatientListDto;
}
export interface PatientListDto  {
  /** The patient id. */
  id: number;
  /** First name of a patient. */
  firstName: string;
  /** Last name of a patient. */
  lastName: string;
  /** Sex of the patient. */
  sex: SexType;
  /** Date of birth of the patient. */
  dateOfBirth: Date;
  /** Id of the Subtenant that Patient belongs to. */
  subtenantId: number;
  isActive: boolean;
  number: string;
  numberSource: NumberSource;
  dateOfDeath: Date | null;
  priorityContact: string;
  priorityContactType: ContactType;
  homePhone?: string | null;
  workPhone?: string | null;
  mobilePhone?: string | null;
  fax?: string | null;
  email?: string | null;
  lastVisitDateTime: Date | null;
  isDeleted: boolean;
  anonymous: boolean;
  importId: string | null;
  lastChangeDateTime: Date;
  /** Values are only included if IncludeValues is set in request DTO */
  values?: any | null;
}
export function deserializePatientListDto(json: string): PatientListDto {
  const data = JSON.parse(json) as PatientListDto;
  initPatientListDto(data);
  return data;
}
export function initPatientListDto(_data: PatientListDto) {
  if (_data) {
    _data.sex = _data["sex"];
    _data.dateOfBirth = _data["dateOfBirth"] ? parseDateOnly(_data["dateOfBirth"].toString()) : <any>null;
    _data.numberSource = _data["numberSource"];
    _data.dateOfDeath = _data["dateOfDeath"] ? parseDateOnly(_data["dateOfDeath"].toString()) : <any>null;
    _data.priorityContactType = _data["priorityContactType"];
    _data.lastVisitDateTime = _data["lastVisitDateTime"] ? new Date(_data["lastVisitDateTime"].toString()) : <any>null;
    _data.lastChangeDateTime = _data["lastChangeDateTime"] ? new Date(_data["lastChangeDateTime"].toString()) : <any>null;
    _data.values = _data["values"];
  }
  return _data;
}
export function serializePatientListDto(_data: PatientListDto | undefined) {
  if (_data) {
    _data = prepareSerializePatientListDto(_data as PatientListDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatientListDto(_data: PatientListDto): PatientListDto {
  const data: Record<string, any> = { ..._data };
  data["dateOfBirth"] = _data.dateOfBirth && formatDate(_data.dateOfBirth);
  data["dateOfDeath"] = _data.dateOfDeath && formatDate(_data.dateOfDeath);
  data["lastVisitDateTime"] = _data.lastVisitDateTime && _data.lastVisitDateTime.toISOString();
  data["lastChangeDateTime"] = _data.lastChangeDateTime && _data.lastChangeDateTime.toISOString();
  return data as PatientListDto;
}
/** 0 = Active 1 = Deleted 2 = Anonymous */
export enum PatientState {
    Active = 0,
    Deleted = 1,
    Anonymous = 2,
}
/** 0 = Active 1 = Deceased */
export enum PatientStatus {
    Active = 0,
    Deceased = 1,
}
export interface PatchPatientDto  {
  /** First name of the patient. */
  firstName?: string | null;
  /** Last name of the patient. */
  lastName?: string | null;
  /** Sex of the patient. */
  sex?: SexType | null;
  priorityContactType?: ContactType | null;
  /** Date of birth of the patient. */
  dateOfBirth?: Date | null;
  number?: string | null;
  address?: string | null;
  postcode?: string | null;
  location?: string | null;
  homePhone?: string | null;
  workPhone?: string | null;
  mobilePhone?: string | null;
  fax?: string | null;
  email?: string | null;
  emailsAllowed?: boolean | null;
  healthInsuranceCompanyId?: number | null;
  isPrivateInsurance?: boolean | null;
  isSelfPayer?: boolean | null;
  insuranceNumber?: string | null;
  insuredStatus?: string | null;
  doctorId?: number | null;
  comments?: string | null;
  isDeceased?: boolean;
  dateOfDeath?: Date | null;
  values?: any | null;
  importErrors?: { [key: string]: string; } | null;
  lastChangeDateTime?: Date | null;
}
export function deserializePatchPatientDto(json: string): PatchPatientDto {
  const data = JSON.parse(json) as PatchPatientDto;
  initPatchPatientDto(data);
  return data;
}
export function initPatchPatientDto(_data: PatchPatientDto) {
  if (_data) {
    _data.sex = _data["sex"];
    _data.priorityContactType = _data["priorityContactType"];
    _data.dateOfBirth = _data["dateOfBirth"] ? parseDateOnly(_data["dateOfBirth"].toString()) : <any>null;
    _data.dateOfDeath = _data["dateOfDeath"] ? parseDateOnly(_data["dateOfDeath"].toString()) : <any>null;
    _data.values = _data["values"];
    _data.lastChangeDateTime = _data["lastChangeDateTime"] ? new Date(_data["lastChangeDateTime"].toString()) : <any>null;
  }
  return _data;
}
export function serializePatchPatientDto(_data: PatchPatientDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchPatientDto(_data as PatchPatientDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchPatientDto(_data: PatchPatientDto): PatchPatientDto {
  const data: Record<string, any> = { ..._data };
  data["dateOfBirth"] = _data.dateOfBirth && formatDate(_data.dateOfBirth);
  data["dateOfDeath"] = _data.dateOfDeath && formatDate(_data.dateOfDeath);
  data["lastChangeDateTime"] = _data.lastChangeDateTime && _data.lastChangeDateTime.toISOString();
  return data as PatchPatientDto;
}
export interface RemovePatientDto  {
  reason: string;
}
export function deserializeRemovePatientDto(json: string): RemovePatientDto {
  const data = JSON.parse(json) as RemovePatientDto;
  initRemovePatientDto(data);
  return data;
}
export function initRemovePatientDto(_data: RemovePatientDto) {
    return _data;
}
export function serializeRemovePatientDto(_data: RemovePatientDto | undefined) {
  if (_data) {
    _data = prepareSerializeRemovePatientDto(_data as RemovePatientDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeRemovePatientDto(_data: RemovePatientDto): RemovePatientDto {
  const data: Record<string, any> = { ..._data };
  return data as RemovePatientDto;
}
export interface CreatePatientDto  {
  /** Patients first name. */
  firstName: string;
  /** Patients last name. */
  lastName: string;
  /** Sex of the patient. */
  sex: SexType | null;
  priorityContactType: ContactType;
  /** Date of birth of the patient. */
  dateOfBirth: Date;
  isDeceased?: boolean | null;
  dateOfDeath?: Date | null;
  mobilePhone?: string | null;
  email?: string | null;
  emailsAllowed?: boolean | null;
  doctorId?: number | null;
  comments?: string | null;
  subtenantId: number;
  number?: string | null;
  address?: string | null;
  postcode?: string | null;
  location?: string | null;
  homePhone?: string | null;
  workPhone?: string | null;
  fax?: string | null;
  healthInsuranceCompanyId?: number | null;
  isPrivateInsurance?: boolean | null;
  isSelfPayer?: boolean | null;
  insuranceNumber?: string | null;
  importId?: string | null;
  importErrors?: { [key: string]: string; } | null;
  values?: any | null;
}
export function deserializeCreatePatientDto(json: string): CreatePatientDto {
  const data = JSON.parse(json) as CreatePatientDto;
  initCreatePatientDto(data);
  return data;
}
export function initCreatePatientDto(_data: CreatePatientDto) {
  if (_data) {
    _data.sex = _data["sex"];
    _data.priorityContactType = _data["priorityContactType"];
    _data.dateOfBirth = _data["dateOfBirth"] ? parseDateOnly(_data["dateOfBirth"].toString()) : <any>null;
    _data.dateOfDeath = _data["dateOfDeath"] ? parseDateOnly(_data["dateOfDeath"].toString()) : <any>null;
    _data.values = _data["values"];
  }
  return _data;
}
export function serializeCreatePatientDto(_data: CreatePatientDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreatePatientDto(_data as CreatePatientDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreatePatientDto(_data: CreatePatientDto): CreatePatientDto {
  const data: Record<string, any> = { ..._data };
  data["dateOfBirth"] = _data.dateOfBirth && formatDate(_data.dateOfBirth);
  data["dateOfDeath"] = _data.dateOfDeath && formatDate(_data.dateOfDeath);
  return data as CreatePatientDto;
}
export interface MergePatientsDto  {
  updatedPatientId: number;
  removedPatientId: number;
  patchPatient: PatchPatientDto;
}
export function deserializeMergePatientsDto(json: string): MergePatientsDto {
  const data = JSON.parse(json) as MergePatientsDto;
  initMergePatientsDto(data);
  return data;
}
export function initMergePatientsDto(_data: MergePatientsDto) {
  if (_data) {
    _data.patchPatient = _data["patchPatient"] && initPatchPatientDto(_data["patchPatient"]);
  }
  return _data;
}
export function serializeMergePatientsDto(_data: MergePatientsDto | undefined) {
  if (_data) {
    _data = prepareSerializeMergePatientsDto(_data as MergePatientsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeMergePatientsDto(_data: MergePatientsDto): MergePatientsDto {
  const data: Record<string, any> = { ..._data };
  data["patchPatient"] = _data.patchPatient && prepareSerializePatchPatientDto(_data.patchPatient);
  return data as MergePatientsDto;
}
export interface MovePatientResultDto  {
  patientId: number;
  duplicatePatientId: number | null;
  errors?: string[] | null;
}
export function deserializeMovePatientResultDto(json: string): MovePatientResultDto {
  const data = JSON.parse(json) as MovePatientResultDto;
  initMovePatientResultDto(data);
  return data;
}
export function initMovePatientResultDto(_data: MovePatientResultDto) {
  if (_data) {
    _data.errors = _data["errors"];
  }
  return _data;
}
export function serializeMovePatientResultDto(_data: MovePatientResultDto | undefined) {
  if (_data) {
    _data = prepareSerializeMovePatientResultDto(_data as MovePatientResultDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeMovePatientResultDto(_data: MovePatientResultDto): MovePatientResultDto {
  const data: Record<string, any> = { ..._data };
  return data as MovePatientResultDto;
}
export interface MovePatientDto  {
  isReplaceNumberWithGeneratedIfDuplicate: boolean;
}
export function deserializeMovePatientDto(json: string): MovePatientDto {
  const data = JSON.parse(json) as MovePatientDto;
  initMovePatientDto(data);
  return data;
}
export function initMovePatientDto(_data: MovePatientDto) {
    return _data;
}
export function serializeMovePatientDto(_data: MovePatientDto | undefined) {
  if (_data) {
    _data = prepareSerializeMovePatientDto(_data as MovePatientDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeMovePatientDto(_data: MovePatientDto): MovePatientDto {
  const data: Record<string, any> = { ..._data };
  return data as MovePatientDto;
}
export interface MovePatientsResultDto  {
  errors?: string[];
  isFinished: boolean;
}
export function deserializeMovePatientsResultDto(json: string): MovePatientsResultDto {
  const data = JSON.parse(json) as MovePatientsResultDto;
  initMovePatientsResultDto(data);
  return data;
}
export function initMovePatientsResultDto(_data: MovePatientsResultDto) {
  if (_data) {
    _data.errors = _data["errors"];
  }
  return _data;
}
export function serializeMovePatientsResultDto(_data: MovePatientsResultDto | undefined) {
  if (_data) {
    _data = prepareSerializeMovePatientsResultDto(_data as MovePatientsResultDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeMovePatientsResultDto(_data: MovePatientsResultDto): MovePatientsResultDto {
  const data: Record<string, any> = { ..._data };
  return data as MovePatientsResultDto;
}
export interface PageableListDtoOfPatientDuplicatePairDto  {
  totalCount: number;
  data: PatientDuplicatePairDto[];
}
export function deserializePageableListDtoOfPatientDuplicatePairDto(json: string): PageableListDtoOfPatientDuplicatePairDto {
  const data = JSON.parse(json) as PageableListDtoOfPatientDuplicatePairDto;
  initPageableListDtoOfPatientDuplicatePairDto(data);
  return data;
}
export function initPageableListDtoOfPatientDuplicatePairDto(_data: PageableListDtoOfPatientDuplicatePairDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initPatientDuplicatePairDto(item)
      );
    }
  }
  return _data;
}
export function serializePageableListDtoOfPatientDuplicatePairDto(_data: PageableListDtoOfPatientDuplicatePairDto | undefined) {
  if (_data) {
    _data = prepareSerializePageableListDtoOfPatientDuplicatePairDto(_data as PageableListDtoOfPatientDuplicatePairDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePageableListDtoOfPatientDuplicatePairDto(_data: PageableListDtoOfPatientDuplicatePairDto): PageableListDtoOfPatientDuplicatePairDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializePatientDuplicatePairDto(item)
    );
  }
  return data as PageableListDtoOfPatientDuplicatePairDto;
}
export interface PatientDuplicatePairDto  {
  id: number;
  firstPatient: PatientDuplicateInfo;
  secondPatient: PatientDuplicateInfo;
  createdAt: Date;
  isDeleted: boolean;
  lastActivity: Date | null;
  firstPatientId: number;
}
export function deserializePatientDuplicatePairDto(json: string): PatientDuplicatePairDto {
  const data = JSON.parse(json) as PatientDuplicatePairDto;
  initPatientDuplicatePairDto(data);
  return data;
}
export function initPatientDuplicatePairDto(_data: PatientDuplicatePairDto) {
  if (_data) {
    _data.firstPatient = _data["firstPatient"] && initPatientDuplicateInfo(_data["firstPatient"]);
    _data.secondPatient = _data["secondPatient"] && initPatientDuplicateInfo(_data["secondPatient"]);
    _data.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
    _data.lastActivity = _data["lastActivity"] ? new Date(_data["lastActivity"].toString()) : <any>null;
  }
  return _data;
}
export function serializePatientDuplicatePairDto(_data: PatientDuplicatePairDto | undefined) {
  if (_data) {
    _data = prepareSerializePatientDuplicatePairDto(_data as PatientDuplicatePairDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatientDuplicatePairDto(_data: PatientDuplicatePairDto): PatientDuplicatePairDto {
  const data: Record<string, any> = { ..._data };
  data["firstPatient"] = _data.firstPatient && prepareSerializePatientDuplicateInfo(_data.firstPatient);
  data["secondPatient"] = _data.secondPatient && prepareSerializePatientDuplicateInfo(_data.secondPatient);
  data["createdAt"] = _data.createdAt && _data.createdAt.toISOString();
  data["lastActivity"] = _data.lastActivity && _data.lastActivity.toISOString();
  return data as PatientDuplicatePairDto;
}
export interface PatientDuplicateInfo  {
  /** The patient id. */
  id: number;
  /** First name of a patient. */
  firstName: string;
  /** Last name of a patient. */
  lastName: string;
  /** Date of birth of the patient. */
  dateOfBirth: Date;
  isActive: boolean;
  number: string;
  numberSource: NumberSource;
  dateOfDeath: Date | null;
  priorityContact: string;
}
export function deserializePatientDuplicateInfo(json: string): PatientDuplicateInfo {
  const data = JSON.parse(json) as PatientDuplicateInfo;
  initPatientDuplicateInfo(data);
  return data;
}
export function initPatientDuplicateInfo(_data: PatientDuplicateInfo) {
  if (_data) {
    _data.dateOfBirth = _data["dateOfBirth"] ? parseDateOnly(_data["dateOfBirth"].toString()) : <any>null;
    _data.numberSource = _data["numberSource"];
    _data.dateOfDeath = _data["dateOfDeath"] ? parseDateOnly(_data["dateOfDeath"].toString()) : <any>null;
  }
  return _data;
}
export function serializePatientDuplicateInfo(_data: PatientDuplicateInfo | undefined) {
  if (_data) {
    _data = prepareSerializePatientDuplicateInfo(_data as PatientDuplicateInfo);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatientDuplicateInfo(_data: PatientDuplicateInfo): PatientDuplicateInfo {
  const data: Record<string, any> = { ..._data };
  data["dateOfBirth"] = _data.dateOfBirth && formatDate(_data.dateOfBirth);
  data["dateOfDeath"] = _data.dateOfDeath && formatDate(_data.dateOfDeath);
  return data as PatientDuplicateInfo;
}
export interface PatchPatientDuplicatePairDto  {
  isDeleted?: boolean;
}
export function deserializePatchPatientDuplicatePairDto(json: string): PatchPatientDuplicatePairDto {
  const data = JSON.parse(json) as PatchPatientDuplicatePairDto;
  initPatchPatientDuplicatePairDto(data);
  return data;
}
export function initPatchPatientDuplicatePairDto(_data: PatchPatientDuplicatePairDto) {
    return _data;
}
export function serializePatchPatientDuplicatePairDto(_data: PatchPatientDuplicatePairDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchPatientDuplicatePairDto(_data as PatchPatientDuplicatePairDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchPatientDuplicatePairDto(_data: PatchPatientDuplicatePairDto): PatchPatientDuplicatePairDto {
  const data: Record<string, any> = { ..._data };
  return data as PatchPatientDuplicatePairDto;
}
export interface PatientCommentDto  {
  id: number;
  comment: string;
  patientId: number;
  userFirstName: string;
  userLastName: string;
  createdAt: Date;
  isEdited: boolean;
  userId: string;
  tags?: number[];
}
export function deserializePatientCommentDto(json: string): PatientCommentDto {
  const data = JSON.parse(json) as PatientCommentDto;
  initPatientCommentDto(data);
  return data;
}
export function initPatientCommentDto(_data: PatientCommentDto) {
  if (_data) {
    _data.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
    _data.tags = _data["tags"];
  }
  return _data;
}
export function serializePatientCommentDto(_data: PatientCommentDto | undefined) {
  if (_data) {
    _data = prepareSerializePatientCommentDto(_data as PatientCommentDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatientCommentDto(_data: PatientCommentDto): PatientCommentDto {
  const data: Record<string, any> = { ..._data };
  data["createdAt"] = _data.createdAt && _data.createdAt.toISOString();
  return data as PatientCommentDto;
}
export interface EditPatientCommentDto  {
  comment: string;
}
export function deserializeEditPatientCommentDto(json: string): EditPatientCommentDto {
  const data = JSON.parse(json) as EditPatientCommentDto;
  initEditPatientCommentDto(data);
  return data;
}
export function initEditPatientCommentDto(_data: EditPatientCommentDto) {
    return _data;
}
export function serializeEditPatientCommentDto(_data: EditPatientCommentDto | undefined) {
  if (_data) {
    _data = prepareSerializeEditPatientCommentDto(_data as EditPatientCommentDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeEditPatientCommentDto(_data: EditPatientCommentDto): EditPatientCommentDto {
  const data: Record<string, any> = { ..._data };
  return data as EditPatientCommentDto;
}
export interface CreatePatientCommentDto  {
  comment: string;
  patientId: number;
}
export function deserializeCreatePatientCommentDto(json: string): CreatePatientCommentDto {
  const data = JSON.parse(json) as CreatePatientCommentDto;
  initCreatePatientCommentDto(data);
  return data;
}
export function initCreatePatientCommentDto(_data: CreatePatientCommentDto) {
    return _data;
}
export function serializeCreatePatientCommentDto(_data: CreatePatientCommentDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreatePatientCommentDto(_data as CreatePatientCommentDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreatePatientCommentDto(_data: CreatePatientCommentDto): CreatePatientCommentDto {
  const data: Record<string, any> = { ..._data };
  return data as CreatePatientCommentDto;
}
export interface PatientCardHashDto  {
  id: number;
  patientId: number;
  cardHash: string;
}
export function deserializePatientCardHashDto(json: string): PatientCardHashDto {
  const data = JSON.parse(json) as PatientCardHashDto;
  initPatientCardHashDto(data);
  return data;
}
export function initPatientCardHashDto(_data: PatientCardHashDto) {
    return _data;
}
export function serializePatientCardHashDto(_data: PatientCardHashDto | undefined) {
  if (_data) {
    _data = prepareSerializePatientCardHashDto(_data as PatientCardHashDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatientCardHashDto(_data: PatientCardHashDto): PatientCardHashDto {
  const data: Record<string, any> = { ..._data };
  return data as PatientCardHashDto;
}
export interface CreatePatientCardHashDto  {
  patientId: number;
  cardHash: string;
}
export function deserializeCreatePatientCardHashDto(json: string): CreatePatientCardHashDto {
  const data = JSON.parse(json) as CreatePatientCardHashDto;
  initCreatePatientCardHashDto(data);
  return data;
}
export function initCreatePatientCardHashDto(_data: CreatePatientCardHashDto) {
    return _data;
}
export function serializeCreatePatientCardHashDto(_data: CreatePatientCardHashDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreatePatientCardHashDto(_data as CreatePatientCardHashDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreatePatientCardHashDto(_data: CreatePatientCardHashDto): CreatePatientCardHashDto {
  const data: Record<string, any> = { ..._data };
  return data as CreatePatientCardHashDto;
}
export interface PatientListConfigurationDto  {
  id: number;
  name: string;
  userId: string;
  /** Shared between all users */
  isShared: boolean;
  /** Show filter or not */
  isFilterDisplayed: boolean;
  hasFilterBySubtenants: boolean;
  hasFilterByTags: boolean;
  hasFilterBySexTypes: boolean;
  hasFilterByStatuses: boolean;
  hasFilterByStates: boolean;
  hasFilterByLastActivity: boolean;
  hasFilterByLastVisit: boolean;
  hasFilterBySqlFilter: boolean;
  /** Subtenants that are available for filtering patients */
  subtenants?: number[];
  tags?: number[];
  sexTypes?: SexType[];
  statuses?: PatientStatus[];
  states?: PatientState[];
  lastActivity: DateRangeSetting | null;
  lastVisit: DateRangeSetting | null;
  sqlFilter?: string | null;
  /** System configuration (not created by user) */
  isSystem: boolean;
}
export function deserializePatientListConfigurationDto(json: string): PatientListConfigurationDto {
  const data = JSON.parse(json) as PatientListConfigurationDto;
  initPatientListConfigurationDto(data);
  return data;
}
export function initPatientListConfigurationDto(_data: PatientListConfigurationDto) {
  if (_data) {
    _data.subtenants = _data["subtenants"];
    _data.tags = _data["tags"];
    _data.sexTypes = _data["sexTypes"];
    _data.statuses = _data["statuses"];
    _data.states = _data["states"];
    _data.lastActivity = _data["lastActivity"] && initDateRangeSetting(_data["lastActivity"]);
    _data.lastVisit = _data["lastVisit"] && initDateRangeSetting(_data["lastVisit"]);
  }
  return _data;
}
export function serializePatientListConfigurationDto(_data: PatientListConfigurationDto | undefined) {
  if (_data) {
    _data = prepareSerializePatientListConfigurationDto(_data as PatientListConfigurationDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatientListConfigurationDto(_data: PatientListConfigurationDto): PatientListConfigurationDto {
  const data: Record<string, any> = { ..._data };
  data["lastActivity"] = _data.lastActivity && prepareSerializeDateRangeSetting(_data.lastActivity);
  data["lastVisit"] = _data.lastVisit && prepareSerializeDateRangeSetting(_data.lastVisit);
  return data as PatientListConfigurationDto;
}
export interface DateRangeSetting  {
  isRelativeToCurrentMoment: boolean;
  absoluteMoment: Date | null;
  rangeInSeconds: number | null;
}
export function deserializeDateRangeSetting(json: string): DateRangeSetting {
  const data = JSON.parse(json) as DateRangeSetting;
  initDateRangeSetting(data);
  return data;
}
export function initDateRangeSetting(_data: DateRangeSetting) {
  if (_data) {
    _data.absoluteMoment = _data["absoluteMoment"] ? new Date(_data["absoluteMoment"].toString()) : <any>null;
  }
  return _data;
}
export function serializeDateRangeSetting(_data: DateRangeSetting | undefined) {
  if (_data) {
    _data = prepareSerializeDateRangeSetting(_data as DateRangeSetting);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDateRangeSetting(_data: DateRangeSetting): DateRangeSetting {
  const data: Record<string, any> = { ..._data };
  data["absoluteMoment"] = _data.absoluteMoment && _data.absoluteMoment.toISOString();
  return data as DateRangeSetting;
}
export interface PatientListConfigurationListDto  {
  id: number;
  name: string;
  userId: string;
  /** Shared between all users */
  isShared: boolean;
  /** System configuration (not created by user) */
  isSystem: boolean;
  /** Is pinned for current user */
  isPinned: boolean;
}
export function deserializePatientListConfigurationListDto(json: string): PatientListConfigurationListDto {
  const data = JSON.parse(json) as PatientListConfigurationListDto;
  initPatientListConfigurationListDto(data);
  return data;
}
export function initPatientListConfigurationListDto(_data: PatientListConfigurationListDto) {
    return _data;
}
export function serializePatientListConfigurationListDto(_data: PatientListConfigurationListDto | undefined) {
  if (_data) {
    _data = prepareSerializePatientListConfigurationListDto(_data as PatientListConfigurationListDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatientListConfigurationListDto(_data: PatientListConfigurationListDto): PatientListConfigurationListDto {
  const data: Record<string, any> = { ..._data };
  return data as PatientListConfigurationListDto;
}
export interface CreatePatientListConfigurationDto  {
  name: string;
  isShared?: boolean | null;
  isFilterDisplayed: boolean;
  hasFilterBySubtenants?: boolean | null;
  hasFilterByTags?: boolean | null;
  hasFilterBySexTypes?: boolean | null;
  hasFilterByStatuses?: boolean | null;
  hasFilterByStates?: boolean | null;
  hasFilterByLastActivity?: boolean | null;
  hasFilterByLastVisit?: boolean | null;
  hasFilterBySqlFilter?: boolean | null;
  subtenants?: number[];
  tags?: number[];
  sexTypes?: SexType[];
  statuses?: PatientStatus[];
  states?: PatientState[];
  lastActivity?: DateRangeSetting | null;
  lastVisit?: DateRangeSetting | null;
  sqlFilter?: string | null;
}
export function deserializeCreatePatientListConfigurationDto(json: string): CreatePatientListConfigurationDto {
  const data = JSON.parse(json) as CreatePatientListConfigurationDto;
  initCreatePatientListConfigurationDto(data);
  return data;
}
export function initCreatePatientListConfigurationDto(_data: CreatePatientListConfigurationDto) {
  if (_data) {
    _data.subtenants = _data["subtenants"];
    _data.tags = _data["tags"];
    _data.sexTypes = _data["sexTypes"];
    _data.statuses = _data["statuses"];
    _data.states = _data["states"];
    _data.lastActivity = _data["lastActivity"] && initDateRangeSetting(_data["lastActivity"]);
    _data.lastVisit = _data["lastVisit"] && initDateRangeSetting(_data["lastVisit"]);
  }
  return _data;
}
export function serializeCreatePatientListConfigurationDto(_data: CreatePatientListConfigurationDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreatePatientListConfigurationDto(_data as CreatePatientListConfigurationDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreatePatientListConfigurationDto(_data: CreatePatientListConfigurationDto): CreatePatientListConfigurationDto {
  const data: Record<string, any> = { ..._data };
  data["lastActivity"] = _data.lastActivity && prepareSerializeDateRangeSetting(_data.lastActivity);
  data["lastVisit"] = _data.lastVisit && prepareSerializeDateRangeSetting(_data.lastVisit);
  return data as CreatePatientListConfigurationDto;
}
export interface UpdatePatientListConfigurationDto  {
  name?: string | null;
  isShared?: boolean | null;
  isFilterDisplayed?: boolean | null;
  hasFilterBySubtenants?: boolean | null;
  hasFilterByTags?: boolean | null;
  hasFilterBySexTypes?: boolean | null;
  hasFilterByStatuses?: boolean | null;
  hasFilterByStates?: boolean | null;
  hasFilterByLastActivity?: boolean | null;
  hasFilterByLastVisit?: boolean | null;
  hasFilterBySqlFilter?: boolean | null;
  subtenants?: number[] | null;
  tags?: number[] | null;
  sexTypes?: SexType[] | null;
  statuses?: PatientStatus[] | null;
  states?: PatientState[] | null;
  lastActivity?: DateRangeSetting | null;
  lastVisit?: DateRangeSetting | null;
  sqlFilter?: string | null;
}
export function deserializeUpdatePatientListConfigurationDto(json: string): UpdatePatientListConfigurationDto {
  const data = JSON.parse(json) as UpdatePatientListConfigurationDto;
  initUpdatePatientListConfigurationDto(data);
  return data;
}
export function initUpdatePatientListConfigurationDto(_data: UpdatePatientListConfigurationDto) {
  if (_data) {
    _data.subtenants = _data["subtenants"];
    _data.tags = _data["tags"];
    _data.sexTypes = _data["sexTypes"];
    _data.statuses = _data["statuses"];
    _data.states = _data["states"];
    _data.lastActivity = _data["lastActivity"] && initDateRangeSetting(_data["lastActivity"]);
    _data.lastVisit = _data["lastVisit"] && initDateRangeSetting(_data["lastVisit"]);
  }
  return _data;
}
export function serializeUpdatePatientListConfigurationDto(_data: UpdatePatientListConfigurationDto | undefined) {
  if (_data) {
    _data = prepareSerializeUpdatePatientListConfigurationDto(_data as UpdatePatientListConfigurationDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUpdatePatientListConfigurationDto(_data: UpdatePatientListConfigurationDto): UpdatePatientListConfigurationDto {
  const data: Record<string, any> = { ..._data };
  data["lastActivity"] = _data.lastActivity && prepareSerializeDateRangeSetting(_data.lastActivity);
  data["lastVisit"] = _data.lastVisit && prepareSerializeDateRangeSetting(_data.lastVisit);
  return data as UpdatePatientListConfigurationDto;
}
export interface PinPatientListConfigurationDto  {
  isPinned: boolean;
}
export function deserializePinPatientListConfigurationDto(json: string): PinPatientListConfigurationDto {
  const data = JSON.parse(json) as PinPatientListConfigurationDto;
  initPinPatientListConfigurationDto(data);
  return data;
}
export function initPinPatientListConfigurationDto(_data: PinPatientListConfigurationDto) {
    return _data;
}
export function serializePinPatientListConfigurationDto(_data: PinPatientListConfigurationDto | undefined) {
  if (_data) {
    _data = prepareSerializePinPatientListConfigurationDto(_data as PinPatientListConfigurationDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePinPatientListConfigurationDto(_data: PinPatientListConfigurationDto): PinPatientListConfigurationDto {
  const data: Record<string, any> = { ..._data };
  return data as PinPatientListConfigurationDto;
}
export interface NoteDto  {
  id: number;
  text: string;
  startDate: Date | null;
  endDate: Date | null;
  urgent: boolean;
  importId: string | null;
}
export function deserializeNoteDto(json: string): NoteDto {
  const data = JSON.parse(json) as NoteDto;
  initNoteDto(data);
  return data;
}
export function initNoteDto(_data: NoteDto) {
  if (_data) {
    _data.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
    _data.endDate = _data["endDate"] ? parseDateOnly(_data["endDate"].toString()) : <any>null;
  }
  return _data;
}
export function serializeNoteDto(_data: NoteDto | undefined) {
  if (_data) {
    _data = prepareSerializeNoteDto(_data as NoteDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeNoteDto(_data: NoteDto): NoteDto {
  const data: Record<string, any> = { ..._data };
  data["startDate"] = _data.startDate && formatDate(_data.startDate);
  data["endDate"] = _data.endDate && formatDate(_data.endDate);
  return data as NoteDto;
}
export interface PageableListDtoOfNoteDto  {
  totalCount: number;
  data: NoteDto[];
}
export function deserializePageableListDtoOfNoteDto(json: string): PageableListDtoOfNoteDto {
  const data = JSON.parse(json) as PageableListDtoOfNoteDto;
  initPageableListDtoOfNoteDto(data);
  return data;
}
export function initPageableListDtoOfNoteDto(_data: PageableListDtoOfNoteDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initNoteDto(item)
      );
    }
  }
  return _data;
}
export function serializePageableListDtoOfNoteDto(_data: PageableListDtoOfNoteDto | undefined) {
  if (_data) {
    _data = prepareSerializePageableListDtoOfNoteDto(_data as PageableListDtoOfNoteDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePageableListDtoOfNoteDto(_data: PageableListDtoOfNoteDto): PageableListDtoOfNoteDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeNoteDto(item)
    );
  }
  return data as PageableListDtoOfNoteDto;
}
export interface CreateNoteDto  {
  text: string;
  startDate?: Date | null;
  endDate?: Date | null;
  urgent: boolean;
  importId?: string | null;
}
export function deserializeCreateNoteDto(json: string): CreateNoteDto {
  const data = JSON.parse(json) as CreateNoteDto;
  initCreateNoteDto(data);
  return data;
}
export function initCreateNoteDto(_data: CreateNoteDto) {
  if (_data) {
    _data.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
    _data.endDate = _data["endDate"] ? parseDateOnly(_data["endDate"].toString()) : <any>null;
  }
  return _data;
}
export function serializeCreateNoteDto(_data: CreateNoteDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateNoteDto(_data as CreateNoteDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateNoteDto(_data: CreateNoteDto): CreateNoteDto {
  const data: Record<string, any> = { ..._data };
  data["startDate"] = _data.startDate && formatDate(_data.startDate);
  data["endDate"] = _data.endDate && formatDate(_data.endDate);
  return data as CreateNoteDto;
}
export interface UpdateNoteDto  {
  text?: string | null;
  startDate?: Date | null;
  endDate?: Date | null;
  urgent?: boolean | null;
}
export function deserializeUpdateNoteDto(json: string): UpdateNoteDto {
  const data = JSON.parse(json) as UpdateNoteDto;
  initUpdateNoteDto(data);
  return data;
}
export function initUpdateNoteDto(_data: UpdateNoteDto) {
  if (_data) {
    _data.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
    _data.endDate = _data["endDate"] ? parseDateOnly(_data["endDate"].toString()) : <any>null;
  }
  return _data;
}
export function serializeUpdateNoteDto(_data: UpdateNoteDto | undefined) {
  if (_data) {
    _data = prepareSerializeUpdateNoteDto(_data as UpdateNoteDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUpdateNoteDto(_data: UpdateNoteDto): UpdateNoteDto {
  const data: Record<string, any> = { ..._data };
  data["startDate"] = _data.startDate && formatDate(_data.startDate);
  data["endDate"] = _data.endDate && formatDate(_data.endDate);
  return data as UpdateNoteDto;
}
export interface MeasurementMappingDto  {
  id: number;
  sourceName: string;
  fieldId: number;
  comment: string | null;
  deviceModel: DeviceModel;
  measurementTypeId: number;
  isActive: boolean;
  isMandatory: boolean;
  isDefault: boolean;
  ignoreErrors: boolean;
}
export function deserializeMeasurementMappingDto(json: string): MeasurementMappingDto {
  const data = JSON.parse(json) as MeasurementMappingDto;
  initMeasurementMappingDto(data);
  return data;
}
export function initMeasurementMappingDto(_data: MeasurementMappingDto) {
  if (_data) {
    _data.deviceModel = _data["deviceModel"];
  }
  return _data;
}
export function serializeMeasurementMappingDto(_data: MeasurementMappingDto | undefined) {
  if (_data) {
    _data = prepareSerializeMeasurementMappingDto(_data as MeasurementMappingDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeMeasurementMappingDto(_data: MeasurementMappingDto): MeasurementMappingDto {
  const data: Record<string, any> = { ..._data };
  return data as MeasurementMappingDto;
}
/** 1 = MiniScreen */
export enum DeviceModel {
    MiniScreen = 1,
}
export interface CreateMeasurementMappingDto  {
  sourceName: string;
  comment: string | null;
  deviceModel: DeviceModel;
  measurementTypeId: number;
  fieldId: number;
  isActive: boolean;
  isMandatory: boolean;
  ignoreErrors: boolean;
}
export function deserializeCreateMeasurementMappingDto(json: string): CreateMeasurementMappingDto {
  const data = JSON.parse(json) as CreateMeasurementMappingDto;
  initCreateMeasurementMappingDto(data);
  return data;
}
export function initCreateMeasurementMappingDto(_data: CreateMeasurementMappingDto) {
  if (_data) {
    _data.deviceModel = _data["deviceModel"];
  }
  return _data;
}
export function serializeCreateMeasurementMappingDto(_data: CreateMeasurementMappingDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateMeasurementMappingDto(_data as CreateMeasurementMappingDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateMeasurementMappingDto(_data: CreateMeasurementMappingDto): CreateMeasurementMappingDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateMeasurementMappingDto;
}
export interface UpdateMeasurementMappingDto  {
  sourceName: string;
  comment: string | null;
  isActive: boolean;
  isMandatory: boolean;
  ignoreErrors: boolean;
}
export function deserializeUpdateMeasurementMappingDto(json: string): UpdateMeasurementMappingDto {
  const data = JSON.parse(json) as UpdateMeasurementMappingDto;
  initUpdateMeasurementMappingDto(data);
  return data;
}
export function initUpdateMeasurementMappingDto(_data: UpdateMeasurementMappingDto) {
    return _data;
}
export function serializeUpdateMeasurementMappingDto(_data: UpdateMeasurementMappingDto | undefined) {
  if (_data) {
    _data = prepareSerializeUpdateMeasurementMappingDto(_data as UpdateMeasurementMappingDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUpdateMeasurementMappingDto(_data: UpdateMeasurementMappingDto): UpdateMeasurementMappingDto {
  const data: Record<string, any> = { ..._data };
  return data as UpdateMeasurementMappingDto;
}
export interface DocumentMailSettingsDto  {
  enabled: boolean;
  notificationSubject: string;
  notificationTemplateId: number;
  isEncryptDocument: boolean;
  passwordExpression: string | null;
}
export function deserializeDocumentMailSettingsDto(json: string): DocumentMailSettingsDto {
  const data = JSON.parse(json) as DocumentMailSettingsDto;
  initDocumentMailSettingsDto(data);
  return data;
}
export function initDocumentMailSettingsDto(_data: DocumentMailSettingsDto) {
    return _data;
}
export function serializeDocumentMailSettingsDto(_data: DocumentMailSettingsDto | undefined) {
  if (_data) {
    _data = prepareSerializeDocumentMailSettingsDto(_data as DocumentMailSettingsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDocumentMailSettingsDto(_data: DocumentMailSettingsDto): DocumentMailSettingsDto {
  const data: Record<string, any> = { ..._data };
  return data as DocumentMailSettingsDto;
}
export interface DocumentMailSettingsPatchDto  {
  enabled?: boolean | null;
  notificationSubject?: string | null;
  notificationTemplateId?: number | null;
  isEncryptDocument?: boolean | null;
  passwordExpression?: string | null;
}
export function deserializeDocumentMailSettingsPatchDto(json: string): DocumentMailSettingsPatchDto {
  const data = JSON.parse(json) as DocumentMailSettingsPatchDto;
  initDocumentMailSettingsPatchDto(data);
  return data;
}
export function initDocumentMailSettingsPatchDto(_data: DocumentMailSettingsPatchDto) {
    return _data;
}
export function serializeDocumentMailSettingsPatchDto(_data: DocumentMailSettingsPatchDto | undefined) {
  if (_data) {
    _data = prepareSerializeDocumentMailSettingsPatchDto(_data as DocumentMailSettingsPatchDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDocumentMailSettingsPatchDto(_data: DocumentMailSettingsPatchDto): DocumentMailSettingsPatchDto {
  const data: Record<string, any> = { ..._data };
  return data as DocumentMailSettingsPatchDto;
}
export interface SmtpSubtenantSettingsDto  {
  host: string | null;
  port: number | null;
  username: string | null;
  fromName: string | null;
  fromAddress: string | null;
}
export function deserializeSmtpSubtenantSettingsDto(json: string): SmtpSubtenantSettingsDto {
  const data = JSON.parse(json) as SmtpSubtenantSettingsDto;
  initSmtpSubtenantSettingsDto(data);
  return data;
}
export function initSmtpSubtenantSettingsDto(_data: SmtpSubtenantSettingsDto) {
    return _data;
}
export function serializeSmtpSubtenantSettingsDto(_data: SmtpSubtenantSettingsDto | undefined) {
  if (_data) {
    _data = prepareSerializeSmtpSubtenantSettingsDto(_data as SmtpSubtenantSettingsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSmtpSubtenantSettingsDto(_data: SmtpSubtenantSettingsDto): SmtpSubtenantSettingsDto {
  const data: Record<string, any> = { ..._data };
  return data as SmtpSubtenantSettingsDto;
}
export interface SmtpSubtenantSettingsPatchDto  {
  host?: string | null;
  port?: number | null;
  username?: string | null;
  password?: string | null;
  fromName?: string | null;
  fromAddress?: string | null;
}
export function deserializeSmtpSubtenantSettingsPatchDto(json: string): SmtpSubtenantSettingsPatchDto {
  const data = JSON.parse(json) as SmtpSubtenantSettingsPatchDto;
  initSmtpSubtenantSettingsPatchDto(data);
  return data;
}
export function initSmtpSubtenantSettingsPatchDto(_data: SmtpSubtenantSettingsPatchDto) {
    return _data;
}
export function serializeSmtpSubtenantSettingsPatchDto(_data: SmtpSubtenantSettingsPatchDto | undefined) {
  if (_data) {
    _data = prepareSerializeSmtpSubtenantSettingsPatchDto(_data as SmtpSubtenantSettingsPatchDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSmtpSubtenantSettingsPatchDto(_data: SmtpSubtenantSettingsPatchDto): SmtpSubtenantSettingsPatchDto {
  const data: Record<string, any> = { ..._data };
  return data as SmtpSubtenantSettingsPatchDto;
}
export interface VisitMailSettingsDto  {
  enabled: boolean;
  visitNotificationSubject: string;
  visitNotificationTemplateId: number;
  visitNotificationDaysBeforeNotify: number;
  visitNotificationRunJobAtInMillsAfterMidnight: number;
}
export function deserializeVisitMailSettingsDto(json: string): VisitMailSettingsDto {
  const data = JSON.parse(json) as VisitMailSettingsDto;
  initVisitMailSettingsDto(data);
  return data;
}
export function initVisitMailSettingsDto(_data: VisitMailSettingsDto) {
    return _data;
}
export function serializeVisitMailSettingsDto(_data: VisitMailSettingsDto | undefined) {
  if (_data) {
    _data = prepareSerializeVisitMailSettingsDto(_data as VisitMailSettingsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeVisitMailSettingsDto(_data: VisitMailSettingsDto): VisitMailSettingsDto {
  const data: Record<string, any> = { ..._data };
  return data as VisitMailSettingsDto;
}
export interface VisitMailSettingsPatchDto  {
  enabled?: boolean | null;
  visitNotificationSubject?: string | null;
  visitNotificationTemplateId?: number | null;
  visitNotificationDaysBeforeNotify?: number | null;
  visitNotificationRunJobAtInMillsAfterMidnight?: number | null;
}
export function deserializeVisitMailSettingsPatchDto(json: string): VisitMailSettingsPatchDto {
  const data = JSON.parse(json) as VisitMailSettingsPatchDto;
  initVisitMailSettingsPatchDto(data);
  return data;
}
export function initVisitMailSettingsPatchDto(_data: VisitMailSettingsPatchDto) {
    return _data;
}
export function serializeVisitMailSettingsPatchDto(_data: VisitMailSettingsPatchDto | undefined) {
  if (_data) {
    _data = prepareSerializeVisitMailSettingsPatchDto(_data as VisitMailSettingsPatchDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeVisitMailSettingsPatchDto(_data: VisitMailSettingsPatchDto): VisitMailSettingsPatchDto {
  const data: Record<string, any> = { ..._data };
  return data as VisitMailSettingsPatchDto;
}
export interface InputTemplateDto  {
  id: number;
  name: string;
  value: string;
}
export function deserializeInputTemplateDto(json: string): InputTemplateDto {
  const data = JSON.parse(json) as InputTemplateDto;
  initInputTemplateDto(data);
  return data;
}
export function initInputTemplateDto(_data: InputTemplateDto) {
    return _data;
}
export function serializeInputTemplateDto(_data: InputTemplateDto | undefined) {
  if (_data) {
    _data = prepareSerializeInputTemplateDto(_data as InputTemplateDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeInputTemplateDto(_data: InputTemplateDto): InputTemplateDto {
  const data: Record<string, any> = { ..._data };
  return data as InputTemplateDto;
}
/** 0 = DataBlock 1 = Document */
export enum InputTemplateType {
    DataBlock = 0,
    Document = 1,
}
export interface PatchInputTemplateDto  {
  name?: string | null;
  value?: string | null;
}
export function deserializePatchInputTemplateDto(json: string): PatchInputTemplateDto {
  const data = JSON.parse(json) as PatchInputTemplateDto;
  initPatchInputTemplateDto(data);
  return data;
}
export function initPatchInputTemplateDto(_data: PatchInputTemplateDto) {
    return _data;
}
export function serializePatchInputTemplateDto(_data: PatchInputTemplateDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchInputTemplateDto(_data as PatchInputTemplateDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchInputTemplateDto(_data: PatchInputTemplateDto): PatchInputTemplateDto {
  const data: Record<string, any> = { ..._data };
  return data as PatchInputTemplateDto;
}
export interface CreateInputTemplateDto  {
  name: string;
  value: string;
  type: InputTemplateType;
  subtenantId: number;
  dataBlockFieldId: number | null;
}
export function deserializeCreateInputTemplateDto(json: string): CreateInputTemplateDto {
  const data = JSON.parse(json) as CreateInputTemplateDto;
  initCreateInputTemplateDto(data);
  return data;
}
export function initCreateInputTemplateDto(_data: CreateInputTemplateDto) {
  if (_data) {
    _data.type = _data["type"];
  }
  return _data;
}
export function serializeCreateInputTemplateDto(_data: CreateInputTemplateDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateInputTemplateDto(_data as CreateInputTemplateDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateInputTemplateDto(_data: CreateInputTemplateDto): CreateInputTemplateDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateInputTemplateDto;
}
export interface FileInfoDto  {
  id: string;
  /** Id of a latest Draft for this file.
Only present for files with Type == Document */
  draftId: string | null;
  name: string;
  type: FileType;
  comment: string;
  uploadDateTime: Date;
  patientId: number | null;
  caseId: number | null;
  visitId: number | null;
  dataBlockId: number | null;
  importId: string;
  values?: any | null;
  authorId: string;
  templateId: number | null;
  groupId: string;
  versionNumber: number;
  isDeleted: boolean;
  transportInfo: FileTransportInfoDto | null;
}
export function deserializeFileInfoDto(json: string): FileInfoDto {
  const data = JSON.parse(json) as FileInfoDto;
  initFileInfoDto(data);
  return data;
}
export function initFileInfoDto(_data: FileInfoDto) {
  if (_data) {
    _data.type = _data["type"];
    _data.uploadDateTime = _data["uploadDateTime"] ? new Date(_data["uploadDateTime"].toString()) : <any>null;
    _data.values = _data["values"];
    _data.transportInfo = _data["transportInfo"] && initFileTransportInfoDto(_data["transportInfo"]);
  }
  return _data;
}
export function serializeFileInfoDto(_data: FileInfoDto | undefined) {
  if (_data) {
    _data = prepareSerializeFileInfoDto(_data as FileInfoDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeFileInfoDto(_data: FileInfoDto): FileInfoDto {
  const data: Record<string, any> = { ..._data };
  data["uploadDateTime"] = _data.uploadDateTime && _data.uploadDateTime.toISOString();
  data["transportInfo"] = _data.transportInfo && prepareSerializeFileTransportInfoDto(_data.transportInfo);
  return data as FileInfoDto;
}
/** 0 = Undefined 1 = DeviceReport 2 = Sdbdata 3 = Document 4 = External 5 = DocumentDraft */
export enum FileType {
    Undefined = 0,
    DeviceReport = 1,
    Sdbdata = 2,
    Document = 3,
    External = 4,
    DocumentDraft = 5,
}
export interface FileTransportInfoDto  {
  hL7: TransportChannelStatusDto | null;
  gdt: TransportChannelStatusDto | null;
  email: TransportChannelStatusDto | null;
}
export function deserializeFileTransportInfoDto(json: string): FileTransportInfoDto {
  const data = JSON.parse(json) as FileTransportInfoDto;
  initFileTransportInfoDto(data);
  return data;
}
export function initFileTransportInfoDto(_data: FileTransportInfoDto) {
  if (_data) {
    _data.hL7 = _data["hL7"] && initTransportChannelStatusDto(_data["hL7"]);
    _data.gdt = _data["gdt"] && initTransportChannelStatusDto(_data["gdt"]);
    _data.email = _data["email"] && initTransportChannelStatusDto(_data["email"]);
  }
  return _data;
}
export function serializeFileTransportInfoDto(_data: FileTransportInfoDto | undefined) {
  if (_data) {
    _data = prepareSerializeFileTransportInfoDto(_data as FileTransportInfoDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeFileTransportInfoDto(_data: FileTransportInfoDto): FileTransportInfoDto {
  const data: Record<string, any> = { ..._data };
  data["hL7"] = _data.hL7 && prepareSerializeTransportChannelStatusDto(_data.hL7);
  data["gdt"] = _data.gdt && prepareSerializeTransportChannelStatusDto(_data.gdt);
  data["email"] = _data.email && prepareSerializeTransportChannelStatusDto(_data.email);
  return data as FileTransportInfoDto;
}
export interface TransportChannelStatusDto  {
  status: TransportMessageStatus | null;
  date: Date | null;
  errorMessage: string | null;
}
export function deserializeTransportChannelStatusDto(json: string): TransportChannelStatusDto {
  const data = JSON.parse(json) as TransportChannelStatusDto;
  initTransportChannelStatusDto(data);
  return data;
}
export function initTransportChannelStatusDto(_data: TransportChannelStatusDto) {
  if (_data) {
    _data.status = _data["status"];
    _data.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
  }
  return _data;
}
export function serializeTransportChannelStatusDto(_data: TransportChannelStatusDto | undefined) {
  if (_data) {
    _data = prepareSerializeTransportChannelStatusDto(_data as TransportChannelStatusDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeTransportChannelStatusDto(_data: TransportChannelStatusDto): TransportChannelStatusDto {
  const data: Record<string, any> = { ..._data };
  data["date"] = _data.date && _data.date.toISOString();
  return data as TransportChannelStatusDto;
}
export interface PatchFileDto  {
  comment?: string | null;
  name?: string;
  values?: any | null;
}
export function deserializePatchFileDto(json: string): PatchFileDto {
  const data = JSON.parse(json) as PatchFileDto;
  initPatchFileDto(data);
  return data;
}
export function initPatchFileDto(_data: PatchFileDto) {
  if (_data) {
    _data.values = _data["values"];
  }
  return _data;
}
export function serializePatchFileDto(_data: PatchFileDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchFileDto(_data as PatchFileDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchFileDto(_data: PatchFileDto): PatchFileDto {
  const data: Record<string, any> = { ..._data };
  return data as PatchFileDto;
}
export interface ContentDto  {
  content: string;
}
export function deserializeContentDto(json: string): ContentDto {
  const data = JSON.parse(json) as ContentDto;
  initContentDto(data);
  return data;
}
export function initContentDto(_data: ContentDto) {
    return _data;
}
export function serializeContentDto(_data: ContentDto | undefined) {
  if (_data) {
    _data = prepareSerializeContentDto(_data as ContentDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeContentDto(_data: ContentDto): ContentDto {
  const data: Record<string, any> = { ..._data };
  return data as ContentDto;
}
export interface DocumentTemplateRuleDto  {
  id: number;
  isActive: boolean;
  subtenantId: number;
  templateId: number;
  isOpeningAfterSaving: boolean;
  headerId: number | null;
  firstPageHeaderId: number | null;
  footerId: number | null;
  firstPageFooterId: number | null;
}
export function deserializeDocumentTemplateRuleDto(json: string): DocumentTemplateRuleDto {
  const data = JSON.parse(json) as DocumentTemplateRuleDto;
  initDocumentTemplateRuleDto(data);
  return data;
}
export function initDocumentTemplateRuleDto(_data: DocumentTemplateRuleDto) {
    return _data;
}
export function serializeDocumentTemplateRuleDto(_data: DocumentTemplateRuleDto | undefined) {
  if (_data) {
    _data = prepareSerializeDocumentTemplateRuleDto(_data as DocumentTemplateRuleDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDocumentTemplateRuleDto(_data: DocumentTemplateRuleDto): DocumentTemplateRuleDto {
  const data: Record<string, any> = { ..._data };
  return data as DocumentTemplateRuleDto;
}
export interface DocumentTemplateRuleListDto  {
  id: number;
  isActive: boolean;
  subtenantId: number;
  templateId: number;
  isOpeningAfterSaving: boolean;
  headerId: number | null;
  firstPageHeaderId: number | null;
  footerId: number | null;
  firstPageFooterId: number | null;
}
export function deserializeDocumentTemplateRuleListDto(json: string): DocumentTemplateRuleListDto {
  const data = JSON.parse(json) as DocumentTemplateRuleListDto;
  initDocumentTemplateRuleListDto(data);
  return data;
}
export function initDocumentTemplateRuleListDto(_data: DocumentTemplateRuleListDto) {
    return _data;
}
export function serializeDocumentTemplateRuleListDto(_data: DocumentTemplateRuleListDto | undefined) {
  if (_data) {
    _data = prepareSerializeDocumentTemplateRuleListDto(_data as DocumentTemplateRuleListDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDocumentTemplateRuleListDto(_data: DocumentTemplateRuleListDto): DocumentTemplateRuleListDto {
  const data: Record<string, any> = { ..._data };
  return data as DocumentTemplateRuleListDto;
}
export interface CreateTemplateRuleDto  {
  isActive: boolean;
  subtenantId: number;
  templateId: number;
  isOpeningAfterSaving: boolean;
  headerId?: number | null;
  firstPageHeaderId?: number | null;
  footerId?: number | null;
  firstPageFooterId?: number | null;
}
export function deserializeCreateTemplateRuleDto(json: string): CreateTemplateRuleDto {
  const data = JSON.parse(json) as CreateTemplateRuleDto;
  initCreateTemplateRuleDto(data);
  return data;
}
export function initCreateTemplateRuleDto(_data: CreateTemplateRuleDto) {
    return _data;
}
export function serializeCreateTemplateRuleDto(_data: CreateTemplateRuleDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateTemplateRuleDto(_data as CreateTemplateRuleDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateTemplateRuleDto(_data: CreateTemplateRuleDto): CreateTemplateRuleDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateTemplateRuleDto;
}
export interface PatchTemplateRuleDto  {
  isActive?: boolean | null;
  headerId?: number | null;
  firstPageHeaderId?: number | null;
  footerId?: number | null;
  firstPageFooterId?: number | null;
  isOpeningAfterSaving?: boolean | null;
}
export function deserializePatchTemplateRuleDto(json: string): PatchTemplateRuleDto {
  const data = JSON.parse(json) as PatchTemplateRuleDto;
  initPatchTemplateRuleDto(data);
  return data;
}
export function initPatchTemplateRuleDto(_data: PatchTemplateRuleDto) {
    return _data;
}
export function serializePatchTemplateRuleDto(_data: PatchTemplateRuleDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchTemplateRuleDto(_data as PatchTemplateRuleDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchTemplateRuleDto(_data: PatchTemplateRuleDto): PatchTemplateRuleDto {
  const data: Record<string, any> = { ..._data };
  return data as PatchTemplateRuleDto;
}
export interface MergeFieldDto  {
  id: number;
  name: string;
  expression: string;
  code: number;
  prefix: string;
  isDefault: boolean;
  isInterpretationsActive: boolean;
  defaultInterpretationEntry: string | null;
  interpretations?: MergeFieldInterpretation[] | null;
}
export function deserializeMergeFieldDto(json: string): MergeFieldDto {
  const data = JSON.parse(json) as MergeFieldDto;
  initMergeFieldDto(data);
  return data;
}
export function initMergeFieldDto(_data: MergeFieldDto) {
  if (_data) {
    if (Array.isArray(_data["interpretations"])) {
      _data.interpretations = _data["interpretations"].map(item => 
        initMergeFieldInterpretation(item)
      );
    }
  }
  return _data;
}
export function serializeMergeFieldDto(_data: MergeFieldDto | undefined) {
  if (_data) {
    _data = prepareSerializeMergeFieldDto(_data as MergeFieldDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeMergeFieldDto(_data: MergeFieldDto): MergeFieldDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.interpretations)) {
    data["interpretations"] = _data.interpretations.map(item => 
        prepareSerializeMergeFieldInterpretation(item)
    );
  }
  return data as MergeFieldDto;
}
export interface MergeFieldInterpretation  {
  position: number;
  condition: ConditionType;
  value: number | null;
  minValue: number | null;
  maxValue: number | null;
  entry: string;
}
export function deserializeMergeFieldInterpretation(json: string): MergeFieldInterpretation {
  const data = JSON.parse(json) as MergeFieldInterpretation;
  initMergeFieldInterpretation(data);
  return data;
}
export function initMergeFieldInterpretation(_data: MergeFieldInterpretation) {
  if (_data) {
    _data.condition = _data["condition"];
  }
  return _data;
}
export function serializeMergeFieldInterpretation(_data: MergeFieldInterpretation | undefined) {
  if (_data) {
    _data = prepareSerializeMergeFieldInterpretation(_data as MergeFieldInterpretation);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeMergeFieldInterpretation(_data: MergeFieldInterpretation): MergeFieldInterpretation {
  const data: Record<string, any> = { ..._data };
  return data as MergeFieldInterpretation;
}
/** 0 = Equal 1 = Greater 2 = GreaterOrEqual 3 = Less 4 = LessOrEqual 5 = NotEqual 6 = GreaterOrEqualAndLess 7 = GreaterOrEqualAndLessOrEqual 8 = GreaterAndLessOrEqual 9 = GreaterAndLess */
export enum ConditionType {
    Equal = 0,
    Greater = 1,
    GreaterOrEqual = 2,
    Less = 3,
    LessOrEqual = 4,
    NotEqual = 5,
    GreaterOrEqualAndLess = 6,
    GreaterOrEqualAndLessOrEqual = 7,
    GreaterAndLessOrEqual = 8,
    GreaterAndLess = 9,
}
export interface UpdateMergeFieldDto  {
  /** Name of a MergeField */
  name?: string | null;
  /** Expression to select a certain value from Query.
E.g.: `Patient.FirstName` */
  expression?: string | null;
  code?: number | null;
  isInterpretationsActive?: boolean;
  defaultInterpretationEntry?: string | null;
  interpretations?: MergeFieldInterpretation[] | null;
}
export function deserializeUpdateMergeFieldDto(json: string): UpdateMergeFieldDto {
  const data = JSON.parse(json) as UpdateMergeFieldDto;
  initUpdateMergeFieldDto(data);
  return data;
}
export function initUpdateMergeFieldDto(_data: UpdateMergeFieldDto) {
  if (_data) {
    if (Array.isArray(_data["interpretations"])) {
      _data.interpretations = _data["interpretations"].map(item => 
        initMergeFieldInterpretation(item)
      );
    }
  }
  return _data;
}
export function serializeUpdateMergeFieldDto(_data: UpdateMergeFieldDto | undefined) {
  if (_data) {
    _data = prepareSerializeUpdateMergeFieldDto(_data as UpdateMergeFieldDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUpdateMergeFieldDto(_data: UpdateMergeFieldDto): UpdateMergeFieldDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.interpretations)) {
    data["interpretations"] = _data.interpretations.map(item => 
        prepareSerializeMergeFieldInterpretation(item)
    );
  }
  return data as UpdateMergeFieldDto;
}
export interface CreateMergeFieldDto  {
  code?: number | null;
  name: string;
  prefix: string;
  /** Expression to select a certain value from Query.
E.g.: `Patient.FirstName` */
  expression: string;
  isInterpretationsActive: boolean;
  defaultInterpretationEntry?: string | null;
  interpretations?: MergeFieldInterpretation[] | null;
}
export function deserializeCreateMergeFieldDto(json: string): CreateMergeFieldDto {
  const data = JSON.parse(json) as CreateMergeFieldDto;
  initCreateMergeFieldDto(data);
  return data;
}
export function initCreateMergeFieldDto(_data: CreateMergeFieldDto) {
  if (_data) {
    if (Array.isArray(_data["interpretations"])) {
      _data.interpretations = _data["interpretations"].map(item => 
        initMergeFieldInterpretation(item)
      );
    }
  }
  return _data;
}
export function serializeCreateMergeFieldDto(_data: CreateMergeFieldDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateMergeFieldDto(_data as CreateMergeFieldDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateMergeFieldDto(_data: CreateMergeFieldDto): CreateMergeFieldDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.interpretations)) {
    data["interpretations"] = _data.interpretations.map(item => 
        prepareSerializeMergeFieldInterpretation(item)
    );
  }
  return data as CreateMergeFieldDto;
}
export interface ImportMergeFieldDto  {
  name: string;
  code: number;
  prefix: string;
  /** Name of measurement type if it is measurement field */
  measurementTypeName?: string | null;
  /** Expression to select a certain value from Query.
E.g.: `Patient.FirstName` */
  expression: string;
}
export function deserializeImportMergeFieldDto(json: string): ImportMergeFieldDto {
  const data = JSON.parse(json) as ImportMergeFieldDto;
  initImportMergeFieldDto(data);
  return data;
}
export function initImportMergeFieldDto(_data: ImportMergeFieldDto) {
    return _data;
}
export function serializeImportMergeFieldDto(_data: ImportMergeFieldDto | undefined) {
  if (_data) {
    _data = prepareSerializeImportMergeFieldDto(_data as ImportMergeFieldDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeImportMergeFieldDto(_data: ImportMergeFieldDto): ImportMergeFieldDto {
  const data: Record<string, any> = { ..._data };
  return data as ImportMergeFieldDto;
}
export interface DocumentQueryDto  {
  queryIdentifier: MergeFieldQueryDto;
  queryFields: DocumentQueryFieldDto[];
}
export function deserializeDocumentQueryDto(json: string): DocumentQueryDto {
  const data = JSON.parse(json) as DocumentQueryDto;
  initDocumentQueryDto(data);
  return data;
}
export function initDocumentQueryDto(_data: DocumentQueryDto) {
  if (_data) {
    _data.queryIdentifier = _data["queryIdentifier"] && initMergeFieldQueryDto(_data["queryIdentifier"]);
    if (Array.isArray(_data["queryFields"])) {
      _data.queryFields = _data["queryFields"].map(item => 
        initDocumentQueryFieldDto(item)
      );
    }
  }
  return _data;
}
export function serializeDocumentQueryDto(_data: DocumentQueryDto | undefined) {
  if (_data) {
    _data = prepareSerializeDocumentQueryDto(_data as DocumentQueryDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDocumentQueryDto(_data: DocumentQueryDto): DocumentQueryDto {
  const data: Record<string, any> = { ..._data };
  data["queryIdentifier"] = _data.queryIdentifier && prepareSerializeMergeFieldQueryDto(_data.queryIdentifier);
  if (Array.isArray(_data.queryFields)) {
    data["queryFields"] = _data.queryFields.map(item => 
        prepareSerializeDocumentQueryFieldDto(item)
    );
  }
  return data as DocumentQueryDto;
}
export interface MergeFieldQueryDto  {
  /** Type of a Query this MergeField refers to */
  queryType: MergeFieldQueryType;
  /** Id of DataBlockType (if MergeFieldQueryType query is DataBlockQuery, null otherwise (e.g. PatientWithSharedCaseFieldsDocumentQuery)) */
  dataBlockTypeId: number | null;
  /** Ids of Visits (if selectedVisits function was used in Expression) */
  selectedVisits?: number[] | null;
}
export function deserializeMergeFieldQueryDto(json: string): MergeFieldQueryDto {
  const data = JSON.parse(json) as MergeFieldQueryDto;
  initMergeFieldQueryDto(data);
  return data;
}
export function initMergeFieldQueryDto(_data: MergeFieldQueryDto) {
  if (_data) {
    _data.queryType = _data["queryType"];
    _data.selectedVisits = _data["selectedVisits"];
  }
  return _data;
}
export function serializeMergeFieldQueryDto(_data: MergeFieldQueryDto | undefined) {
  if (_data) {
    _data = prepareSerializeMergeFieldQueryDto(_data as MergeFieldQueryDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeMergeFieldQueryDto(_data: MergeFieldQueryDto): MergeFieldQueryDto {
  const data: Record<string, any> = { ..._data };
  return data as MergeFieldQueryDto;
}
/** 2 = DataBlockQuery 3 = VisitQuery 4 = PatientQuery 5 = CaseQuery 6 = HL7Settings 7 = FileQuery 8 = GDTSettings */
export enum MergeFieldQueryType {
    DataBlockQuery = 2,
    VisitQuery = 3,
    PatientQuery = 4,
    CaseQuery = 5,
    HL7Settings = 6,
    FileQuery = 7,
    GDTSettings = 8,
}
export interface DocumentQueryFieldDto  {
  dataField: string;
  clrPropertyName: string;
  caption?: string | null;
  dataType: DataType;
  hideFromFilter: boolean;
  /** Contains JSON-serialized Dx FilterExpression, to be evaluated on DataSource of applied filters.
Expression will be evaluated on the client, and this field will only be shown if ShowCondition is true.
(needed for showing MeasurementFields only when appropriate MeasurementType is selected)
e.g. ['measurement.TypeId', '=', '3'] */
  showCondition?: any[] | null;
  possibleValues?: { [key: string]: any; };
  nestedFields?: DocumentQueryFieldDto[] | null;
  tableColumns?: DataBlockTableColumnDto[] | null;
}
export function deserializeDocumentQueryFieldDto(json: string): DocumentQueryFieldDto {
  const data = JSON.parse(json) as DocumentQueryFieldDto;
  initDocumentQueryFieldDto(data);
  return data;
}
export function initDocumentQueryFieldDto(_data: DocumentQueryFieldDto) {
  if (_data) {
    _data.dataType = _data["dataType"];
    _data.showCondition = _data["showCondition"];
    if (Array.isArray(_data["nestedFields"])) {
      _data.nestedFields = _data["nestedFields"].map(item => 
        initDocumentQueryFieldDto(item)
      );
    }
    if (Array.isArray(_data["tableColumns"])) {
      _data.tableColumns = _data["tableColumns"].map(item => 
        initDataBlockTableColumnDto(item)
      );
    }
  }
  return _data;
}
export function serializeDocumentQueryFieldDto(_data: DocumentQueryFieldDto | undefined) {
  if (_data) {
    _data = prepareSerializeDocumentQueryFieldDto(_data as DocumentQueryFieldDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDocumentQueryFieldDto(_data: DocumentQueryFieldDto): DocumentQueryFieldDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.nestedFields)) {
    data["nestedFields"] = _data.nestedFields.map(item => 
        prepareSerializeDocumentQueryFieldDto(item)
    );
  }
  if (Array.isArray(_data.tableColumns)) {
    data["tableColumns"] = _data.tableColumns.map(item => 
        prepareSerializeDataBlockTableColumnDto(item)
    );
  }
  return data as DocumentQueryFieldDto;
}
export interface DataBlockTableColumnDto  {
  id: number;
  name: string;
  dataType: DataType;
  dictionaryId: number | null;
  dictionaryColumnId: number | null;
  order: number;
  dictionaryColumnName?: string | null;
  /** Whether it's allowed to enter values not present in a Dictionary or not.
Only applicable to Fields with DataType of Dictionary.
Similar to IsOptionAllowed. */
  isOptionAllowed: boolean;
  /** Could be set for Boolean fields.
If true it means that only a single Row could have this column set to True
(basically we should show Radio Buttons instead of Checkboxes) */
  isSingleValue: boolean;
}
export function deserializeDataBlockTableColumnDto(json: string): DataBlockTableColumnDto {
  const data = JSON.parse(json) as DataBlockTableColumnDto;
  initDataBlockTableColumnDto(data);
  return data;
}
export function initDataBlockTableColumnDto(_data: DataBlockTableColumnDto) {
  if (_data) {
    _data.dataType = _data["dataType"];
  }
  return _data;
}
export function serializeDataBlockTableColumnDto(_data: DataBlockTableColumnDto | undefined) {
  if (_data) {
    _data = prepareSerializeDataBlockTableColumnDto(_data as DataBlockTableColumnDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDataBlockTableColumnDto(_data: DataBlockTableColumnDto): DataBlockTableColumnDto {
  const data: Record<string, any> = { ..._data };
  return data as DataBlockTableColumnDto;
}
export interface ExecuteQueryDto  {
  query: CreateMergeFieldQueryIdentifierDto;
  filter?: any | null;
  limit?: string | null;
  secondArgument?: any | null;
  patientId: number;
  caseId: number | null;
  visitId: number | null;
  dataBlockId: number | null;
}
export function deserializeExecuteQueryDto(json: string): ExecuteQueryDto {
  const data = JSON.parse(json) as ExecuteQueryDto;
  initExecuteQueryDto(data);
  return data;
}
export function initExecuteQueryDto(_data: ExecuteQueryDto) {
  if (_data) {
    _data.query = _data["query"] && initCreateMergeFieldQueryIdentifierDto(_data["query"]);
    _data.filter = _data["filter"];
    _data.secondArgument = _data["secondArgument"];
  }
  return _data;
}
export function serializeExecuteQueryDto(_data: ExecuteQueryDto | undefined) {
  if (_data) {
    _data = prepareSerializeExecuteQueryDto(_data as ExecuteQueryDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeExecuteQueryDto(_data: ExecuteQueryDto): ExecuteQueryDto {
  const data: Record<string, any> = { ..._data };
  data["query"] = _data.query && prepareSerializeCreateMergeFieldQueryIdentifierDto(_data.query);
  return data as ExecuteQueryDto;
}
export interface CreateMergeFieldQueryIdentifierDto  {
  /** Type of a Query this MergeField refers to */
  queryType: MergeFieldQueryType;
  /** Id of DataBlockType (if MergeFieldQueryType query is DataBlockQuery, null otherwise (e.g. PatientWithSharedCaseFieldsDocumentQuery)) */
  dataBlockTypeId: number | null;
  /** Ids of Visits (if selectedVisits function was used in Expression) */
  selectedVisits?: number[] | null;
}
export function deserializeCreateMergeFieldQueryIdentifierDto(json: string): CreateMergeFieldQueryIdentifierDto {
  const data = JSON.parse(json) as CreateMergeFieldQueryIdentifierDto;
  initCreateMergeFieldQueryIdentifierDto(data);
  return data;
}
export function initCreateMergeFieldQueryIdentifierDto(_data: CreateMergeFieldQueryIdentifierDto) {
  if (_data) {
    _data.queryType = _data["queryType"];
    _data.selectedVisits = _data["selectedVisits"];
  }
  return _data;
}
export function serializeCreateMergeFieldQueryIdentifierDto(_data: CreateMergeFieldQueryIdentifierDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateMergeFieldQueryIdentifierDto(_data as CreateMergeFieldQueryIdentifierDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateMergeFieldQueryIdentifierDto(_data: CreateMergeFieldQueryIdentifierDto): CreateMergeFieldQueryIdentifierDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateMergeFieldQueryIdentifierDto;
}
export interface MergeFieldPrefixSettingsDto  {
  prefixes?: string[];
}
export function deserializeMergeFieldPrefixSettingsDto(json: string): MergeFieldPrefixSettingsDto {
  const data = JSON.parse(json) as MergeFieldPrefixSettingsDto;
  initMergeFieldPrefixSettingsDto(data);
  return data;
}
export function initMergeFieldPrefixSettingsDto(_data: MergeFieldPrefixSettingsDto) {
  if (_data) {
    _data.prefixes = _data["prefixes"];
  }
  return _data;
}
export function serializeMergeFieldPrefixSettingsDto(_data: MergeFieldPrefixSettingsDto | undefined) {
  if (_data) {
    _data = prepareSerializeMergeFieldPrefixSettingsDto(_data as MergeFieldPrefixSettingsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeMergeFieldPrefixSettingsDto(_data: MergeFieldPrefixSettingsDto): MergeFieldPrefixSettingsDto {
  const data: Record<string, any> = { ..._data };
  return data as MergeFieldPrefixSettingsDto;
}
export interface CreateMergeFieldPrefixDto  {
  prefix: string;
}
export function deserializeCreateMergeFieldPrefixDto(json: string): CreateMergeFieldPrefixDto {
  const data = JSON.parse(json) as CreateMergeFieldPrefixDto;
  initCreateMergeFieldPrefixDto(data);
  return data;
}
export function initCreateMergeFieldPrefixDto(_data: CreateMergeFieldPrefixDto) {
    return _data;
}
export function serializeCreateMergeFieldPrefixDto(_data: CreateMergeFieldPrefixDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateMergeFieldPrefixDto(_data as CreateMergeFieldPrefixDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateMergeFieldPrefixDto(_data: CreateMergeFieldPrefixDto): CreateMergeFieldPrefixDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateMergeFieldPrefixDto;
}
export interface DoctorDto  {
  id: number;
  surname: string;
  name: string;
  titleId: number | null;
  titleOfLetter: string;
  clinicId: number | null;
  address: string;
  postcode: string;
  location: string;
  specialtyId: number | null;
  workPhone: string;
  fax: string;
  mobilePhone: string;
  email: string;
  cisId: string;
  active: boolean;
  isDeleted: boolean;
  resourceId: number | null;
}
export function deserializeDoctorDto(json: string): DoctorDto {
  const data = JSON.parse(json) as DoctorDto;
  initDoctorDto(data);
  return data;
}
export function initDoctorDto(_data: DoctorDto) {
    return _data;
}
export function serializeDoctorDto(_data: DoctorDto | undefined) {
  if (_data) {
    _data = prepareSerializeDoctorDto(_data as DoctorDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDoctorDto(_data: DoctorDto): DoctorDto {
  const data: Record<string, any> = { ..._data };
  return data as DoctorDto;
}
export interface PageableListDtoOfDoctorListDto  {
  totalCount: number;
  data: DoctorListDto[];
}
export function deserializePageableListDtoOfDoctorListDto(json: string): PageableListDtoOfDoctorListDto {
  const data = JSON.parse(json) as PageableListDtoOfDoctorListDto;
  initPageableListDtoOfDoctorListDto(data);
  return data;
}
export function initPageableListDtoOfDoctorListDto(_data: PageableListDtoOfDoctorListDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initDoctorListDto(item)
      );
    }
  }
  return _data;
}
export function serializePageableListDtoOfDoctorListDto(_data: PageableListDtoOfDoctorListDto | undefined) {
  if (_data) {
    _data = prepareSerializePageableListDtoOfDoctorListDto(_data as PageableListDtoOfDoctorListDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePageableListDtoOfDoctorListDto(_data: PageableListDtoOfDoctorListDto): PageableListDtoOfDoctorListDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeDoctorListDto(item)
    );
  }
  return data as PageableListDtoOfDoctorListDto;
}
export interface DoctorListDto  {
  id: number;
  surname: string;
  name?: string | null;
  workPhone?: string | null;
  email?: string | null;
  active: boolean;
  specialtyId?: number | null;
  importId?: string | null;
  isDeleted: boolean;
}
export function deserializeDoctorListDto(json: string): DoctorListDto {
  const data = JSON.parse(json) as DoctorListDto;
  initDoctorListDto(data);
  return data;
}
export function initDoctorListDto(_data: DoctorListDto) {
    return _data;
}
export function serializeDoctorListDto(_data: DoctorListDto | undefined) {
  if (_data) {
    _data = prepareSerializeDoctorListDto(_data as DoctorListDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDoctorListDto(_data: DoctorListDto): DoctorListDto {
  const data: Record<string, any> = { ..._data };
  return data as DoctorListDto;
}
/** 0 = Clinic 1 = External */
export enum DoctorType {
    Clinic = 0,
    External = 1,
}
export interface UpdateDoctorDto  {
  surname?: string | null;
  name?: string | null;
  titleId?: number | null;
  titleOfLetter?: string | null;
  clinicId?: number | null;
  address?: string | null;
  postcode?: string | null;
  location?: string | null;
  specialtyId?: number | null;
  workPhone?: string | null;
  fax?: string | null;
  mobilePhone?: string | null;
  email?: string | null;
  cisId?: string | null;
  active?: boolean;
}
export function deserializeUpdateDoctorDto(json: string): UpdateDoctorDto {
  const data = JSON.parse(json) as UpdateDoctorDto;
  initUpdateDoctorDto(data);
  return data;
}
export function initUpdateDoctorDto(_data: UpdateDoctorDto) {
    return _data;
}
export function serializeUpdateDoctorDto(_data: UpdateDoctorDto | undefined) {
  if (_data) {
    _data = prepareSerializeUpdateDoctorDto(_data as UpdateDoctorDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUpdateDoctorDto(_data: UpdateDoctorDto): UpdateDoctorDto {
  const data: Record<string, any> = { ..._data };
  return data as UpdateDoctorDto;
}
export interface CreateDoctorDto  {
  doctorType: DoctorType;
  surname: string;
  name?: string;
  titleId?: number | null;
  titleOfLetter?: string | null;
  mobilePhone?: string | null;
  workPhone?: string | null;
  email?: string | null;
  fax?: string | null;
  address?: string | null;
  location?: string | null;
  postcode?: string | null;
  specialtyId?: number | null;
  clinicId?: number | null;
  cisId?: string | null;
  active: boolean;
  importId?: string | null;
}
export function deserializeCreateDoctorDto(json: string): CreateDoctorDto {
  const data = JSON.parse(json) as CreateDoctorDto;
  initCreateDoctorDto(data);
  return data;
}
export function initCreateDoctorDto(_data: CreateDoctorDto) {
  if (_data) {
    _data.doctorType = _data["doctorType"];
  }
  return _data;
}
export function serializeCreateDoctorDto(_data: CreateDoctorDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateDoctorDto(_data as CreateDoctorDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateDoctorDto(_data: CreateDoctorDto): CreateDoctorDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateDoctorDto;
}
export interface DictionaryRecordDto  {
  id: number;
  value: string;
  isDeleted: boolean;
}
export function deserializeDictionaryRecordDto(json: string): DictionaryRecordDto {
  const data = JSON.parse(json) as DictionaryRecordDto;
  initDictionaryRecordDto(data);
  return data;
}
export function initDictionaryRecordDto(_data: DictionaryRecordDto) {
    return _data;
}
export function serializeDictionaryRecordDto(_data: DictionaryRecordDto | undefined) {
  if (_data) {
    _data = prepareSerializeDictionaryRecordDto(_data as DictionaryRecordDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDictionaryRecordDto(_data: DictionaryRecordDto): DictionaryRecordDto {
  const data: Record<string, any> = { ..._data };
  return data as DictionaryRecordDto;
}
export interface VisitTypeDto extends DictionaryRecordDto  {
  /** Specific start time in seconds since midnight if visit has specific start time */
  specificStartTimeInSecondsSinceMidnight: number | null;
  /** Default visit length for this visit type in seconds */
  defaultDurationInSeconds: number;
  isDefault: boolean;
}
export function deserializeVisitTypeDto(json: string): VisitTypeDto {
  const data = JSON.parse(json) as VisitTypeDto;
  initVisitTypeDto(data);
  return data;
}
export function initVisitTypeDto(_data: VisitTypeDto) {
  initDictionaryRecordDto(_data);
    return _data;
}
export function serializeVisitTypeDto(_data: VisitTypeDto | undefined) {
  if (_data) {
    _data = prepareSerializeVisitTypeDto(_data as VisitTypeDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeVisitTypeDto(_data: VisitTypeDto): VisitTypeDto {
  const data = prepareSerializeDictionaryRecordDto(_data as VisitTypeDto) as Record<string, any>;
  return data as VisitTypeDto;
}
export interface CreateVisitTypeDto  {
  value: string;
  defaultDurationInSeconds: number | null;
  specificStartTimeInSecondsSinceMidnight: number | null;
}
export function deserializeCreateVisitTypeDto(json: string): CreateVisitTypeDto {
  const data = JSON.parse(json) as CreateVisitTypeDto;
  initCreateVisitTypeDto(data);
  return data;
}
export function initCreateVisitTypeDto(_data: CreateVisitTypeDto) {
    return _data;
}
export function serializeCreateVisitTypeDto(_data: CreateVisitTypeDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateVisitTypeDto(_data as CreateVisitTypeDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateVisitTypeDto(_data: CreateVisitTypeDto): CreateVisitTypeDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateVisitTypeDto;
}
export interface PatchVisitTypeDto  {
  value?: string | null;
  defaultDurationInSeconds?: number | null;
  specificStartTimeInSecondsSinceMidnight?: number | null;
}
export function deserializePatchVisitTypeDto(json: string): PatchVisitTypeDto {
  const data = JSON.parse(json) as PatchVisitTypeDto;
  initPatchVisitTypeDto(data);
  return data;
}
export function initPatchVisitTypeDto(_data: PatchVisitTypeDto) {
    return _data;
}
export function serializePatchVisitTypeDto(_data: PatchVisitTypeDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchVisitTypeDto(_data as PatchVisitTypeDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchVisitTypeDto(_data: PatchVisitTypeDto): PatchVisitTypeDto {
  const data: Record<string, any> = { ..._data };
  return data as PatchVisitTypeDto;
}
export interface CreateDictionaryRecordDto  {
  value: string;
}
export function deserializeCreateDictionaryRecordDto(json: string): CreateDictionaryRecordDto {
  const data = JSON.parse(json) as CreateDictionaryRecordDto;
  initCreateDictionaryRecordDto(data);
  return data;
}
export function initCreateDictionaryRecordDto(_data: CreateDictionaryRecordDto) {
    return _data;
}
export function serializeCreateDictionaryRecordDto(_data: CreateDictionaryRecordDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateDictionaryRecordDto(_data as CreateDictionaryRecordDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateDictionaryRecordDto(_data: CreateDictionaryRecordDto): CreateDictionaryRecordDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateDictionaryRecordDto;
}
export interface CreateTagDto extends CreateDictionaryRecordDto  {
  value: string;
}
export function deserializeCreateTagDto(json: string): CreateTagDto {
  const data = JSON.parse(json) as CreateTagDto;
  initCreateTagDto(data);
  return data;
}
export function initCreateTagDto(_data: CreateTagDto) {
  initCreateDictionaryRecordDto(_data);
    return _data;
}
export function serializeCreateTagDto(_data: CreateTagDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateTagDto(_data as CreateTagDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateTagDto(_data: CreateTagDto): CreateTagDto {
  const data = prepareSerializeCreateDictionaryRecordDto(_data as CreateTagDto) as Record<string, any>;
  return data as CreateTagDto;
}
export interface UpdateDictionaryRecordDto  {
  value: string;
}
export function deserializeUpdateDictionaryRecordDto(json: string): UpdateDictionaryRecordDto {
  const data = JSON.parse(json) as UpdateDictionaryRecordDto;
  initUpdateDictionaryRecordDto(data);
  return data;
}
export function initUpdateDictionaryRecordDto(_data: UpdateDictionaryRecordDto) {
    return _data;
}
export function serializeUpdateDictionaryRecordDto(_data: UpdateDictionaryRecordDto | undefined) {
  if (_data) {
    _data = prepareSerializeUpdateDictionaryRecordDto(_data as UpdateDictionaryRecordDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUpdateDictionaryRecordDto(_data: UpdateDictionaryRecordDto): UpdateDictionaryRecordDto {
  const data: Record<string, any> = { ..._data };
  return data as UpdateDictionaryRecordDto;
}
export interface UpdateTagDto extends UpdateDictionaryRecordDto  {
  value: string;
}
export function deserializeUpdateTagDto(json: string): UpdateTagDto {
  const data = JSON.parse(json) as UpdateTagDto;
  initUpdateTagDto(data);
  return data;
}
export function initUpdateTagDto(_data: UpdateTagDto) {
  initUpdateDictionaryRecordDto(_data);
    return _data;
}
export function serializeUpdateTagDto(_data: UpdateTagDto | undefined) {
  if (_data) {
    _data = prepareSerializeUpdateTagDto(_data as UpdateTagDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUpdateTagDto(_data: UpdateTagDto): UpdateTagDto {
  const data = prepareSerializeUpdateDictionaryRecordDto(_data as UpdateTagDto) as Record<string, any>;
  return data as UpdateTagDto;
}
export interface OptionalSubtenantDictionaryRecordDto  {
  id: number;
  subtenantId: number | null;
  value: string;
  isDeleted: boolean;
}
export function deserializeOptionalSubtenantDictionaryRecordDto(json: string): OptionalSubtenantDictionaryRecordDto {
  const data = JSON.parse(json) as OptionalSubtenantDictionaryRecordDto;
  initOptionalSubtenantDictionaryRecordDto(data);
  return data;
}
export function initOptionalSubtenantDictionaryRecordDto(_data: OptionalSubtenantDictionaryRecordDto) {
    return _data;
}
export function serializeOptionalSubtenantDictionaryRecordDto(_data: OptionalSubtenantDictionaryRecordDto | undefined) {
  if (_data) {
    _data = prepareSerializeOptionalSubtenantDictionaryRecordDto(_data as OptionalSubtenantDictionaryRecordDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeOptionalSubtenantDictionaryRecordDto(_data: OptionalSubtenantDictionaryRecordDto): OptionalSubtenantDictionaryRecordDto {
  const data: Record<string, any> = { ..._data };
  return data as OptionalSubtenantDictionaryRecordDto;
}
export interface CreateOptionalSubtenantDictionaryRecordDto  {
  subtenantId?: number | null;
  value: string;
}
export function deserializeCreateOptionalSubtenantDictionaryRecordDto(json: string): CreateOptionalSubtenantDictionaryRecordDto {
  const data = JSON.parse(json) as CreateOptionalSubtenantDictionaryRecordDto;
  initCreateOptionalSubtenantDictionaryRecordDto(data);
  return data;
}
export function initCreateOptionalSubtenantDictionaryRecordDto(_data: CreateOptionalSubtenantDictionaryRecordDto) {
    return _data;
}
export function serializeCreateOptionalSubtenantDictionaryRecordDto(_data: CreateOptionalSubtenantDictionaryRecordDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateOptionalSubtenantDictionaryRecordDto(_data as CreateOptionalSubtenantDictionaryRecordDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateOptionalSubtenantDictionaryRecordDto(_data: CreateOptionalSubtenantDictionaryRecordDto): CreateOptionalSubtenantDictionaryRecordDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateOptionalSubtenantDictionaryRecordDto;
}
export interface UpdateOptionalSubtenantDictionaryRecordDto  {
  subtenantId?: number | null;
  value: string;
}
export function deserializeUpdateOptionalSubtenantDictionaryRecordDto(json: string): UpdateOptionalSubtenantDictionaryRecordDto {
  const data = JSON.parse(json) as UpdateOptionalSubtenantDictionaryRecordDto;
  initUpdateOptionalSubtenantDictionaryRecordDto(data);
  return data;
}
export function initUpdateOptionalSubtenantDictionaryRecordDto(_data: UpdateOptionalSubtenantDictionaryRecordDto) {
    return _data;
}
export function serializeUpdateOptionalSubtenantDictionaryRecordDto(_data: UpdateOptionalSubtenantDictionaryRecordDto | undefined) {
  if (_data) {
    _data = prepareSerializeUpdateOptionalSubtenantDictionaryRecordDto(_data as UpdateOptionalSubtenantDictionaryRecordDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUpdateOptionalSubtenantDictionaryRecordDto(_data: UpdateOptionalSubtenantDictionaryRecordDto): UpdateOptionalSubtenantDictionaryRecordDto {
  const data: Record<string, any> = { ..._data };
  return data as UpdateOptionalSubtenantDictionaryRecordDto;
}
export interface DataBlockDto  {
  id: number;
  visitId?: number | null;
  caseId?: number | null;
  patientId?: number | null;
  typeId: number;
  importId: string | null;
  tags: number[];
  begin?: Date | null;
  end?: Date | null;
  deviceModel?: DeviceModel | null;
  beginDateContainsTime?: boolean;
  isStatisticCompleted: boolean;
  valuesHash?: string | null;
}
export function deserializeDataBlockDto(json: string): DataBlockDto {
  const data = JSON.parse(json) as DataBlockDto;
  initDataBlockDto(data);
  return data;
}
export function initDataBlockDto(_data: DataBlockDto) {
  if (_data) {
    _data.tags = _data["tags"];
    _data.begin = _data["begin"] ? new Date(_data["begin"].toString()) : <any>null;
    _data.end = _data["end"] ? new Date(_data["end"].toString()) : <any>null;
    _data.deviceModel = _data["deviceModel"];
  }
  return _data;
}
export function serializeDataBlockDto(_data: DataBlockDto | undefined) {
  if (_data) {
    _data = prepareSerializeDataBlockDto(_data as DataBlockDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDataBlockDto(_data: DataBlockDto): DataBlockDto {
  const data: Record<string, any> = { ..._data };
  data["begin"] = _data.begin && _data.begin.toISOString();
  data["end"] = _data.end && _data.end.toISOString();
  return data as DataBlockDto;
}
export interface DataBlockWithValuesDto extends DataBlockDto  {
  values: any;
}
export function deserializeDataBlockWithValuesDto(json: string): DataBlockWithValuesDto {
  const data = JSON.parse(json) as DataBlockWithValuesDto;
  initDataBlockWithValuesDto(data);
  return data;
}
export function initDataBlockWithValuesDto(_data: DataBlockWithValuesDto) {
  initDataBlockDto(_data);
  if (_data) {
    _data.values = _data["values"];
  }
  return _data;
}
export function serializeDataBlockWithValuesDto(_data: DataBlockWithValuesDto | undefined) {
  if (_data) {
    _data = prepareSerializeDataBlockWithValuesDto(_data as DataBlockWithValuesDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDataBlockWithValuesDto(_data: DataBlockWithValuesDto): DataBlockWithValuesDto {
  const data = prepareSerializeDataBlockDto(_data as DataBlockWithValuesDto) as Record<string, any>;
  return data as DataBlockWithValuesDto;
}
export interface CreateDataBlockDto  {
  /** One of VisitId or CaseId must be set. */
  visitId?: number | null;
  /** One of VisitId or CaseId must be set. */
  caseId?: number | null;
  patientId?: number | null;
  typeId: number;
  deviceModel?: DeviceModel | null;
  values?: any;
  begin?: Date | null;
  end?: Date | null;
  importId?: string | null;
  /** If set will update case fields as well */
  updateCaseDto?: PatchCaseDto | null;
  /** If set will update visit fields as well. VisitId must be set, if this field is not null. */
  updateVisitDto?: PatchVisitDto | null;
  isStatisticCompleted?: boolean | null;
  valuesHash?: string | null;
}
export function deserializeCreateDataBlockDto(json: string): CreateDataBlockDto {
  const data = JSON.parse(json) as CreateDataBlockDto;
  initCreateDataBlockDto(data);
  return data;
}
export function initCreateDataBlockDto(_data: CreateDataBlockDto) {
  if (_data) {
    _data.deviceModel = _data["deviceModel"];
    _data.values = _data["values"];
    _data.begin = _data["begin"] ? new Date(_data["begin"].toString()) : <any>null;
    _data.end = _data["end"] ? new Date(_data["end"].toString()) : <any>null;
    _data.updateCaseDto = _data["updateCaseDto"] && initPatchCaseDto(_data["updateCaseDto"]);
    _data.updateVisitDto = _data["updateVisitDto"] && initPatchVisitDto(_data["updateVisitDto"]);
  }
  return _data;
}
export function serializeCreateDataBlockDto(_data: CreateDataBlockDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateDataBlockDto(_data as CreateDataBlockDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateDataBlockDto(_data: CreateDataBlockDto): CreateDataBlockDto {
  const data: Record<string, any> = { ..._data };
  data["begin"] = _data.begin && _data.begin.toISOString();
  data["end"] = _data.end && _data.end.toISOString();
  data["updateCaseDto"] = _data.updateCaseDto && prepareSerializePatchCaseDto(_data.updateCaseDto);
  data["updateVisitDto"] = _data.updateVisitDto && prepareSerializePatchVisitDto(_data.updateVisitDto);
  return data as CreateDataBlockDto;
}
export interface PatchCaseDto  {
  patientId?: number | null;
  number?: string | null;
  startDate?: Date | null;
  endDate?: Date | null;
  status?: CaseStatus;
  values?: any | null;
}
export function deserializePatchCaseDto(json: string): PatchCaseDto {
  const data = JSON.parse(json) as PatchCaseDto;
  initPatchCaseDto(data);
  return data;
}
export function initPatchCaseDto(_data: PatchCaseDto) {
  if (_data) {
    _data.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
    _data.endDate = _data["endDate"] ? parseDateOnly(_data["endDate"].toString()) : <any>null;
    _data.status = _data["status"];
    _data.values = _data["values"];
  }
  return _data;
}
export function serializePatchCaseDto(_data: PatchCaseDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchCaseDto(_data as PatchCaseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchCaseDto(_data: PatchCaseDto): PatchCaseDto {
  const data: Record<string, any> = { ..._data };
  data["startDate"] = _data.startDate && formatDate(_data.startDate);
  data["endDate"] = _data.endDate && formatDate(_data.endDate);
  return data as PatchCaseDto;
}
/** 0 = Undefined 1 = Normal 2 = Planned 3 = Canceled 4 = Completed */
export enum CaseStatus {
    Undefined = 0,
    Normal = 1,
    Planned = 2,
    Canceled = 3,
    Completed = 4,
}
export interface PatchVisitDto  {
  title?: string | null;
  note?: string | null;
  start?: Date | null;
  end?: Date | null;
  statusId?: AppointmentStatusCodes | null;
  isAllDay?: boolean;
  recurrenceRule?: string | null;
  resourceIds?: number[] | null;
  acceptConflict?: boolean | null;
  inWaitingList?: boolean;
  priority?: WaitingListPriority | null;
  caseId?: number | null;
  typeId?: number | null;
  attendingDoctorId?: number | null;
  number?: string | null;
  values?: any | null;
}
export function deserializePatchVisitDto(json: string): PatchVisitDto {
  const data = JSON.parse(json) as PatchVisitDto;
  initPatchVisitDto(data);
  return data;
}
export function initPatchVisitDto(_data: PatchVisitDto) {
  if (_data) {
    _data.start = _data["start"] ? new Date(_data["start"].toString()) : <any>null;
    _data.end = _data["end"] ? new Date(_data["end"].toString()) : <any>null;
    _data.statusId = _data["statusId"];
    _data.resourceIds = _data["resourceIds"];
    _data.priority = _data["priority"];
    _data.values = _data["values"];
  }
  return _data;
}
export function serializePatchVisitDto(_data: PatchVisitDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchVisitDto(_data as PatchVisitDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchVisitDto(_data: PatchVisitDto): PatchVisitDto {
  const data: Record<string, any> = { ..._data };
  data["start"] = _data.start && _data.start.toISOString();
  data["end"] = _data.end && _data.end.toISOString();
  return data as PatchVisitDto;
}
/** 0 = Undefined 1 = Planned 2 = Skipped 3 = Canceled 4 = Completed 5 = Confirmed */
export enum AppointmentStatusCodes {
    Undefined = 0,
    Planned = 1,
    Skipped = 2,
    Canceled = 3,
    Completed = 4,
    Confirmed = 5,
}
/** 10 = High 20 = Medium 30 = Low */
export enum WaitingListPriority {
    High = 10,
    Medium = 20,
    Low = 30,
}
export interface ReimportResultDto  {
  errors?: string[];
  isFinished: boolean;
}
export function deserializeReimportResultDto(json: string): ReimportResultDto {
  const data = JSON.parse(json) as ReimportResultDto;
  initReimportResultDto(data);
  return data;
}
export function initReimportResultDto(_data: ReimportResultDto) {
  if (_data) {
    _data.errors = _data["errors"];
  }
  return _data;
}
export function serializeReimportResultDto(_data: ReimportResultDto | undefined) {
  if (_data) {
    _data = prepareSerializeReimportResultDto(_data as ReimportResultDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeReimportResultDto(_data: ReimportResultDto): ReimportResultDto {
  const data: Record<string, any> = { ..._data };
  return data as ReimportResultDto;
}
export interface PageableListDtoOfDataBlockDto  {
  totalCount: number;
  data: DataBlockDto[];
}
export function deserializePageableListDtoOfDataBlockDto(json: string): PageableListDtoOfDataBlockDto {
  const data = JSON.parse(json) as PageableListDtoOfDataBlockDto;
  initPageableListDtoOfDataBlockDto(data);
  return data;
}
export function initPageableListDtoOfDataBlockDto(_data: PageableListDtoOfDataBlockDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initDataBlockDto(item)
      );
    }
  }
  return _data;
}
export function serializePageableListDtoOfDataBlockDto(_data: PageableListDtoOfDataBlockDto | undefined) {
  if (_data) {
    _data = prepareSerializePageableListDtoOfDataBlockDto(_data as PageableListDtoOfDataBlockDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePageableListDtoOfDataBlockDto(_data: PageableListDtoOfDataBlockDto): PageableListDtoOfDataBlockDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeDataBlockDto(item)
    );
  }
  return data as PageableListDtoOfDataBlockDto;
}
/** 1 = DeviceMeasurement 2 = Measurement 3 = Case 4 = Visit 5 = SharedFields 6 = Patient */
export enum DataBlockVariant {
    DeviceMeasurement = 1,
    Measurement = 2,
    Case = 3,
    Visit = 4,
    SharedFields = 5,
    Patient = 6,
}
export interface PageableListDtoOfDataBlockWithValuesDto  {
  totalCount: number;
  data: DataBlockWithValuesDto[];
}
export function deserializePageableListDtoOfDataBlockWithValuesDto(json: string): PageableListDtoOfDataBlockWithValuesDto {
  const data = JSON.parse(json) as PageableListDtoOfDataBlockWithValuesDto;
  initPageableListDtoOfDataBlockWithValuesDto(data);
  return data;
}
export function initPageableListDtoOfDataBlockWithValuesDto(_data: PageableListDtoOfDataBlockWithValuesDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initDataBlockWithValuesDto(item)
      );
    }
  }
  return _data;
}
export function serializePageableListDtoOfDataBlockWithValuesDto(_data: PageableListDtoOfDataBlockWithValuesDto | undefined) {
  if (_data) {
    _data = prepareSerializePageableListDtoOfDataBlockWithValuesDto(_data as PageableListDtoOfDataBlockWithValuesDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePageableListDtoOfDataBlockWithValuesDto(_data: PageableListDtoOfDataBlockWithValuesDto): PageableListDtoOfDataBlockWithValuesDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeDataBlockWithValuesDto(item)
    );
  }
  return data as PageableListDtoOfDataBlockWithValuesDto;
}
export interface UpdateDataBlockDto  {
  values: any;
  /** If set will update case fields as well. */
  updateCaseDto?: PatchCaseDto | null;
  /** If set will update visit fields as well. If set, Data Block must be attached to a visit, otherwise operation will fail. */
  updateVisitDto?: PatchVisitDto | null;
  isStatisticCompleted?: boolean | null;
  valuesHash?: string | null;
}
export function deserializeUpdateDataBlockDto(json: string): UpdateDataBlockDto {
  const data = JSON.parse(json) as UpdateDataBlockDto;
  initUpdateDataBlockDto(data);
  return data;
}
export function initUpdateDataBlockDto(_data: UpdateDataBlockDto) {
  if (_data) {
    _data.values = _data["values"];
    _data.updateCaseDto = _data["updateCaseDto"] && initPatchCaseDto(_data["updateCaseDto"]);
    _data.updateVisitDto = _data["updateVisitDto"] && initPatchVisitDto(_data["updateVisitDto"]);
  }
  return _data;
}
export function serializeUpdateDataBlockDto(_data: UpdateDataBlockDto | undefined) {
  if (_data) {
    _data = prepareSerializeUpdateDataBlockDto(_data as UpdateDataBlockDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUpdateDataBlockDto(_data: UpdateDataBlockDto): UpdateDataBlockDto {
  const data: Record<string, any> = { ..._data };
  data["updateCaseDto"] = _data.updateCaseDto && prepareSerializePatchCaseDto(_data.updateCaseDto);
  data["updateVisitDto"] = _data.updateVisitDto && prepareSerializePatchVisitDto(_data.updateVisitDto);
  return data as UpdateDataBlockDto;
}
export interface RemoveDataBlockDto  {
  includeSharedValues: boolean;
}
export function deserializeRemoveDataBlockDto(json: string): RemoveDataBlockDto {
  const data = JSON.parse(json) as RemoveDataBlockDto;
  initRemoveDataBlockDto(data);
  return data;
}
export function initRemoveDataBlockDto(_data: RemoveDataBlockDto) {
    return _data;
}
export function serializeRemoveDataBlockDto(_data: RemoveDataBlockDto | undefined) {
  if (_data) {
    _data = prepareSerializeRemoveDataBlockDto(_data as RemoveDataBlockDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeRemoveDataBlockDto(_data: RemoveDataBlockDto): RemoveDataBlockDto {
  const data: Record<string, any> = { ..._data };
  return data as RemoveDataBlockDto;
}
export interface DataBlockTypeDto  {
  id: number;
  value: string;
  label: string | null;
  variant: DataBlockVariant;
  isDeleted: boolean;
  isDeactivated: boolean;
  isAutoCreated: boolean;
  showStatistic: boolean;
  isOnlyOnePerCase: boolean;
  isOnlyOnePerVisit: boolean;
}
export function deserializeDataBlockTypeDto(json: string): DataBlockTypeDto {
  const data = JSON.parse(json) as DataBlockTypeDto;
  initDataBlockTypeDto(data);
  return data;
}
export function initDataBlockTypeDto(_data: DataBlockTypeDto) {
  if (_data) {
    _data.variant = _data["variant"];
  }
  return _data;
}
export function serializeDataBlockTypeDto(_data: DataBlockTypeDto | undefined) {
  if (_data) {
    _data = prepareSerializeDataBlockTypeDto(_data as DataBlockTypeDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDataBlockTypeDto(_data: DataBlockTypeDto): DataBlockTypeDto {
  const data: Record<string, any> = { ..._data };
  return data as DataBlockTypeDto;
}
export interface DataBlockTypeListDto  {
  id: number;
  value: string;
  label: string;
  variant: DataBlockVariant;
  isDefault: boolean;
  isUsed: boolean;
  /** If `true` we don't show it for new Block Types */
  isDeactivated: boolean;
  isAutoCreated: boolean;
  isOnlyOnePerCase: boolean;
  isOnlyOnePerVisit: boolean;
}
export function deserializeDataBlockTypeListDto(json: string): DataBlockTypeListDto {
  const data = JSON.parse(json) as DataBlockTypeListDto;
  initDataBlockTypeListDto(data);
  return data;
}
export function initDataBlockTypeListDto(_data: DataBlockTypeListDto) {
  if (_data) {
    _data.variant = _data["variant"];
  }
  return _data;
}
export function serializeDataBlockTypeListDto(_data: DataBlockTypeListDto | undefined) {
  if (_data) {
    _data = prepareSerializeDataBlockTypeListDto(_data as DataBlockTypeListDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDataBlockTypeListDto(_data: DataBlockTypeListDto): DataBlockTypeListDto {
  const data: Record<string, any> = { ..._data };
  return data as DataBlockTypeListDto;
}
export interface CreateDataBlockTypeDto  {
  value: string;
  variant: DataBlockVariant;
  label?: string | null;
}
export function deserializeCreateDataBlockTypeDto(json: string): CreateDataBlockTypeDto {
  const data = JSON.parse(json) as CreateDataBlockTypeDto;
  initCreateDataBlockTypeDto(data);
  return data;
}
export function initCreateDataBlockTypeDto(_data: CreateDataBlockTypeDto) {
  if (_data) {
    _data.variant = _data["variant"];
  }
  return _data;
}
export function serializeCreateDataBlockTypeDto(_data: CreateDataBlockTypeDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateDataBlockTypeDto(_data as CreateDataBlockTypeDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateDataBlockTypeDto(_data: CreateDataBlockTypeDto): CreateDataBlockTypeDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateDataBlockTypeDto;
}
export interface PatchDataBlockTypeDto  {
  value?: string | null;
  label?: string | null;
  isDeactivated?: boolean;
  isAutoCreated?: boolean;
  isOnlyOnePerCase?: boolean;
  isOnlyOnePerVisit?: boolean;
}
export function deserializePatchDataBlockTypeDto(json: string): PatchDataBlockTypeDto {
  const data = JSON.parse(json) as PatchDataBlockTypeDto;
  initPatchDataBlockTypeDto(data);
  return data;
}
export function initPatchDataBlockTypeDto(_data: PatchDataBlockTypeDto) {
    return _data;
}
export function serializePatchDataBlockTypeDto(_data: PatchDataBlockTypeDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchDataBlockTypeDto(_data as PatchDataBlockTypeDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchDataBlockTypeDto(_data: PatchDataBlockTypeDto): PatchDataBlockTypeDto {
  const data: Record<string, any> = { ..._data };
  return data as PatchDataBlockTypeDto;
}
export interface EditUIConfigDto  {
  value?: string | null;
  isDeactivated?: boolean;
  isAutoCreated?: boolean;
  isOnlyOnePerCase?: boolean;
  isOnlyOnePerVisit?: boolean;
  type?: UIConfigType;
  config?: string;
  showDetails?: boolean | null;
  showStatistic?: boolean | null;
  label?: string | null;
}
export function deserializeEditUIConfigDto(json: string): EditUIConfigDto {
  const data = JSON.parse(json) as EditUIConfigDto;
  initEditUIConfigDto(data);
  return data;
}
export function initEditUIConfigDto(_data: EditUIConfigDto) {
  if (_data) {
    _data.type = _data["type"];
  }
  return _data;
}
export function serializeEditUIConfigDto(_data: EditUIConfigDto | undefined) {
  if (_data) {
    _data = prepareSerializeEditUIConfigDto(_data as EditUIConfigDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeEditUIConfigDto(_data: EditUIConfigDto): EditUIConfigDto {
  const data: Record<string, any> = { ..._data };
  return data as EditUIConfigDto;
}
/** 1 = View 2 = Details 3 = Statistic */
export enum UIConfigType {
    View = 1,
    Details = 2,
    Statistic = 3,
}
export interface UIConfigDto  {
  view: string;
  details: string;
  statistic: string;
  showDetails: boolean;
  showStatistic: boolean;
}
export function deserializeUIConfigDto(json: string): UIConfigDto {
  const data = JSON.parse(json) as UIConfigDto;
  initUIConfigDto(data);
  return data;
}
export function initUIConfigDto(_data: UIConfigDto) {
    return _data;
}
export function serializeUIConfigDto(_data: UIConfigDto | undefined) {
  if (_data) {
    _data = prepareSerializeUIConfigDto(_data as UIConfigDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUIConfigDto(_data: UIConfigDto): UIConfigDto {
  const data: Record<string, any> = { ..._data };
  return data as UIConfigDto;
}
export interface UIConfigTypeDto  {
  type: UIConfigType;
}
export function deserializeUIConfigTypeDto(json: string): UIConfigTypeDto {
  const data = JSON.parse(json) as UIConfigTypeDto;
  initUIConfigTypeDto(data);
  return data;
}
export function initUIConfigTypeDto(_data: UIConfigTypeDto) {
  if (_data) {
    _data.type = _data["type"];
  }
  return _data;
}
export function serializeUIConfigTypeDto(_data: UIConfigTypeDto | undefined) {
  if (_data) {
    _data = prepareSerializeUIConfigTypeDto(_data as UIConfigTypeDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUIConfigTypeDto(_data: UIConfigTypeDto): UIConfigTypeDto {
  const data: Record<string, any> = { ..._data };
  return data as UIConfigTypeDto;
}
export interface UIConfigFieldDto  {
  fieldId: number;
  name: string;
  dataType: DataType;
}
export function deserializeUIConfigFieldDto(json: string): UIConfigFieldDto {
  const data = JSON.parse(json) as UIConfigFieldDto;
  initUIConfigFieldDto(data);
  return data;
}
export function initUIConfigFieldDto(_data: UIConfigFieldDto) {
  if (_data) {
    _data.dataType = _data["dataType"];
  }
  return _data;
}
export function serializeUIConfigFieldDto(_data: UIConfigFieldDto | undefined) {
  if (_data) {
    _data = prepareSerializeUIConfigFieldDto(_data as UIConfigFieldDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUIConfigFieldDto(_data: UIConfigFieldDto): UIConfigFieldDto {
  const data: Record<string, any> = { ..._data };
  return data as UIConfigFieldDto;
}
export interface DataBlockFieldDto  {
  id: number;
  name: string;
  dataType: DataType;
  dataBlockTypeId: number;
  dictionaryId: number | null;
  isDeactivated: boolean;
  isDefault: boolean;
  isSingleValue: boolean;
  isOptionAllowed: boolean;
  isBasedOnPrevious: boolean;
  tableColumns?: DataBlockTableColumnDto[] | null;
}
export function deserializeDataBlockFieldDto(json: string): DataBlockFieldDto {
  const data = JSON.parse(json) as DataBlockFieldDto;
  initDataBlockFieldDto(data);
  return data;
}
export function initDataBlockFieldDto(_data: DataBlockFieldDto) {
  if (_data) {
    _data.dataType = _data["dataType"];
    if (Array.isArray(_data["tableColumns"])) {
      _data.tableColumns = _data["tableColumns"].map(item => 
        initDataBlockTableColumnDto(item)
      );
    }
  }
  return _data;
}
export function serializeDataBlockFieldDto(_data: DataBlockFieldDto | undefined) {
  if (_data) {
    _data = prepareSerializeDataBlockFieldDto(_data as DataBlockFieldDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDataBlockFieldDto(_data: DataBlockFieldDto): DataBlockFieldDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.tableColumns)) {
    data["tableColumns"] = _data.tableColumns.map(item => 
        prepareSerializeDataBlockTableColumnDto(item)
    );
  }
  return data as DataBlockFieldDto;
}
export interface CreateDataBlockFieldDto  {
  name: string;
  dataType: DataType;
  dataBlockTypeId: number;
  dictionaryId: number | null;
  isOptionAllowed?: boolean;
  tableColumns?: CreateDataBlockTableColumnDto[] | null;
  isBasedOnPrevious?: boolean;
}
export function deserializeCreateDataBlockFieldDto(json: string): CreateDataBlockFieldDto {
  const data = JSON.parse(json) as CreateDataBlockFieldDto;
  initCreateDataBlockFieldDto(data);
  return data;
}
export function initCreateDataBlockFieldDto(_data: CreateDataBlockFieldDto) {
  if (_data) {
    _data.dataType = _data["dataType"];
    if (Array.isArray(_data["tableColumns"])) {
      _data.tableColumns = _data["tableColumns"].map(item => 
        initCreateDataBlockTableColumnDto(item)
      );
    }
  }
  return _data;
}
export function serializeCreateDataBlockFieldDto(_data: CreateDataBlockFieldDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateDataBlockFieldDto(_data as CreateDataBlockFieldDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateDataBlockFieldDto(_data: CreateDataBlockFieldDto): CreateDataBlockFieldDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.tableColumns)) {
    data["tableColumns"] = _data.tableColumns.map(item => 
        prepareSerializeCreateDataBlockTableColumnDto(item)
    );
  }
  return data as CreateDataBlockFieldDto;
}
export interface CreateDataBlockTableColumnDto  {
  /** If set, existing TableColumn definition will be updated.
If not set, new TableColumn will be created. */
  id: number | null;
  name: string;
  dataType: DataType;
  dictionaryId: number | null;
  dictionaryColumnId: number | null;
  /** Whether it's allowed to enter values not present in a Dictionary or not.
Only applicable to Fields with DataType of Dictionary.
Similar to IsOptionAllowed. */
  isOptionAllowed: boolean | null;
  /** Could be set for Boolean fields.
If true it means that only a single Row could have this column set to True
(basically we should show Radio Buttons instead of Checkboxes) */
  isSingleValue: boolean | null;
}
export function deserializeCreateDataBlockTableColumnDto(json: string): CreateDataBlockTableColumnDto {
  const data = JSON.parse(json) as CreateDataBlockTableColumnDto;
  initCreateDataBlockTableColumnDto(data);
  return data;
}
export function initCreateDataBlockTableColumnDto(_data: CreateDataBlockTableColumnDto) {
  if (_data) {
    _data.dataType = _data["dataType"];
  }
  return _data;
}
export function serializeCreateDataBlockTableColumnDto(_data: CreateDataBlockTableColumnDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateDataBlockTableColumnDto(_data as CreateDataBlockTableColumnDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateDataBlockTableColumnDto(_data: CreateDataBlockTableColumnDto): CreateDataBlockTableColumnDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateDataBlockTableColumnDto;
}
export interface RenameDataBlockFieldDto  {
  newName: string;
}
export function deserializeRenameDataBlockFieldDto(json: string): RenameDataBlockFieldDto {
  const data = JSON.parse(json) as RenameDataBlockFieldDto;
  initRenameDataBlockFieldDto(data);
  return data;
}
export function initRenameDataBlockFieldDto(_data: RenameDataBlockFieldDto) {
    return _data;
}
export function serializeRenameDataBlockFieldDto(_data: RenameDataBlockFieldDto | undefined) {
  if (_data) {
    _data = prepareSerializeRenameDataBlockFieldDto(_data as RenameDataBlockFieldDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeRenameDataBlockFieldDto(_data: RenameDataBlockFieldDto): RenameDataBlockFieldDto {
  const data: Record<string, any> = { ..._data };
  return data as RenameDataBlockFieldDto;
}
export interface DataBlockFieldListDto  {
  id: number;
  name: string;
  dataType: DataType;
  dataBlockTypeId: number;
  isDefault: boolean;
  isDeactivated: boolean;
  isOptionAllowed: boolean;
  isBasedOnPrevious: boolean;
  dictionaryId: number | null;
}
export function deserializeDataBlockFieldListDto(json: string): DataBlockFieldListDto {
  const data = JSON.parse(json) as DataBlockFieldListDto;
  initDataBlockFieldListDto(data);
  return data;
}
export function initDataBlockFieldListDto(_data: DataBlockFieldListDto) {
  if (_data) {
    _data.dataType = _data["dataType"];
  }
  return _data;
}
export function serializeDataBlockFieldListDto(_data: DataBlockFieldListDto | undefined) {
  if (_data) {
    _data = prepareSerializeDataBlockFieldListDto(_data as DataBlockFieldListDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDataBlockFieldListDto(_data: DataBlockFieldListDto): DataBlockFieldListDto {
  const data: Record<string, any> = { ..._data };
  return data as DataBlockFieldListDto;
}
export interface PatchDataBlockFieldDto  {
  isDeactivated?: boolean;
  isOptionAllowed?: boolean;
  isBasedOnPrevious?: boolean;
  tableColumns?: CreateDataBlockTableColumnDto[] | null;
}
export function deserializePatchDataBlockFieldDto(json: string): PatchDataBlockFieldDto {
  const data = JSON.parse(json) as PatchDataBlockFieldDto;
  initPatchDataBlockFieldDto(data);
  return data;
}
export function initPatchDataBlockFieldDto(_data: PatchDataBlockFieldDto) {
  if (_data) {
    if (Array.isArray(_data["tableColumns"])) {
      _data.tableColumns = _data["tableColumns"].map(item => 
        initCreateDataBlockTableColumnDto(item)
      );
    }
  }
  return _data;
}
export function serializePatchDataBlockFieldDto(_data: PatchDataBlockFieldDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchDataBlockFieldDto(_data as PatchDataBlockFieldDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchDataBlockFieldDto(_data: PatchDataBlockFieldDto): PatchDataBlockFieldDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.tableColumns)) {
    data["tableColumns"] = _data.tableColumns.map(item => 
        prepareSerializeCreateDataBlockTableColumnDto(item)
    );
  }
  return data as PatchDataBlockFieldDto;
}
export interface ConvertFieldToDictionaryDto  {
  dictionaryTitle: string;
}
export function deserializeConvertFieldToDictionaryDto(json: string): ConvertFieldToDictionaryDto {
  const data = JSON.parse(json) as ConvertFieldToDictionaryDto;
  initConvertFieldToDictionaryDto(data);
  return data;
}
export function initConvertFieldToDictionaryDto(_data: ConvertFieldToDictionaryDto) {
    return _data;
}
export function serializeConvertFieldToDictionaryDto(_data: ConvertFieldToDictionaryDto | undefined) {
  if (_data) {
    _data = prepareSerializeConvertFieldToDictionaryDto(_data as ConvertFieldToDictionaryDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeConvertFieldToDictionaryDto(_data: ConvertFieldToDictionaryDto): ConvertFieldToDictionaryDto {
  const data: Record<string, any> = { ..._data };
  return data as ConvertFieldToDictionaryDto;
}
export interface PageableListDtoOfDataBlockDictionaryItemDto  {
  totalCount: number;
  data: DataBlockDictionaryItemDto[];
}
export function deserializePageableListDtoOfDataBlockDictionaryItemDto(json: string): PageableListDtoOfDataBlockDictionaryItemDto {
  const data = JSON.parse(json) as PageableListDtoOfDataBlockDictionaryItemDto;
  initPageableListDtoOfDataBlockDictionaryItemDto(data);
  return data;
}
export function initPageableListDtoOfDataBlockDictionaryItemDto(_data: PageableListDtoOfDataBlockDictionaryItemDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initDataBlockDictionaryItemDto(item)
      );
    }
  }
  return _data;
}
export function serializePageableListDtoOfDataBlockDictionaryItemDto(_data: PageableListDtoOfDataBlockDictionaryItemDto | undefined) {
  if (_data) {
    _data = prepareSerializePageableListDtoOfDataBlockDictionaryItemDto(_data as PageableListDtoOfDataBlockDictionaryItemDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePageableListDtoOfDataBlockDictionaryItemDto(_data: PageableListDtoOfDataBlockDictionaryItemDto): PageableListDtoOfDataBlockDictionaryItemDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeDataBlockDictionaryItemDto(item)
    );
  }
  return data as PageableListDtoOfDataBlockDictionaryItemDto;
}
export interface DataBlockDictionaryItemDto  {
  id: number;
  value: string;
  isDeleted: boolean;
  dictionaryId: number;
  isDefault?: boolean | null;
  importId?: string | null;
  /** Custom values */
  values?: any | null;
  manualOrderPosition: number;
}
export function deserializeDataBlockDictionaryItemDto(json: string): DataBlockDictionaryItemDto {
  const data = JSON.parse(json) as DataBlockDictionaryItemDto;
  initDataBlockDictionaryItemDto(data);
  return data;
}
export function initDataBlockDictionaryItemDto(_data: DataBlockDictionaryItemDto) {
  if (_data) {
    _data.values = _data["values"];
  }
  return _data;
}
export function serializeDataBlockDictionaryItemDto(_data: DataBlockDictionaryItemDto | undefined) {
  if (_data) {
    _data = prepareSerializeDataBlockDictionaryItemDto(_data as DataBlockDictionaryItemDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDataBlockDictionaryItemDto(_data: DataBlockDictionaryItemDto): DataBlockDictionaryItemDto {
  const data: Record<string, any> = { ..._data };
  return data as DataBlockDictionaryItemDto;
}
export interface CreateDataBlockDictionaryItemDto  {
  value: string;
  dictionaryId: number;
  values?: any | null;
  importId?: string | null;
  /** Might be needed during import from 3rd party software (e.g. SDB) */
  isDeleted?: boolean | null;
  manualOrderPosition?: number | null;
}
export function deserializeCreateDataBlockDictionaryItemDto(json: string): CreateDataBlockDictionaryItemDto {
  const data = JSON.parse(json) as CreateDataBlockDictionaryItemDto;
  initCreateDataBlockDictionaryItemDto(data);
  return data;
}
export function initCreateDataBlockDictionaryItemDto(_data: CreateDataBlockDictionaryItemDto) {
  if (_data) {
    _data.values = _data["values"];
  }
  return _data;
}
export function serializeCreateDataBlockDictionaryItemDto(_data: CreateDataBlockDictionaryItemDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateDataBlockDictionaryItemDto(_data as CreateDataBlockDictionaryItemDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateDataBlockDictionaryItemDto(_data: CreateDataBlockDictionaryItemDto): CreateDataBlockDictionaryItemDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateDataBlockDictionaryItemDto;
}
export interface PatchDataBlockDictionaryItemDto  {
  value?: string | null;
  isDeleted?: boolean;
  values?: any | null;
  manualOrderPosition?: number | null;
}
export function deserializePatchDataBlockDictionaryItemDto(json: string): PatchDataBlockDictionaryItemDto {
  const data = JSON.parse(json) as PatchDataBlockDictionaryItemDto;
  initPatchDataBlockDictionaryItemDto(data);
  return data;
}
export function initPatchDataBlockDictionaryItemDto(_data: PatchDataBlockDictionaryItemDto) {
  if (_data) {
    _data.values = _data["values"];
  }
  return _data;
}
export function serializePatchDataBlockDictionaryItemDto(_data: PatchDataBlockDictionaryItemDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchDataBlockDictionaryItemDto(_data as PatchDataBlockDictionaryItemDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchDataBlockDictionaryItemDto(_data: PatchDataBlockDictionaryItemDto): PatchDataBlockDictionaryItemDto {
  const data: Record<string, any> = { ..._data };
  return data as PatchDataBlockDictionaryItemDto;
}
export interface DataBlockDictionaryDto  {
  id: number;
  title: string;
  isDeleted: boolean;
  /** If true it means that the source-of-truth for this dictionary items is in some other table (not DataBlockDictionaryItems).
E.g. VisitStatus, PatientTitle, etc.
All of them have their own tables with values */
  isExternal: boolean;
  isEditable: boolean;
  isDefault: boolean;
  isMandatory: boolean;
  /** If true, dictionary and its items cannot be modified */
  isReadOnly: boolean;
  importId?: string | null;
  columns: DataBlockDictionaryColumnDto[];
  manualOrdering: boolean;
}
export function deserializeDataBlockDictionaryDto(json: string): DataBlockDictionaryDto {
  const data = JSON.parse(json) as DataBlockDictionaryDto;
  initDataBlockDictionaryDto(data);
  return data;
}
export function initDataBlockDictionaryDto(_data: DataBlockDictionaryDto) {
  if (_data) {
    if (Array.isArray(_data["columns"])) {
      _data.columns = _data["columns"].map(item => 
        initDataBlockDictionaryColumnDto(item)
      );
    }
  }
  return _data;
}
export function serializeDataBlockDictionaryDto(_data: DataBlockDictionaryDto | undefined) {
  if (_data) {
    _data = prepareSerializeDataBlockDictionaryDto(_data as DataBlockDictionaryDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDataBlockDictionaryDto(_data: DataBlockDictionaryDto): DataBlockDictionaryDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.columns)) {
    data["columns"] = _data.columns.map(item => 
        prepareSerializeDataBlockDictionaryColumnDto(item)
    );
  }
  return data as DataBlockDictionaryDto;
}
export interface DataBlockDictionaryColumnDto  {
  id: number;
  title: string;
  dataType: DataType;
  required: boolean;
  isUnique: boolean;
  referenceDictionaryId: number | null;
}
export function deserializeDataBlockDictionaryColumnDto(json: string): DataBlockDictionaryColumnDto {
  const data = JSON.parse(json) as DataBlockDictionaryColumnDto;
  initDataBlockDictionaryColumnDto(data);
  return data;
}
export function initDataBlockDictionaryColumnDto(_data: DataBlockDictionaryColumnDto) {
  if (_data) {
    _data.dataType = _data["dataType"];
  }
  return _data;
}
export function serializeDataBlockDictionaryColumnDto(_data: DataBlockDictionaryColumnDto | undefined) {
  if (_data) {
    _data = prepareSerializeDataBlockDictionaryColumnDto(_data as DataBlockDictionaryColumnDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDataBlockDictionaryColumnDto(_data: DataBlockDictionaryColumnDto): DataBlockDictionaryColumnDto {
  const data: Record<string, any> = { ..._data };
  return data as DataBlockDictionaryColumnDto;
}
export interface CreateDataBlockDictionaryDto  {
  title: string;
  importId?: string | null;
  columns?: DataBlockDictionaryColumnCreateDto[] | null;
  manualOrdering?: boolean | null;
}
export function deserializeCreateDataBlockDictionaryDto(json: string): CreateDataBlockDictionaryDto {
  const data = JSON.parse(json) as CreateDataBlockDictionaryDto;
  initCreateDataBlockDictionaryDto(data);
  return data;
}
export function initCreateDataBlockDictionaryDto(_data: CreateDataBlockDictionaryDto) {
  if (_data) {
    if (Array.isArray(_data["columns"])) {
      _data.columns = _data["columns"].map(item => 
        initDataBlockDictionaryColumnCreateDto(item)
      );
    }
  }
  return _data;
}
export function serializeCreateDataBlockDictionaryDto(_data: CreateDataBlockDictionaryDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateDataBlockDictionaryDto(_data as CreateDataBlockDictionaryDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateDataBlockDictionaryDto(_data: CreateDataBlockDictionaryDto): CreateDataBlockDictionaryDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.columns)) {
    data["columns"] = _data.columns.map(item => 
        prepareSerializeDataBlockDictionaryColumnCreateDto(item)
    );
  }
  return data as CreateDataBlockDictionaryDto;
}
export interface DataBlockDictionaryColumnCreateDto  {
  /** If Id is null, new Column will be created */
  id: number | null;
  title: string;
  dataType: DataType;
  referenceDictionaryId: number | null;
  isUnique: boolean;
}
export function deserializeDataBlockDictionaryColumnCreateDto(json: string): DataBlockDictionaryColumnCreateDto {
  const data = JSON.parse(json) as DataBlockDictionaryColumnCreateDto;
  initDataBlockDictionaryColumnCreateDto(data);
  return data;
}
export function initDataBlockDictionaryColumnCreateDto(_data: DataBlockDictionaryColumnCreateDto) {
  if (_data) {
    _data.dataType = _data["dataType"];
  }
  return _data;
}
export function serializeDataBlockDictionaryColumnCreateDto(_data: DataBlockDictionaryColumnCreateDto | undefined) {
  if (_data) {
    _data = prepareSerializeDataBlockDictionaryColumnCreateDto(_data as DataBlockDictionaryColumnCreateDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDataBlockDictionaryColumnCreateDto(_data: DataBlockDictionaryColumnCreateDto): DataBlockDictionaryColumnCreateDto {
  const data: Record<string, any> = { ..._data };
  return data as DataBlockDictionaryColumnCreateDto;
}
export interface DataBlockDictionaryPatchDto  {
  title?: string | null;
  isDeleted?: boolean;
  columns?: DataBlockDictionaryColumnCreateDto[] | null;
  manualOrdering?: boolean | null;
}
export function deserializeDataBlockDictionaryPatchDto(json: string): DataBlockDictionaryPatchDto {
  const data = JSON.parse(json) as DataBlockDictionaryPatchDto;
  initDataBlockDictionaryPatchDto(data);
  return data;
}
export function initDataBlockDictionaryPatchDto(_data: DataBlockDictionaryPatchDto) {
  if (_data) {
    if (Array.isArray(_data["columns"])) {
      _data.columns = _data["columns"].map(item => 
        initDataBlockDictionaryColumnCreateDto(item)
      );
    }
  }
  return _data;
}
export function serializeDataBlockDictionaryPatchDto(_data: DataBlockDictionaryPatchDto | undefined) {
  if (_data) {
    _data = prepareSerializeDataBlockDictionaryPatchDto(_data as DataBlockDictionaryPatchDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDataBlockDictionaryPatchDto(_data: DataBlockDictionaryPatchDto): DataBlockDictionaryPatchDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.columns)) {
    data["columns"] = _data.columns.map(item => 
        prepareSerializeDataBlockDictionaryColumnCreateDto(item)
    );
  }
  return data as DataBlockDictionaryPatchDto;
}
export interface PageableListDtoOfCaseListDto  {
  totalCount: number;
  data: CaseListDto[];
}
export function deserializePageableListDtoOfCaseListDto(json: string): PageableListDtoOfCaseListDto {
  const data = JSON.parse(json) as PageableListDtoOfCaseListDto;
  initPageableListDtoOfCaseListDto(data);
  return data;
}
export function initPageableListDtoOfCaseListDto(_data: PageableListDtoOfCaseListDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initCaseListDto(item)
      );
    }
  }
  return _data;
}
export function serializePageableListDtoOfCaseListDto(_data: PageableListDtoOfCaseListDto | undefined) {
  if (_data) {
    _data = prepareSerializePageableListDtoOfCaseListDto(_data as PageableListDtoOfCaseListDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePageableListDtoOfCaseListDto(_data: PageableListDtoOfCaseListDto): PageableListDtoOfCaseListDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeCaseListDto(item)
    );
  }
  return data as PageableListDtoOfCaseListDto;
}
export interface CaseListDto  {
  id: number;
  patientId: number;
  /** Identifier of a case that is shown in UI to end-users */
  number: string;
  /** Source of the information about Number */
  numberSource: NumberSource;
  startDate: Date;
  endDate: Date | null;
  importId?: string | null;
  /** Based on `Values.Status` value.
Currently Completed and Canceled cases are considered 'closed', and you can't modify/add data blocks to them */
  isClosed: boolean;
  status: CaseStatus;
  /** Values are only included if IncludeValues is set in request DTO */
  values?: any | null;
}
export function deserializeCaseListDto(json: string): CaseListDto {
  const data = JSON.parse(json) as CaseListDto;
  initCaseListDto(data);
  return data;
}
export function initCaseListDto(_data: CaseListDto) {
  if (_data) {
    _data.numberSource = _data["numberSource"];
    _data.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
    _data.endDate = _data["endDate"] ? parseDateOnly(_data["endDate"].toString()) : <any>null;
    _data.status = _data["status"];
    _data.values = _data["values"];
  }
  return _data;
}
export function serializeCaseListDto(_data: CaseListDto | undefined) {
  if (_data) {
    _data = prepareSerializeCaseListDto(_data as CaseListDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCaseListDto(_data: CaseListDto): CaseListDto {
  const data: Record<string, any> = { ..._data };
  data["startDate"] = _data.startDate && formatDate(_data.startDate);
  data["endDate"] = _data.endDate && formatDate(_data.endDate);
  return data as CaseListDto;
}
export interface CaseDto  {
  /** Id of case entity */
  id: number;
  patientId: number;
  /** Identifier of a case that is shown in UI to end-users */
  number: string;
  /** Source of the information about Number */
  numberSource: NumberSource;
  startDate: Date;
  endDate: Date | null;
  values: any;
  /** Based on `Values.Status` value.
Currently Completed and Canceled cases are considered 'closed', and you can't modify/add data blocks to them */
  isClosed: boolean;
  status: CaseStatus;
}
export function deserializeCaseDto(json: string): CaseDto {
  const data = JSON.parse(json) as CaseDto;
  initCaseDto(data);
  return data;
}
export function initCaseDto(_data: CaseDto) {
  if (_data) {
    _data.numberSource = _data["numberSource"];
    _data.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
    _data.endDate = _data["endDate"] ? parseDateOnly(_data["endDate"].toString()) : <any>null;
    _data.values = _data["values"];
    _data.status = _data["status"];
  }
  return _data;
}
export function serializeCaseDto(_data: CaseDto | undefined) {
  if (_data) {
    _data = prepareSerializeCaseDto(_data as CaseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCaseDto(_data: CaseDto): CaseDto {
  const data: Record<string, any> = { ..._data };
  data["startDate"] = _data.startDate && formatDate(_data.startDate);
  data["endDate"] = _data.endDate && formatDate(_data.endDate);
  return data as CaseDto;
}
export interface CreateCaseDto  {
  patientId: number;
  number?: string | null;
  startDate: Date;
  endDate: Date | null;
  importId?: string | null;
  status?: CaseStatus | null;
  values?: any | null;
}
export function deserializeCreateCaseDto(json: string): CreateCaseDto {
  const data = JSON.parse(json) as CreateCaseDto;
  initCreateCaseDto(data);
  return data;
}
export function initCreateCaseDto(_data: CreateCaseDto) {
  if (_data) {
    _data.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
    _data.endDate = _data["endDate"] ? parseDateOnly(_data["endDate"].toString()) : <any>null;
    _data.status = _data["status"];
    _data.values = _data["values"];
  }
  return _data;
}
export function serializeCreateCaseDto(_data: CreateCaseDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateCaseDto(_data as CreateCaseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateCaseDto(_data: CreateCaseDto): CreateCaseDto {
  const data: Record<string, any> = { ..._data };
  data["startDate"] = _data.startDate && formatDate(_data.startDate);
  data["endDate"] = _data.endDate && formatDate(_data.endDate);
  return data as CreateCaseDto;
}
export interface CalendarConfigurationDto  {
  id: number;
  name: string;
  userId: string;
  /** Shared between all users */
  isShared: boolean;
  shownEventType: AppointmentType;
  defaultVisitTypeId: number;
  visitStartTimeInSeconds: number;
  timeSlotSearchTimeStepInMinutes: number;
  showAbsences: boolean;
  calendarType: CalendarType;
  weekDays?: DayOfWeek[];
  startOfDayInSecondsSinceMidnight: number | null;
  endOfDayInSecondsSinceMidnight: number | null;
  roundingType: RoundingType;
  isMultiDayVisitRounding: boolean;
  /** Calendar */
  isResourceViewCalendar: boolean;
  isFilterDisplayed: boolean;
  hasFilterByVisitTypes: boolean;
  visitTypes?: number[];
  hasFilterByPlaces: boolean;
  places?: number[];
  hasFilterBySpecialConditions: boolean;
  specialConditions?: number[];
  hasFilterBySubtenants: boolean;
  hasFilterByDoctors: boolean;
  subtenants?: number[];
  doctors?: number[];
  hasFilterByTags: boolean;
  tags?: number[];
  hasFilterByVisitStatuses: boolean;
  visitStatuses?: AppointmentStatusCodes[];
  isShowingPatients: boolean;
  isShowingWaitingList: boolean;
  miniCalendarType: MiniCalendarType;
  isShowingRoomOccupancy: boolean;
  isShowingSelectedRoomOccupancy: boolean;
  /** System configuration (not created by user) */
  isSystem: boolean;
  displayWeekNumber: boolean;
}
export function deserializeCalendarConfigurationDto(json: string): CalendarConfigurationDto {
  const data = JSON.parse(json) as CalendarConfigurationDto;
  initCalendarConfigurationDto(data);
  return data;
}
export function initCalendarConfigurationDto(_data: CalendarConfigurationDto) {
  if (_data) {
    _data.shownEventType = _data["shownEventType"];
    _data.calendarType = _data["calendarType"];
    _data.weekDays = _data["weekDays"];
    _data.roundingType = _data["roundingType"];
    _data.visitTypes = _data["visitTypes"];
    _data.places = _data["places"];
    _data.specialConditions = _data["specialConditions"];
    _data.subtenants = _data["subtenants"];
    _data.doctors = _data["doctors"];
    _data.tags = _data["tags"];
    _data.visitStatuses = _data["visitStatuses"];
    _data.miniCalendarType = _data["miniCalendarType"];
  }
  return _data;
}
export function serializeCalendarConfigurationDto(_data: CalendarConfigurationDto | undefined) {
  if (_data) {
    _data = prepareSerializeCalendarConfigurationDto(_data as CalendarConfigurationDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCalendarConfigurationDto(_data: CalendarConfigurationDto): CalendarConfigurationDto {
  const data: Record<string, any> = { ..._data };
  return data as CalendarConfigurationDto;
}
/** 0 = AllEvents 1 = Visit 2 = Meeting 3 = Absence */
export enum AppointmentType {
    AllEvents = 0,
    Visit = 1,
    Meeting = 2,
    Absence = 3,
}
/** 1 = Day 2 = Week 3 = Month */
export enum CalendarType {
    Day = 1,
    Week = 2,
    Month = 3,
}
/** 0 = None 1 = RoundingTo12Hours 2 = RoundingTo24Hours */
export enum RoundingType {
    None = 0,
    RoundingTo12Hours = 1,
    RoundingTo24Hours = 2,
}
/** 0 = None 1 = OneMonth 2 = ThreeMonth */
export enum MiniCalendarType {
    None = 0,
    OneMonth = 1,
    ThreeMonth = 2,
}
export interface CalendarConfigurationListDto  {
  id: number;
  name: string;
  userId: string;
  /** Shared between all users */
  isShared: boolean;
  /** System configuration (not created by user) */
  isSystem: boolean;
  /** Is pinned for current user */
  isPinned: boolean;
}
export function deserializeCalendarConfigurationListDto(json: string): CalendarConfigurationListDto {
  const data = JSON.parse(json) as CalendarConfigurationListDto;
  initCalendarConfigurationListDto(data);
  return data;
}
export function initCalendarConfigurationListDto(_data: CalendarConfigurationListDto) {
    return _data;
}
export function serializeCalendarConfigurationListDto(_data: CalendarConfigurationListDto | undefined) {
  if (_data) {
    _data = prepareSerializeCalendarConfigurationListDto(_data as CalendarConfigurationListDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCalendarConfigurationListDto(_data: CalendarConfigurationListDto): CalendarConfigurationListDto {
  const data: Record<string, any> = { ..._data };
  return data as CalendarConfigurationListDto;
}
export interface CreateCalendarConfigurationDto  {
  name: string;
  /** Configuration is shared between all users */
  isShared?: boolean | null;
  shownEventType?: AppointmentType;
  defaultVisitTypeId: number;
  visitStartTimeInSeconds: number;
  timeSlotSearchTimeStepInMinutes: number;
  calendarType?: CalendarType;
  weekDays?: DayOfWeek[];
  startOfDayInSecondsSinceMidnight?: number | null;
  endOfDayInSecondsSinceMidnight?: number | null;
  isResourceViewCalendar: boolean;
  roundingType: RoundingType;
  isMultiDayVisitRounding?: boolean | null;
  isFilterDisplayed: boolean;
  hasFilterByVisitTypes?: boolean | null;
  visitTypes?: number[];
  hasFilterByPlaces?: boolean | null;
  places?: number[];
  hasFilterBySpecialConditions?: boolean | null;
  specialConditions?: number[];
  hasFilterBySubtenants?: boolean | null;
  hasFilterByDoctors?: boolean | null;
  subtenants?: number[];
  doctors?: number[];
  hasFilterByTags?: boolean | null;
  tags?: number[];
  hasFilterByVisitStatuses?: boolean | null;
  visitStatuses?: AppointmentStatusCodes[];
  isShowingPatients: boolean;
  miniCalendarType: MiniCalendarType;
  isShowingRoomOccupancy?: boolean | null;
  isShowingSelectedRoomOccupancy?: boolean | null;
  isShowingWaitingList?: boolean;
  showAbsences?: boolean;
  displayWeekNumber?: boolean;
}
export function deserializeCreateCalendarConfigurationDto(json: string): CreateCalendarConfigurationDto {
  const data = JSON.parse(json) as CreateCalendarConfigurationDto;
  initCreateCalendarConfigurationDto(data);
  return data;
}
export function initCreateCalendarConfigurationDto(_data: CreateCalendarConfigurationDto) {
  if (_data) {
    _data.shownEventType = _data["shownEventType"];
    _data.calendarType = _data["calendarType"];
    _data.weekDays = _data["weekDays"];
    _data.roundingType = _data["roundingType"];
    _data.visitTypes = _data["visitTypes"];
    _data.places = _data["places"];
    _data.specialConditions = _data["specialConditions"];
    _data.subtenants = _data["subtenants"];
    _data.doctors = _data["doctors"];
    _data.tags = _data["tags"];
    _data.visitStatuses = _data["visitStatuses"];
    _data.miniCalendarType = _data["miniCalendarType"];
  }
  return _data;
}
export function serializeCreateCalendarConfigurationDto(_data: CreateCalendarConfigurationDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateCalendarConfigurationDto(_data as CreateCalendarConfigurationDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateCalendarConfigurationDto(_data: CreateCalendarConfigurationDto): CreateCalendarConfigurationDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateCalendarConfigurationDto;
}
export interface UpdateCalendarConfigurationDto  {
  name?: string;
  isShared?: boolean | null;
  shownEventType?: AppointmentType | null;
  defaultVisitTypeId?: number | null;
  visitStartTimeInSeconds?: number | null;
  timeSlotSearchTimeStepInMinutes?: number | null;
  calendarType?: CalendarType | null;
  weekDays?: DayOfWeek[] | null;
  startOfDayInSecondsSinceMidnight?: number | null;
  endOfDayInSecondsSinceMidnight?: number | null;
  isResourceViewCalendar?: boolean | null;
  roundingType?: RoundingType | null;
  isMultiDayVisitRounding?: boolean | null;
  isFilterDisplayed?: boolean | null;
  hasFilterByVisitTypes?: boolean | null;
  visitTypes?: number[] | null;
  hasFilterByPlaces?: boolean | null;
  places?: number[] | null;
  hasFilterBySpecialConditions?: boolean | null;
  specialConditions?: number[] | null;
  hasFilterBySubtenants?: boolean | null;
  hasFilterByDoctors?: boolean | null;
  subtenants?: number[] | null;
  doctors?: number[] | null;
  hasFilterByTags?: boolean | null;
  tags?: number[] | null;
  hasFilterByVisitStatuses?: boolean | null;
  visitStatuses?: AppointmentStatusCodes[] | null;
  isShowingPatients?: boolean | null;
  isShowingWaitingList?: boolean | null;
  miniCalendarType?: MiniCalendarType | null;
  isShowingRoomOccupancy?: boolean | null;
  isShowingSelectedRoomOccupancy?: boolean | null;
  showAbsences?: boolean | null;
  displayWeekNumber?: boolean | null;
}
export function deserializeUpdateCalendarConfigurationDto(json: string): UpdateCalendarConfigurationDto {
  const data = JSON.parse(json) as UpdateCalendarConfigurationDto;
  initUpdateCalendarConfigurationDto(data);
  return data;
}
export function initUpdateCalendarConfigurationDto(_data: UpdateCalendarConfigurationDto) {
  if (_data) {
    _data.shownEventType = _data["shownEventType"];
    _data.calendarType = _data["calendarType"];
    _data.weekDays = _data["weekDays"];
    _data.roundingType = _data["roundingType"];
    _data.visitTypes = _data["visitTypes"];
    _data.places = _data["places"];
    _data.specialConditions = _data["specialConditions"];
    _data.subtenants = _data["subtenants"];
    _data.doctors = _data["doctors"];
    _data.tags = _data["tags"];
    _data.visitStatuses = _data["visitStatuses"];
    _data.miniCalendarType = _data["miniCalendarType"];
  }
  return _data;
}
export function serializeUpdateCalendarConfigurationDto(_data: UpdateCalendarConfigurationDto | undefined) {
  if (_data) {
    _data = prepareSerializeUpdateCalendarConfigurationDto(_data as UpdateCalendarConfigurationDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUpdateCalendarConfigurationDto(_data: UpdateCalendarConfigurationDto): UpdateCalendarConfigurationDto {
  const data: Record<string, any> = { ..._data };
  return data as UpdateCalendarConfigurationDto;
}
export interface PinCalendarConfigurationDto  {
  isPinned: boolean;
}
export function deserializePinCalendarConfigurationDto(json: string): PinCalendarConfigurationDto {
  const data = JSON.parse(json) as PinCalendarConfigurationDto;
  initPinCalendarConfigurationDto(data);
  return data;
}
export function initPinCalendarConfigurationDto(_data: PinCalendarConfigurationDto) {
    return _data;
}
export function serializePinCalendarConfigurationDto(_data: PinCalendarConfigurationDto | undefined) {
  if (_data) {
    _data = prepareSerializePinCalendarConfigurationDto(_data as PinCalendarConfigurationDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePinCalendarConfigurationDto(_data: PinCalendarConfigurationDto): PinCalendarConfigurationDto {
  const data: Record<string, any> = { ..._data };
  return data as PinCalendarConfigurationDto;
}
export interface PageableListDtoOfAuditRecordDto  {
  totalCount: number;
  data: AuditRecordDto[];
}
export function deserializePageableListDtoOfAuditRecordDto(json: string): PageableListDtoOfAuditRecordDto {
  const data = JSON.parse(json) as PageableListDtoOfAuditRecordDto;
  initPageableListDtoOfAuditRecordDto(data);
  return data;
}
export function initPageableListDtoOfAuditRecordDto(_data: PageableListDtoOfAuditRecordDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initAuditRecordDto(item)
      );
    }
  }
  return _data;
}
export function serializePageableListDtoOfAuditRecordDto(_data: PageableListDtoOfAuditRecordDto | undefined) {
  if (_data) {
    _data = prepareSerializePageableListDtoOfAuditRecordDto(_data as PageableListDtoOfAuditRecordDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePageableListDtoOfAuditRecordDto(_data: PageableListDtoOfAuditRecordDto): PageableListDtoOfAuditRecordDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeAuditRecordDto(item)
    );
  }
  return data as PageableListDtoOfAuditRecordDto;
}
export interface AuditRecordDto  {
  id: number;
  tableName: string;
  patientId: number | null;
  patientName: string | null;
  dateTime: Date;
  rowKey: string;
  oldValues?: any | null;
  newValues?: any | null;
  state: AuditState;
  userId: string | null;
  userName: string | null;
}
export function deserializeAuditRecordDto(json: string): AuditRecordDto {
  const data = JSON.parse(json) as AuditRecordDto;
  initAuditRecordDto(data);
  return data;
}
export function initAuditRecordDto(_data: AuditRecordDto) {
  if (_data) {
    _data.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>null;
    _data.oldValues = _data["oldValues"];
    _data.newValues = _data["newValues"];
    _data.state = _data["state"];
  }
  return _data;
}
export function serializeAuditRecordDto(_data: AuditRecordDto | undefined) {
  if (_data) {
    _data = prepareSerializeAuditRecordDto(_data as AuditRecordDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAuditRecordDto(_data: AuditRecordDto): AuditRecordDto {
  const data: Record<string, any> = { ..._data };
  data["dateTime"] = _data.dateTime && _data.dateTime.toISOString();
  return data as AuditRecordDto;
}
/** 0 = Added 1 = Modified 2 = Deleted */
export enum AuditState {
    Added = 0,
    Modified = 1,
    Deleted = 2,
}
export interface VisitDto  {
  id: number;
  isDeleted: boolean;
  title: string;
  note: string;
  start: Date;
  end: Date;
  statusId: AppointmentStatusCodes;
  participants: AppointmentParticipantDto[];
  resourceIds: number[];
  patientId: number;
  patientName: string;
  isPrivateInsurance: boolean;
  isSelfPayer: boolean;
  typeId: number | null;
  caseId: number;
  importId?: string | null;
  subtenantId: number;
  attendingDoctorId?: number | null;
  inWaitingList: boolean;
  priority: WaitingListPriority | null;
  tags: number[];
  values: any;
  lastPatientNotificationDateTime: Date | null;
  number: string;
  numberSource: NumberSource;
}
export function deserializeVisitDto(json: string): VisitDto {
  const data = JSON.parse(json) as VisitDto;
  initVisitDto(data);
  return data;
}
export function initVisitDto(_data: VisitDto) {
  if (_data) {
    _data.start = _data["start"] ? new Date(_data["start"].toString()) : <any>null;
    _data.end = _data["end"] ? new Date(_data["end"].toString()) : <any>null;
    _data.statusId = _data["statusId"];
    if (Array.isArray(_data["participants"])) {
      _data.participants = _data["participants"].map(item => 
        initAppointmentParticipantDto(item)
      );
    }
    _data.resourceIds = _data["resourceIds"];
    _data.priority = _data["priority"];
    _data.tags = _data["tags"];
    _data.values = _data["values"];
    _data.lastPatientNotificationDateTime = _data["lastPatientNotificationDateTime"] ? new Date(_data["lastPatientNotificationDateTime"].toString()) : <any>null;
    _data.numberSource = _data["numberSource"];
  }
  return _data;
}
export function serializeVisitDto(_data: VisitDto | undefined) {
  if (_data) {
    _data = prepareSerializeVisitDto(_data as VisitDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeVisitDto(_data: VisitDto): VisitDto {
  const data: Record<string, any> = { ..._data };
  data["start"] = _data.start && _data.start.toISOString();
  data["end"] = _data.end && _data.end.toISOString();
  if (Array.isArray(_data.participants)) {
    data["participants"] = _data.participants.map(item => 
        prepareSerializeAppointmentParticipantDto(item)
    );
  }
  data["lastPatientNotificationDateTime"] = _data.lastPatientNotificationDateTime && _data.lastPatientNotificationDateTime.toISOString();
  return data as VisitDto;
}
export interface AppointmentParticipantDto  {
  participantId: number;
  participantType: ParticipantType;
}
export function deserializeAppointmentParticipantDto(json: string): AppointmentParticipantDto {
  const data = JSON.parse(json) as AppointmentParticipantDto;
  initAppointmentParticipantDto(data);
  return data;
}
export function initAppointmentParticipantDto(_data: AppointmentParticipantDto) {
  if (_data) {
    _data.participantType = _data["participantType"];
  }
  return _data;
}
export function serializeAppointmentParticipantDto(_data: AppointmentParticipantDto | undefined) {
  if (_data) {
    _data = prepareSerializeAppointmentParticipantDto(_data as AppointmentParticipantDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAppointmentParticipantDto(_data: AppointmentParticipantDto): AppointmentParticipantDto {
  const data: Record<string, any> = { ..._data };
  return data as AppointmentParticipantDto;
}
/** 0 = Doctor 1 = Patient */
export enum ParticipantType {
    Doctor = 0,
    Patient = 1,
}
export interface CreateVisitDto  {
  title: string;
  note: string;
  start: Date | null;
  end: Date | null;
  resourceIds?: number[] | null;
  tags?: number[] | null;
  acceptConflict: boolean | null;
  inWaitingList?: boolean;
  priority?: WaitingListPriority | null;
  statusId?: AppointmentStatusCodes | null;
  values?: any | null;
  typeId: number;
  caseId: number;
  number?: string | null;
  attendingDoctorId?: number | null;
  importId?: string | null;
}
export function deserializeCreateVisitDto(json: string): CreateVisitDto {
  const data = JSON.parse(json) as CreateVisitDto;
  initCreateVisitDto(data);
  return data;
}
export function initCreateVisitDto(_data: CreateVisitDto) {
  if (_data) {
    _data.start = _data["start"] ? new Date(_data["start"].toString()) : <any>null;
    _data.end = _data["end"] ? new Date(_data["end"].toString()) : <any>null;
    _data.resourceIds = _data["resourceIds"];
    _data.tags = _data["tags"];
    _data.priority = _data["priority"];
    _data.statusId = _data["statusId"];
    _data.values = _data["values"];
  }
  return _data;
}
export function serializeCreateVisitDto(_data: CreateVisitDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateVisitDto(_data as CreateVisitDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateVisitDto(_data: CreateVisitDto): CreateVisitDto {
  const data: Record<string, any> = { ..._data };
  data["start"] = _data.start && _data.start.toISOString();
  data["end"] = _data.end && _data.end.toISOString();
  return data as CreateVisitDto;
}
export interface AppointmentEventDto  {
  id: number;
  isDeleted: boolean;
  title: string;
  note: string;
  start: Date;
  end: Date;
  statusId: AppointmentStatusCodes;
  participants: AppointmentParticipantDto[];
  resourceIds: number[];
  tags: number[];
  appointmentType: AppointmentType;
  inWaitingList: boolean;
  priority: WaitingListPriority | null;
  importId: string | null;
  /** Returns values for Queries passed in Queries */
  calculatedQueries?: { [key: string]: { [key: string]: any; }; } | null;
  discriminator: string;
}
export function deserializeAppointmentEventDto(json: string): AppointmentEventDto {
  const data = JSON.parse(json) as AppointmentEventDto;
  if (data["discriminator"] === "VisitListDto") {
    return initVisitListDto(data as VisitListDto);
  }
  if (data["discriminator"] === "MeetingListDto") {
    return initMeetingListDto(data as MeetingListDto);
  }
  if (data["discriminator"] === "AbsenceListDto") {
    return initAbsenceListDto(data as AbsenceListDto);
  }
  initAppointmentEventDto(data);
  return data;
}
export function initAppointmentEventDto(_data: AppointmentEventDto) {
  if (_data) {
    _data.start = _data["start"] ? new Date(_data["start"].toString()) : <any>null;
    _data.end = _data["end"] ? new Date(_data["end"].toString()) : <any>null;
    _data.statusId = _data["statusId"];
    if (Array.isArray(_data["participants"])) {
      _data.participants = _data["participants"].map(item => 
        initAppointmentParticipantDto(item)
      );
    }
    _data.resourceIds = _data["resourceIds"];
    _data.tags = _data["tags"];
    _data.appointmentType = _data["appointmentType"];
    _data.priority = _data["priority"];
  }
  return _data;
}
export function serializeAppointmentEventDto(_data: AppointmentEventDto | undefined) {
  if (_data) {
    _data = prepareSerializeAppointmentEventDto(_data as AppointmentEventDto);
      _data["discriminator"] = "AppointmentEventDto";
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAppointmentEventDto(_data: AppointmentEventDto): AppointmentEventDto {
  const data: Record<string, any> = { ..._data };
  data["start"] = _data.start && _data.start.toISOString();
  data["end"] = _data.end && _data.end.toISOString();
  if (Array.isArray(_data.participants)) {
    data["participants"] = _data.participants.map(item => 
        prepareSerializeAppointmentParticipantDto(item)
    );
  }
  return data as AppointmentEventDto;
}
export interface VisitListDto extends AppointmentEventDto  {
  typeId: number | null;
  patientId: number;
  patientName: string;
  isPrivateInsurance: boolean;
  isSelfPayer: boolean;
  caseId: number;
  subtenantId: number;
  priorityContact: string;
  number: string;
  numberSource: NumberSource;
  contacts: string[];
  /** Values are only included if IncludeValues is set in request DTO */
  values?: any | null;
  lastPatientNotificationDateTime: Date | null;
}
export function deserializeVisitListDto(json: string): VisitListDto {
  const data = JSON.parse(json) as VisitListDto;
  initVisitListDto(data);
  return data;
}
export function initVisitListDto(_data: VisitListDto) {
  initAppointmentEventDto(_data);
  if (_data) {
    _data.numberSource = _data["numberSource"];
    _data.contacts = _data["contacts"];
    _data.values = _data["values"];
    _data.lastPatientNotificationDateTime = _data["lastPatientNotificationDateTime"] ? new Date(_data["lastPatientNotificationDateTime"].toString()) : <any>null;
  }
  return _data;
}
export function serializeVisitListDto(_data: VisitListDto | undefined) {
  if (_data) {
    _data = prepareSerializeVisitListDto(_data as VisitListDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeVisitListDto(_data: VisitListDto): VisitListDto {
  const data = prepareSerializeAppointmentEventDto(_data as VisitListDto) as Record<string, any>;
  data["lastPatientNotificationDateTime"] = _data.lastPatientNotificationDateTime && _data.lastPatientNotificationDateTime.toISOString();
  return data as VisitListDto;
}
export interface MeetingListDto extends AppointmentEventDto  {
}
export function deserializeMeetingListDto(json: string): MeetingListDto {
  const data = JSON.parse(json) as MeetingListDto;
  initMeetingListDto(data);
  return data;
}
export function initMeetingListDto(_data: MeetingListDto) {
  initAppointmentEventDto(_data);
  return _data;
}
export function serializeMeetingListDto(_data: MeetingListDto | undefined) {
  if (_data) {
    _data = prepareSerializeMeetingListDto(_data as MeetingListDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeMeetingListDto(_data: MeetingListDto): MeetingListDto {
  const data = prepareSerializeAppointmentEventDto(_data as MeetingListDto) as Record<string, any>;
  return data as MeetingListDto;
}
export interface AbsenceListDto extends AppointmentEventDto  {
  absenceType: AbsenceType;
  absenceReasonId: number | null;
}
export function deserializeAbsenceListDto(json: string): AbsenceListDto {
  const data = JSON.parse(json) as AbsenceListDto;
  initAbsenceListDto(data);
  return data;
}
export function initAbsenceListDto(_data: AbsenceListDto) {
  initAppointmentEventDto(_data);
  if (_data) {
    _data.absenceType = _data["absenceType"];
  }
  return _data;
}
export function serializeAbsenceListDto(_data: AbsenceListDto | undefined) {
  if (_data) {
    _data = prepareSerializeAbsenceListDto(_data as AbsenceListDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAbsenceListDto(_data: AbsenceListDto): AbsenceListDto {
  const data = prepareSerializeAppointmentEventDto(_data as AbsenceListDto) as Record<string, any>;
  return data as AbsenceListDto;
}
/** 1 = ResourceUnavailability 2 = Holiday */
export enum AbsenceType {
    ResourceUnavailability = 1,
    Holiday = 2,
}
export interface JsQuery  {
  queryType: MergeFieldQueryType;
  dataBlockTypeName?: string | null;
  filter?: string | null;
  limit?: string | null;
  expressionFunctionName?: string | null;
  expressionFunctionArgument?: string | null;
  /** comma separated list of fields */
  fields: string;
  fieldList?: string[];
}
export function deserializeJsQuery(json: string): JsQuery {
  const data = JSON.parse(json) as JsQuery;
  initJsQuery(data);
  return data;
}
export function initJsQuery(_data: JsQuery) {
  if (_data) {
    _data.queryType = _data["queryType"];
    _data.fieldList = _data["fieldList"];
  }
  return _data;
}
export function serializeJsQuery(_data: JsQuery | undefined) {
  if (_data) {
    _data = prepareSerializeJsQuery(_data as JsQuery);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeJsQuery(_data: JsQuery): JsQuery {
  const data: Record<string, any> = { ..._data };
  return data as JsQuery;
}
/** 0 = Asc 1 = Desc */
export enum SortOrder {
    Asc = 0,
    Desc = 1,
}
/** Anonymized visit data about occupied resources */
export interface AppointmentResourceOccupationDto  {
  id: number;
  start: Date;
  end: Date;
  subtenantId: number | null;
  patientId: number | null;
  absenceType: AbsenceType | null;
  title: string | null;
  resourceIds?: number[];
}
export function deserializeAppointmentResourceOccupationDto(json: string): AppointmentResourceOccupationDto {
  const data = JSON.parse(json) as AppointmentResourceOccupationDto;
  initAppointmentResourceOccupationDto(data);
  return data;
}
export function initAppointmentResourceOccupationDto(_data: AppointmentResourceOccupationDto) {
  if (_data) {
    _data.start = _data["start"] ? new Date(_data["start"].toString()) : <any>null;
    _data.end = _data["end"] ? new Date(_data["end"].toString()) : <any>null;
    _data.absenceType = _data["absenceType"];
    _data.resourceIds = _data["resourceIds"];
  }
  return _data;
}
export function serializeAppointmentResourceOccupationDto(_data: AppointmentResourceOccupationDto | undefined) {
  if (_data) {
    _data = prepareSerializeAppointmentResourceOccupationDto(_data as AppointmentResourceOccupationDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAppointmentResourceOccupationDto(_data: AppointmentResourceOccupationDto): AppointmentResourceOccupationDto {
  const data: Record<string, any> = { ..._data };
  data["start"] = _data.start && _data.start.toISOString();
  data["end"] = _data.end && _data.end.toISOString();
  return data as AppointmentResourceOccupationDto;
}
export interface MeetingDto  {
  id: number;
  isDeleted: boolean;
  title: string;
  note: string;
  start: Date;
  end: Date;
  statusId: AppointmentStatusCodes;
  participants: AppointmentParticipantDto[];
  resourceIds: number[];
  alertAt: Date | null;
}
export function deserializeMeetingDto(json: string): MeetingDto {
  const data = JSON.parse(json) as MeetingDto;
  initMeetingDto(data);
  return data;
}
export function initMeetingDto(_data: MeetingDto) {
  if (_data) {
    _data.start = _data["start"] ? new Date(_data["start"].toString()) : <any>null;
    _data.end = _data["end"] ? new Date(_data["end"].toString()) : <any>null;
    _data.statusId = _data["statusId"];
    if (Array.isArray(_data["participants"])) {
      _data.participants = _data["participants"].map(item => 
        initAppointmentParticipantDto(item)
      );
    }
    _data.resourceIds = _data["resourceIds"];
    _data.alertAt = _data["alertAt"] ? new Date(_data["alertAt"].toString()) : <any>null;
  }
  return _data;
}
export function serializeMeetingDto(_data: MeetingDto | undefined) {
  if (_data) {
    _data = prepareSerializeMeetingDto(_data as MeetingDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeMeetingDto(_data: MeetingDto): MeetingDto {
  const data: Record<string, any> = { ..._data };
  data["start"] = _data.start && _data.start.toISOString();
  data["end"] = _data.end && _data.end.toISOString();
  if (Array.isArray(_data.participants)) {
    data["participants"] = _data.participants.map(item => 
        prepareSerializeAppointmentParticipantDto(item)
    );
  }
  data["alertAt"] = _data.alertAt && _data.alertAt.toISOString();
  return data as MeetingDto;
}
export interface CreateMeetingDto  {
  title: string;
  note: string;
  start: Date | null;
  end: Date | null;
  resourceIds?: number[] | null;
  tags?: number[] | null;
  acceptConflict: boolean | null;
  inWaitingList?: boolean;
  priority?: WaitingListPriority | null;
  statusId?: AppointmentStatusCodes | null;
  values?: any | null;
  participants: AppointmentParticipantDto[];
  alertAt?: Date | null;
}
export function deserializeCreateMeetingDto(json: string): CreateMeetingDto {
  const data = JSON.parse(json) as CreateMeetingDto;
  initCreateMeetingDto(data);
  return data;
}
export function initCreateMeetingDto(_data: CreateMeetingDto) {
  if (_data) {
    _data.start = _data["start"] ? new Date(_data["start"].toString()) : <any>null;
    _data.end = _data["end"] ? new Date(_data["end"].toString()) : <any>null;
    _data.resourceIds = _data["resourceIds"];
    _data.tags = _data["tags"];
    _data.priority = _data["priority"];
    _data.statusId = _data["statusId"];
    _data.values = _data["values"];
    if (Array.isArray(_data["participants"])) {
      _data.participants = _data["participants"].map(item => 
        initAppointmentParticipantDto(item)
      );
    }
    _data.alertAt = _data["alertAt"] ? new Date(_data["alertAt"].toString()) : <any>null;
  }
  return _data;
}
export function serializeCreateMeetingDto(_data: CreateMeetingDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateMeetingDto(_data as CreateMeetingDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateMeetingDto(_data: CreateMeetingDto): CreateMeetingDto {
  const data: Record<string, any> = { ..._data };
  data["start"] = _data.start && _data.start.toISOString();
  data["end"] = _data.end && _data.end.toISOString();
  if (Array.isArray(_data.participants)) {
    data["participants"] = _data.participants.map(item => 
        prepareSerializeAppointmentParticipantDto(item)
    );
  }
  data["alertAt"] = _data.alertAt && _data.alertAt.toISOString();
  return data as CreateMeetingDto;
}
export interface FindFreeTimeSlotResultDto  {
  start: Date;
  end: Date;
}
export function deserializeFindFreeTimeSlotResultDto(json: string): FindFreeTimeSlotResultDto {
  const data = JSON.parse(json) as FindFreeTimeSlotResultDto;
  initFindFreeTimeSlotResultDto(data);
  return data;
}
export function initFindFreeTimeSlotResultDto(_data: FindFreeTimeSlotResultDto) {
  if (_data) {
    _data.start = _data["start"] ? new Date(_data["start"].toString()) : <any>null;
    _data.end = _data["end"] ? new Date(_data["end"].toString()) : <any>null;
  }
  return _data;
}
export function serializeFindFreeTimeSlotResultDto(_data: FindFreeTimeSlotResultDto | undefined) {
  if (_data) {
    _data = prepareSerializeFindFreeTimeSlotResultDto(_data as FindFreeTimeSlotResultDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeFindFreeTimeSlotResultDto(_data: FindFreeTimeSlotResultDto): FindFreeTimeSlotResultDto {
  const data: Record<string, any> = { ..._data };
  data["start"] = _data.start && _data.start.toISOString();
  data["end"] = _data.end && _data.end.toISOString();
  return data as FindFreeTimeSlotResultDto;
}
/** 0 = Forward 1 = Backward */
export enum SearchDirection {
    Forward = 0,
    Backward = 1,
}
export interface AbsenceDto  {
  id: number;
  title: string;
  absenceReasonId: number | null;
  type: AbsenceType;
  start: Date;
  end: Date;
  resourceIds?: number[];
  isDeleted: boolean;
  customFields?: any;
}
export function deserializeAbsenceDto(json: string): AbsenceDto {
  const data = JSON.parse(json) as AbsenceDto;
  initAbsenceDto(data);
  return data;
}
export function initAbsenceDto(_data: AbsenceDto) {
  if (_data) {
    _data.type = _data["type"];
    _data.start = _data["start"] ? new Date(_data["start"].toString()) : <any>null;
    _data.end = _data["end"] ? new Date(_data["end"].toString()) : <any>null;
    _data.resourceIds = _data["resourceIds"];
    _data.customFields = _data["customFields"];
  }
  return _data;
}
export function serializeAbsenceDto(_data: AbsenceDto | undefined) {
  if (_data) {
    _data = prepareSerializeAbsenceDto(_data as AbsenceDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAbsenceDto(_data: AbsenceDto): AbsenceDto {
  const data: Record<string, any> = { ..._data };
  data["start"] = _data.start && _data.start.toISOString();
  data["end"] = _data.end && _data.end.toISOString();
  return data as AbsenceDto;
}
export interface CreateAbsenceDto  {
  title: string;
  note: string;
  start: Date | null;
  end: Date | null;
  resourceIds?: number[] | null;
  tags?: number[] | null;
  acceptConflict: boolean | null;
  inWaitingList?: boolean;
  priority?: WaitingListPriority | null;
  statusId?: AppointmentStatusCodes | null;
  values?: any | null;
  absenceType: AbsenceType;
  absenceReasonId?: number | null;
}
export function deserializeCreateAbsenceDto(json: string): CreateAbsenceDto {
  const data = JSON.parse(json) as CreateAbsenceDto;
  initCreateAbsenceDto(data);
  return data;
}
export function initCreateAbsenceDto(_data: CreateAbsenceDto) {
  if (_data) {
    _data.start = _data["start"] ? new Date(_data["start"].toString()) : <any>null;
    _data.end = _data["end"] ? new Date(_data["end"].toString()) : <any>null;
    _data.resourceIds = _data["resourceIds"];
    _data.tags = _data["tags"];
    _data.priority = _data["priority"];
    _data.statusId = _data["statusId"];
    _data.values = _data["values"];
    _data.absenceType = _data["absenceType"];
  }
  return _data;
}
export function serializeCreateAbsenceDto(_data: CreateAbsenceDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateAbsenceDto(_data as CreateAbsenceDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateAbsenceDto(_data: CreateAbsenceDto): CreateAbsenceDto {
  const data: Record<string, any> = { ..._data };
  data["start"] = _data.start && _data.start.toISOString();
  data["end"] = _data.end && _data.end.toISOString();
  return data as CreateAbsenceDto;
}
export interface PatchAbsenceDto  {
  title?: string | null;
  note?: string | null;
  absenceReasonId?: number | null;
  absenceType?: AbsenceType | null;
  start?: Date | null;
  end?: Date | null;
  resourceIds?: number[] | null;
  acceptConflict?: boolean | null;
  values?: any | null;
}
export function deserializePatchAbsenceDto(json: string): PatchAbsenceDto {
  const data = JSON.parse(json) as PatchAbsenceDto;
  initPatchAbsenceDto(data);
  return data;
}
export function initPatchAbsenceDto(_data: PatchAbsenceDto) {
  if (_data) {
    _data.absenceType = _data["absenceType"];
    _data.start = _data["start"] ? new Date(_data["start"].toString()) : <any>null;
    _data.end = _data["end"] ? new Date(_data["end"].toString()) : <any>null;
    _data.resourceIds = _data["resourceIds"];
    _data.values = _data["values"];
  }
  return _data;
}
export function serializePatchAbsenceDto(_data: PatchAbsenceDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchAbsenceDto(_data as PatchAbsenceDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchAbsenceDto(_data: PatchAbsenceDto): PatchAbsenceDto {
  const data: Record<string, any> = { ..._data };
  data["start"] = _data.start && _data.start.toISOString();
  data["end"] = _data.end && _data.end.toISOString();
  return data as PatchAbsenceDto;
}
export interface VisitCardSettingsDto  {
  weekLineStyles: VisitCardLineStyleDto[];
  dayLineStyles: VisitCardLineStyleDto[];
  monthLineStyles: VisitCardLineStyleDto[];
}
export function deserializeVisitCardSettingsDto(json: string): VisitCardSettingsDto {
  const data = JSON.parse(json) as VisitCardSettingsDto;
  initVisitCardSettingsDto(data);
  return data;
}
export function initVisitCardSettingsDto(_data: VisitCardSettingsDto) {
  if (_data) {
    if (Array.isArray(_data["weekLineStyles"])) {
      _data.weekLineStyles = _data["weekLineStyles"].map(item => 
        initVisitCardLineStyleDto(item)
      );
    }
    if (Array.isArray(_data["dayLineStyles"])) {
      _data.dayLineStyles = _data["dayLineStyles"].map(item => 
        initVisitCardLineStyleDto(item)
      );
    }
    if (Array.isArray(_data["monthLineStyles"])) {
      _data.monthLineStyles = _data["monthLineStyles"].map(item => 
        initVisitCardLineStyleDto(item)
      );
    }
  }
  return _data;
}
export function serializeVisitCardSettingsDto(_data: VisitCardSettingsDto | undefined) {
  if (_data) {
    _data = prepareSerializeVisitCardSettingsDto(_data as VisitCardSettingsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeVisitCardSettingsDto(_data: VisitCardSettingsDto): VisitCardSettingsDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.weekLineStyles)) {
    data["weekLineStyles"] = _data.weekLineStyles.map(item => 
        prepareSerializeVisitCardLineStyleDto(item)
    );
  }
  if (Array.isArray(_data.dayLineStyles)) {
    data["dayLineStyles"] = _data.dayLineStyles.map(item => 
        prepareSerializeVisitCardLineStyleDto(item)
    );
  }
  if (Array.isArray(_data.monthLineStyles)) {
    data["monthLineStyles"] = _data.monthLineStyles.map(item => 
        prepareSerializeVisitCardLineStyleDto(item)
    );
  }
  return data as VisitCardSettingsDto;
}
export interface VisitCardLineStyleDto  {
  position: number;
  expression: string;
  fontSize: number;
  paddingTop: number;
  isBold: boolean;
}
export function deserializeVisitCardLineStyleDto(json: string): VisitCardLineStyleDto {
  const data = JSON.parse(json) as VisitCardLineStyleDto;
  initVisitCardLineStyleDto(data);
  return data;
}
export function initVisitCardLineStyleDto(_data: VisitCardLineStyleDto) {
    return _data;
}
export function serializeVisitCardLineStyleDto(_data: VisitCardLineStyleDto | undefined) {
  if (_data) {
    _data = prepareSerializeVisitCardLineStyleDto(_data as VisitCardLineStyleDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeVisitCardLineStyleDto(_data: VisitCardLineStyleDto): VisitCardLineStyleDto {
  const data: Record<string, any> = { ..._data };
  return data as VisitCardLineStyleDto;
}
export interface VisitCardSettingsPatchDto  {
  weekLineStyles?: VisitCardLineStyle[];
  monthLineStyles?: VisitCardLineStyle[];
  dayLineStyles?: VisitCardLineStyle[];
}
export function deserializeVisitCardSettingsPatchDto(json: string): VisitCardSettingsPatchDto {
  const data = JSON.parse(json) as VisitCardSettingsPatchDto;
  initVisitCardSettingsPatchDto(data);
  return data;
}
export function initVisitCardSettingsPatchDto(_data: VisitCardSettingsPatchDto) {
  if (_data) {
    if (Array.isArray(_data["weekLineStyles"])) {
      _data.weekLineStyles = _data["weekLineStyles"].map(item => 
        initVisitCardLineStyle(item)
      );
    }
    if (Array.isArray(_data["monthLineStyles"])) {
      _data.monthLineStyles = _data["monthLineStyles"].map(item => 
        initVisitCardLineStyle(item)
      );
    }
    if (Array.isArray(_data["dayLineStyles"])) {
      _data.dayLineStyles = _data["dayLineStyles"].map(item => 
        initVisitCardLineStyle(item)
      );
    }
  }
  return _data;
}
export function serializeVisitCardSettingsPatchDto(_data: VisitCardSettingsPatchDto | undefined) {
  if (_data) {
    _data = prepareSerializeVisitCardSettingsPatchDto(_data as VisitCardSettingsPatchDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeVisitCardSettingsPatchDto(_data: VisitCardSettingsPatchDto): VisitCardSettingsPatchDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.weekLineStyles)) {
    data["weekLineStyles"] = _data.weekLineStyles.map(item => 
        prepareSerializeVisitCardLineStyle(item)
    );
  }
  if (Array.isArray(_data.monthLineStyles)) {
    data["monthLineStyles"] = _data.monthLineStyles.map(item => 
        prepareSerializeVisitCardLineStyle(item)
    );
  }
  if (Array.isArray(_data.dayLineStyles)) {
    data["dayLineStyles"] = _data.dayLineStyles.map(item => 
        prepareSerializeVisitCardLineStyle(item)
    );
  }
  return data as VisitCardSettingsPatchDto;
}
export interface VisitCardLineStyle  {
  position: number;
  expression: string;
  fontSize: number;
  paddingTop: number;
  isBold: boolean;
}
export function deserializeVisitCardLineStyle(json: string): VisitCardLineStyle {
  const data = JSON.parse(json) as VisitCardLineStyle;
  initVisitCardLineStyle(data);
  return data;
}
export function initVisitCardLineStyle(_data: VisitCardLineStyle) {
    return _data;
}
export function serializeVisitCardLineStyle(_data: VisitCardLineStyle | undefined) {
  if (_data) {
    _data = prepareSerializeVisitCardLineStyle(_data as VisitCardLineStyle);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeVisitCardLineStyle(_data: VisitCardLineStyle): VisitCardLineStyle {
  const data: Record<string, any> = { ..._data };
  return data as VisitCardLineStyle;
}
export interface AppointmentColorSettingsDto  {
  rules: AppointmentColorSettingsRuleDto[];
}
export function deserializeAppointmentColorSettingsDto(json: string): AppointmentColorSettingsDto {
  const data = JSON.parse(json) as AppointmentColorSettingsDto;
  initAppointmentColorSettingsDto(data);
  return data;
}
export function initAppointmentColorSettingsDto(_data: AppointmentColorSettingsDto) {
  if (_data) {
    if (Array.isArray(_data["rules"])) {
      _data.rules = _data["rules"].map(item => 
        initAppointmentColorSettingsRuleDto(item)
      );
    }
  }
  return _data;
}
export function serializeAppointmentColorSettingsDto(_data: AppointmentColorSettingsDto | undefined) {
  if (_data) {
    _data = prepareSerializeAppointmentColorSettingsDto(_data as AppointmentColorSettingsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAppointmentColorSettingsDto(_data: AppointmentColorSettingsDto): AppointmentColorSettingsDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.rules)) {
    data["rules"] = _data.rules.map(item => 
        prepareSerializeAppointmentColorSettingsRuleDto(item)
    );
  }
  return data as AppointmentColorSettingsDto;
}
export interface AppointmentColorSettingsRuleDto  {
  /** JSON-serialized filter */
  filterExpression?: string | null;
  color: string;
  position: number;
  isDefault: boolean;
}
export function deserializeAppointmentColorSettingsRuleDto(json: string): AppointmentColorSettingsRuleDto {
  const data = JSON.parse(json) as AppointmentColorSettingsRuleDto;
  initAppointmentColorSettingsRuleDto(data);
  return data;
}
export function initAppointmentColorSettingsRuleDto(_data: AppointmentColorSettingsRuleDto) {
    return _data;
}
export function serializeAppointmentColorSettingsRuleDto(_data: AppointmentColorSettingsRuleDto | undefined) {
  if (_data) {
    _data = prepareSerializeAppointmentColorSettingsRuleDto(_data as AppointmentColorSettingsRuleDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAppointmentColorSettingsRuleDto(_data: AppointmentColorSettingsRuleDto): AppointmentColorSettingsRuleDto {
  const data: Record<string, any> = { ..._data };
  return data as AppointmentColorSettingsRuleDto;
}
export interface AppointmentColorSettingsPatchDto  {
  rules?: AppointmentColorSettingsRule[];
}
export function deserializeAppointmentColorSettingsPatchDto(json: string): AppointmentColorSettingsPatchDto {
  const data = JSON.parse(json) as AppointmentColorSettingsPatchDto;
  initAppointmentColorSettingsPatchDto(data);
  return data;
}
export function initAppointmentColorSettingsPatchDto(_data: AppointmentColorSettingsPatchDto) {
  if (_data) {
    if (Array.isArray(_data["rules"])) {
      _data.rules = _data["rules"].map(item => 
        initAppointmentColorSettingsRule(item)
      );
    }
  }
  return _data;
}
export function serializeAppointmentColorSettingsPatchDto(_data: AppointmentColorSettingsPatchDto | undefined) {
  if (_data) {
    _data = prepareSerializeAppointmentColorSettingsPatchDto(_data as AppointmentColorSettingsPatchDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAppointmentColorSettingsPatchDto(_data: AppointmentColorSettingsPatchDto): AppointmentColorSettingsPatchDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.rules)) {
    data["rules"] = _data.rules.map(item => 
        prepareSerializeAppointmentColorSettingsRule(item)
    );
  }
  return data as AppointmentColorSettingsPatchDto;
}
export interface AppointmentColorSettingsRule  {
  /** JSON-serialized filter */
  filterExpression?: string | null;
  color: string;
  position: number;
  isDefault: boolean;
}
export function deserializeAppointmentColorSettingsRule(json: string): AppointmentColorSettingsRule {
  const data = JSON.parse(json) as AppointmentColorSettingsRule;
  initAppointmentColorSettingsRule(data);
  return data;
}
export function initAppointmentColorSettingsRule(_data: AppointmentColorSettingsRule) {
    return _data;
}
export function serializeAppointmentColorSettingsRule(_data: AppointmentColorSettingsRule | undefined) {
  if (_data) {
    _data = prepareSerializeAppointmentColorSettingsRule(_data as AppointmentColorSettingsRule);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAppointmentColorSettingsRule(_data: AppointmentColorSettingsRule): AppointmentColorSettingsRule {
  const data: Record<string, any> = { ..._data };
  return data as AppointmentColorSettingsRule;
}
export interface DateTimeSerializationDto  {
  timezoneIndependentDate: Date;
  timezoneDependentDate: Date;
}
export function deserializeDateTimeSerializationDto(json: string): DateTimeSerializationDto {
  const data = JSON.parse(json) as DateTimeSerializationDto;
  initDateTimeSerializationDto(data);
  return data;
}
export function initDateTimeSerializationDto(_data: DateTimeSerializationDto) {
  if (_data) {
    _data.timezoneIndependentDate = _data["timezoneIndependentDate"] ? parseDateOnly(_data["timezoneIndependentDate"].toString()) : <any>null;
    _data.timezoneDependentDate = _data["timezoneDependentDate"] ? new Date(_data["timezoneDependentDate"].toString()) : <any>null;
  }
  return _data;
}
export function serializeDateTimeSerializationDto(_data: DateTimeSerializationDto | undefined) {
  if (_data) {
    _data = prepareSerializeDateTimeSerializationDto(_data as DateTimeSerializationDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDateTimeSerializationDto(_data: DateTimeSerializationDto): DateTimeSerializationDto {
  const data: Record<string, any> = { ..._data };
  data["timezoneIndependentDate"] = _data.timezoneIndependentDate && formatDate(_data.timezoneIndependentDate);
  data["timezoneDependentDate"] = _data.timezoneDependentDate && _data.timezoneDependentDate.toISOString();
  return data as DateTimeSerializationDto;
}
export interface NotificationDto  {
  type: NotificationType;
  patientId: number | null;
  userId: string | null;
  values?: any;
}
export function deserializeNotificationDto(json: string): NotificationDto {
  const data = JSON.parse(json) as NotificationDto;
  initNotificationDto(data);
  return data;
}
export function initNotificationDto(_data: NotificationDto) {
  if (_data) {
    _data.type = _data["type"];
    _data.values = _data["values"];
  }
  return _data;
}
export function serializeNotificationDto(_data: NotificationDto | undefined) {
  if (_data) {
    _data = prepareSerializeNotificationDto(_data as NotificationDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeNotificationDto(_data: NotificationDto): NotificationDto {
  const data: Record<string, any> = { ..._data };
  return data as NotificationDto;
}
/** 0 = Undefined 1 = PatientDataReceived 2 = HL7MessageWasAutoCreated 3 = GDTMessageWasAutoCreated */
export enum NotificationType {
    Undefined = 0,
    PatientDataReceived = 1,
    HL7MessageWasAutoCreated = 2,
    GDTMessageWasAutoCreated = 3,
}
export function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}
export function parseDateOnly(s: string) {
    const date = new Date(s);
    return new Date(date.getTime() + 
        date.getTimezoneOffset() * 60000);
}
import type { AxiosError } from 'axios'
export interface FileParameter {
    data: any;
    fileName: string;
}
export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}
export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;
    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    protected isApiException = true;
    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}
export function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
export function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}
//-----/Types.File-----